export const namedOperations = {
  Query: {
    MLBComposeBenchQuery: 'MLBComposeBenchQuery' as const,
    MLBPostBuyBenchObjectsQuery: 'MLBPostBuyBenchObjectsQuery' as const,
    MLBComposeBuyQuery: 'MLBComposeBuyQuery' as const,
    LazyUpcomingGameViewQuery: 'LazyUpcomingGameViewQuery' as const,
    BaseballGameViewDialogQuery: 'BaseballGameViewDialogQuery' as const,
    BaseballSo5LeaderboardContenderDialogQuery: 'BaseballSo5LeaderboardContenderDialogQuery' as const,
    MLBPlayEventTyoeFixtureMatchCenterQuery: 'MLBPlayEventTyoeFixtureMatchCenterQuery' as const,
    MLBComposeLeaderboardLineupPageQuery: 'MLBComposeLeaderboardLineupPageQuery' as const,
    MLBComposeLeaderboardManagerTeamPageQuery: 'MLBComposeLeaderboardManagerTeamPageQuery' as const,
    MLBComposeLeaderboardPageQuery: 'MLBComposeLeaderboardPageQuery' as const,
    MLBLineupSharingQuery: 'MLBLineupSharingQuery' as const,
    BaseballSo5LineupQuery: 'BaseballSo5LineupQuery' as const,
    MLBScoutingCenterGameIdBoxScorePageQuery: 'MLBScoutingCenterGameIdBoxScorePageQuery' as const,
    MLBScoutingCenterGameIdPlayersPageQuery: 'MLBScoutingCenterGameIdPlayersPageQuery' as const,
    BaseballTeamCardsQuery: 'BaseballTeamCardsQuery' as const,
    BaseballSeoTeamQuery: 'BaseballSeoTeamQuery' as const,
    BaseballTeamOverviewQuery: 'BaseballTeamOverviewQuery' as const,
    CardFactoryQuery: 'CardFactoryQuery' as const,
    GetPlayerInfo: 'GetPlayerInfo' as const,
    OAuthApplicationQuery: 'OAuthApplicationQuery' as const,
    LandingPromoBannerQuery: 'LandingPromoBannerQuery' as const,
    LowestSalesPerPlayerQuery: 'LowestSalesPerPlayerQuery' as const,
    DropCardsWarningQuery: 'DropCardsWarningQuery' as const,
    AuthorizationStatusQuery: 'AuthorizationStatusQuery' as const,
    CurrentUserFiatAccountsQuery: 'CurrentUserFiatAccountsQuery' as const,
    GetCurrentUserScaStatusQuery: 'GetCurrentUserScaStatusQuery' as const,
    GetSupportedCountriesQuery: 'GetSupportedCountriesQuery' as const,
    CheckManagernameAvailability: 'CheckManagernameAvailability' as const,
    JonumComposeBlockedDialogQuery: 'JonumComposeBlockedDialogQuery' as const,
    JonumLimitsQuery: 'JonumLimitsQuery' as const,
    KYCDocumentRequirementsQuery: 'KYCDocumentRequirementsQuery' as const,
    AnySportPastLineupWinnerQuery: 'AnySportPastLineupWinnerQuery' as const,
    FullReferrerQuery: 'FullReferrerQuery' as const,
    EnterCodeInlineQuery: 'EnterCodeInlineQuery' as const,
    SignupLeaguesQuery: 'SignupLeaguesQuery' as const,
    SignupPromoBannerQuery: 'SignupPromoBannerQuery' as const,
    InviteCodeStatusQuery: 'InviteCodeStatusQuery' as const,
    MyClubNavItemQuery: 'MyClubNavItemQuery' as const,
    SetManagerNavItemQuery: 'SetManagerNavItemQuery' as const,
    OffRampAddressDefaultsQuery: 'OffRampAddressDefaultsQuery' as const,
    OffRampOnboardingStateQuery: 'OffRampOnboardingStateQuery' as const,
    AcceptCashOffersQuery: 'AcceptCashOffersQuery' as const,
    ActivityReportQuery: 'ActivityReportQuery' as const,
    ApiKeysManagementQuery: 'ApiKeysManagementQuery' as const,
    BlockedUsersQuery: 'BlockedUsersQuery' as const,
    DevicesQuery: 'DevicesQuery' as const,
    ManagePasskeysQuery: 'ManagePasskeysQuery' as const,
    NotificationPreferencesQuery: 'NotificationPreferencesQuery' as const,
    OAuthApplicationsManagementQuery: 'OAuthApplicationsManagementQuery' as const,
    ConnectedOAuthAccessTokensQuery: 'ConnectedOAuthAccessTokensQuery' as const,
    CurrentUserPaymentMethodsQuery: 'CurrentUserPaymentMethodsQuery' as const,
    DeliverableCountriesQuery: 'DeliverableCountriesQuery' as const,
    PrivacyQuery: 'PrivacyQuery' as const,
    RefreshActivePromotionalEventCompletion: 'RefreshActivePromotionalEventCompletion' as const,
    CryptoWithdrawalsQuery: 'CryptoWithdrawalsQuery' as const,
    WalletRecentActivityQuery: 'WalletRecentActivityQuery' as const,
    BankAccountCountryInfosQuery: 'BankAccountCountryInfosQuery' as const,
    WithdrawalBankAccountsQuery: 'WithdrawalBankAccountsQuery' as const,
    Eip7702RevocationsQuery: 'Eip7702RevocationsQuery' as const,
    StarkwareEscapeHatchQuery: 'StarkwareEscapeHatchQuery' as const,
    ConfigQuery: 'ConfigQuery' as const,
    PingConfigQuery: 'PingConfigQuery' as const,
    ExchangeRateQuery: 'ExchangeRateQuery' as const,
    GetCurrentUserConsentQuery: 'GetCurrentUserConsentQuery' as const,
    FootballCardsInLineupQuery: 'FootballCardsInLineupQuery' as const,
    FilterWatchlistQuery: 'FilterWatchlistQuery' as const,
    RestoreWalletQuery: 'RestoreWalletQuery' as const,
    NextFixturesProbablePitchersSlugs: 'NextFixturesProbablePitchersSlugs' as const,
    NoCardEntryConfigQuery: 'NoCardEntryConfigQuery' as const,
    NoCardRoute: 'NoCardRoute' as const,
    PaymentProvider_currentUserQuery: 'PaymentProvider_currentUserQuery' as const,
    DeckQuery: 'DeckQuery' as const,
    DecksQuery: 'DecksQuery' as const,
    MatchdayPicksTabQuery: 'MatchdayPicksTabQuery' as const,
    PrivateKeyRecoveryPayloadsQuery: 'PrivateKeyRecoveryPayloadsQuery' as const,
    FavoriteQuery: 'FavoriteQuery' as const,
    RefreshSportConversionCreditsQuery: 'RefreshSportConversionCreditsQuery' as const,
    CurrentUserAcceptedCurrenciesQuery: 'CurrentUserAcceptedCurrenciesQuery' as const,
    TransactionStatusQuery: 'TransactionStatusQuery' as const,
    CampaignConversionCreditQuery: 'CampaignConversionCreditQuery' as const,
    CurrentUserBalances: 'CurrentUserBalances' as const,
    WalletChallengeQuery: 'WalletChallengeQuery' as const,
    BundledAuctionQuery: 'BundledAuctionQuery' as const,
    FootballComposeBenchQuery: 'FootballComposeBenchQuery' as const,
    FootballPostBuyBenchObjectsQuery: 'FootballPostBuyBenchObjectsQuery' as const,
    FootballRecommendationsQuery: 'FootballRecommendationsQuery' as const,
    FootballAdvancedComposeBuyQuery: 'FootballAdvancedComposeBuyQuery' as const,
    FootballSo5LeaderboardContenderDialogQuery: 'FootballSo5LeaderboardContenderDialogQuery' as const,
    FootballScoutingCenter: 'FootballScoutingCenter' as const,
    MarketLeaderboardQuery: 'MarketLeaderboardQuery' as const,
    Last11Query: 'Last11Query' as const,
    NationalTeamGamesNavigatorQuery: 'NationalTeamGamesNavigatorQuery' as const,
    NationalTeamFixturesQuery: 'NationalTeamFixturesQuery' as const,
    CountryQuery: 'CountryQuery' as const,
    FootballNationalTeamOverviewQuery: 'FootballNationalTeamOverviewQuery' as const,
    NationalTeamPlayersQuery: 'NationalTeamPlayersQuery' as const,
    TopPlayersLeagueQuery: 'TopPlayersLeagueQuery' as const,
    LeagueFixturesQuery: 'LeagueFixturesQuery' as const,
    FootballSeoLeagueQuery: 'FootballSeoLeagueQuery' as const,
    FootballLeagueOverviewQuery: 'FootballLeagueOverviewQuery' as const,
    ScoutingCenterSo5LeaderboardGroupPageQuery: 'ScoutingCenterSo5LeaderboardGroupPageQuery' as const,
    FootballOnboardingComposePageQuery: 'FootballOnboardingComposePageQuery' as const,
    FootballPlayProFixtureMatchCenterQuery: 'FootballPlayProFixtureMatchCenterQuery' as const,
    FootballComposeLeaderboardLineupPageQuery: 'FootballComposeLeaderboardLineupPageQuery' as const,
    FootballComposeLeaderboardManagerTeamPageQuery: 'FootballComposeLeaderboardManagerTeamPageQuery' as const,
    FootballComposeLeaderboardPageQuery: 'FootballComposeLeaderboardPageQuery' as const,
    FootballLineupSharingQuery: 'FootballLineupSharingQuery' as const,
    LineupRedirectQuery: 'LineupRedirectQuery' as const,
    CardCollectionQuery: 'CardCollectionQuery' as const,
    FootballSo5LineupQuery: 'FootballSo5LineupQuery' as const,
    FootballScoutingCenterGameIdPlayersPageQuery: 'FootballScoutingCenterGameIdPlayersPageQuery' as const,
    FootballScoutingCenterGameIdStatsPageQuery: 'FootballScoutingCenterGameIdStatsPageQuery' as const,
    FootballSeasonStandingsQuery: 'FootballSeasonStandingsQuery' as const,
    ClubGamesNavigatorQuery: 'ClubGamesNavigatorQuery' as const,
    FootballClubOverviewQuery: 'FootballClubOverviewQuery' as const,
    FootballClubStandingsQuery: 'FootballClubStandingsQuery' as const,
    ClubFixturesQuery: 'ClubFixturesQuery' as const,
    FootballSeoClubQuery: 'FootballSeoClubQuery' as const,
    ClubSquadQuery: 'ClubSquadQuery' as const,
    AnyCardSportQuery: 'AnyCardSportQuery' as const,
    LeaderboardGroupTeamsQuery: 'LeaderboardGroupTeamsQuery' as const,
    MatchViewPlayerDetailsQuery: 'MatchViewPlayerDetailsQuery' as const,
    PlayerScoreDetailsViewQuery: 'PlayerScoreDetailsViewQuery' as const,
    MatchViewFormationsQuery: 'MatchViewFormationsQuery' as const,
    RevealedCardsSummary26Query: 'RevealedCardsSummary26Query' as const,
    GetNewsQuery: 'GetNewsQuery' as const,
    GetNotificationsNewsQuery: 'GetNotificationsNewsQuery' as const,
    GetNotificationsQuery: 'GetNotificationsQuery' as const,
    GetSpecificNewsQuery: 'GetSpecificNewsQuery' as const,
    ArenaBoardQuery: 'ArenaBoardQuery' as const,
    ArenaBoardLeaderboardQuery: 'ArenaBoardLeaderboardQuery' as const,
    ArenaBoardFixtureSelectorQuery: 'ArenaBoardFixtureSelectorQuery' as const,
    ArenaGameDaysQuery: 'ArenaGameDaysQuery' as const,
    ArenaGameListQuery: 'ArenaGameListQuery' as const,
    ArenaLineupsFixtureSelectorCurrentFixtureQuery: 'ArenaLineupsFixtureSelectorCurrentFixtureQuery' as const,
    ArenaLineupsFixtureSelectorQuery: 'ArenaLineupsFixtureSelectorQuery' as const,
    ArenaLineupsStickyFooterQuery: 'ArenaLineupsStickyFooterQuery' as const,
    ArenaTopLineupsQuery: 'ArenaTopLineupsQuery' as const,
    BoardTaskLineupsQuery: 'BoardTaskLineupsQuery' as const,
    ProHotStreakTileTopRecommendationsQuery: 'ProHotStreakTileTopRecommendationsQuery' as const,
    CardWithTokenPageContentQuery: 'CardWithTokenPageContentQuery' as const,
    ChampionshipPreviewQuery: 'ChampionshipPreviewQuery' as const,
    ChampionshipNoLineupsQuery: 'ChampionshipNoLineupsQuery' as const,
    UserGroupContendersQuery: 'UserGroupContendersQuery' as const,
    CollectionsQuery: 'CollectionsQuery' as const,
    CollectionCardsQuery: 'CollectionCardsQuery' as const,
    CollectionLayoutQuery: 'CollectionLayoutQuery' as const,
    CollectionLeaderboardQuery: 'CollectionLeaderboardQuery' as const,
    AddCollectionToCartQuery: 'AddCollectionToCartQuery' as const,
    CollectionLeaderboardPageQuery: 'CollectionLeaderboardPageQuery' as const,
    CommonPacksQuery: 'CommonPacksQuery' as const,
    EmptyStepBenchQuery: 'EmptyStepBenchQuery' as const,
    PreFetchSo5BenchMarketplaceQuery: 'PreFetchSo5BenchMarketplaceQuery' as const,
    ContenderDrawerQuery: 'ContenderDrawerQuery' as const,
    CardPullEssenceBalanceQuery: 'CardPullEssenceBalanceQuery' as const,
    LazyEssenceFlavoursQuery: 'LazyEssenceFlavoursQuery' as const,
    LazyOddsTableQuery: 'LazyOddsTableQuery' as const,
    CardPullExperienceStoryQuery: 'CardPullExperienceStoryQuery' as const,
    FixtureSelectorQuery: 'FixtureSelectorQuery' as const,
    FixtureTeamsOverviewQuery: 'FixtureTeamsOverviewQuery' as const,
    UpcomingFixtureLeagueQuery: 'UpcomingFixtureLeagueQuery' as const,
    ProjectionInGameHeaderQuery: 'ProjectionInGameHeaderQuery' as const,
    LazyLineupsContendersWidgetQuery: 'LazyLineupsContendersWidgetQuery' as const,
    LazyLineupsLeaderboardGroupsWidgetQuery: 'LazyLineupsLeaderboardGroupsWidgetQuery' as const,
    ImportLineupQuery: 'ImportLineupQuery' as const,
    InboxDrawerQuery: 'InboxDrawerQuery' as const,
    ReferralListQuery: 'ReferralListQuery' as const,
    WalletLandingQuery: 'WalletLandingQuery' as const,
    CumulativePaginatedRankingsQuery: 'CumulativePaginatedRankingsQuery' as const,
    PastLeaderboardListQuery: 'PastLeaderboardListQuery' as const,
    CumulativeRankRewardsQuery: 'CumulativeRankRewardsQuery' as const,
    LazyRankRewardsQuery: 'LazyRankRewardsQuery' as const,
    MyCircleLeaderboardQuery: 'MyCircleLeaderboardQuery' as const,
    PaginatedRankingsQuery: 'PaginatedRankingsQuery' as const,
    FullRankingsQuery: 'FullRankingsQuery' as const,
    LeagueTrckTeamViewDialogQuery: 'LeagueTrckTeamViewDialogQuery' as const,
    YourNextStepQuery: 'YourNextStepQuery' as const,
    LeagueTrckVaultGatedHowItWorksDialogQuery: 'LeagueTrckVaultGatedHowItWorksDialogQuery' as const,
    LeaderboardComposableQuery: 'LeaderboardComposableQuery' as const,
    LineupRewardsDistancesQuery: 'LineupRewardsDistancesQuery' as const,
    MyIncompleteCardCollectionsPaginatedQuery: 'MyIncompleteCardCollectionsPaginatedQuery' as const,
    MarketHomePageQuery: 'MarketHomePageQuery' as const,
    ArenaMissionsDialogQuery: 'ArenaMissionsDialogQuery' as const,
    DropChallengePickerDialogQuery: 'DropChallengePickerDialogQuery' as const,
    FeaturedTasksQuery: 'FeaturedTasksQuery' as const,
    MissionsCategoryRarityTabsLayoutQuery: 'MissionsCategoryRarityTabsLayoutQuery' as const,
    MissionsTaskDetailsQuery: 'MissionsTaskDetailsQuery' as const,
    PlayMissionContentQuery: 'PlayMissionContentQuery' as const,
    PlayMissionsDialogQuery: 'PlayMissionsDialogQuery' as const,
    ProMissionsDialogQuery: 'ProMissionsDialogQuery' as const,
    TaskCardsMyRelatedCardsQuery: 'TaskCardsMyRelatedCardsQuery' as const,
    TaskCollectionsQuery: 'TaskCollectionsQuery' as const,
    SetCollectionTaskDialog: 'SetCollectionTaskDialog' as const,
    SetMissionsDialogQuery: 'SetMissionsDialogQuery' as const,
    DecisivePlayerPickerDialogQuery: 'DecisivePlayerPickerDialogQuery' as const,
    CardsPerGameQuery: 'CardsPerGameQuery' as const,
    CommonEssenceRewardedQuery: 'CommonEssenceRewardedQuery' as const,
    CardsBoostSummaryQuery: 'CardsBoostSummaryQuery' as const,
    CardsToDropQuery: 'CardsToDropQuery' as const,
    MyCardsCollectionsSearchQuery: 'MyCardsCollectionsSearchQuery' as const,
    MyCardsGridSearchQuery: 'MyCardsGridSearchQuery' as const,
    MyClubCardsGridSearchQuery: 'MyClubCardsGridSearchQuery' as const,
    MyClubCardsPageQuery: 'MyClubCardsPageQuery' as const,
    NetworkFollowersQuery: 'NetworkFollowersQuery' as const,
    NetworkFollowingQuery: 'NetworkFollowingQuery' as const,
    NetworkRecommendedQuery: 'NetworkRecommendedQuery' as const,
    FeaturedMainLeagueLaunchCardsSearchQuery: 'FeaturedMainLeagueLaunchCardsSearchQuery' as const,
    FeaturedMainLeagueLaunchClubFilter: 'FeaturedMainLeagueLaunchClubFilter' as const,
    HotStreakDialogQuery: 'HotStreakDialogQuery' as const,
    NewSeasonPageQuery: 'NewSeasonPageQuery' as const,
    So5NoCardRouteEntryFixtureQuery: 'So5NoCardRouteEntryFixtureQuery' as const,
    LazyImportantNotificationDialogQuery: 'LazyImportantNotificationDialogQuery' as const,
    InGameNotificationQuery: 'InGameNotificationQuery' as const,
    FixtureTimelineDialogQuery: 'FixtureTimelineDialogQuery' as const,
    LastMatchChip: 'LastMatchChip' as const,
    TargetHitLineupQuery: 'TargetHitLineupQuery' as const,
    PerformanceBlocksQuery: 'PerformanceBlocksQuery' as const,
    PlayerWatchlistsQuery: 'PlayerWatchlistsQuery' as const,
    ProBoardGamesListQuery: 'ProBoardGamesListQuery' as const,
    PlayerInformationsQuery: 'PlayerInformationsQuery' as const,
    WelcomeOfferBannerQuery: 'WelcomeOfferBannerQuery' as const,
    WelcomeOfferDialogQuery: 'WelcomeOfferDialogQuery' as const,
    WelcomeOfferOrbQuery: 'WelcomeOfferOrbQuery' as const,
    GalleryNohighlightedDeckQuery: 'GalleryNohighlightedDeckQuery' as const,
    LadderStepLineupsDialogQuery: 'LadderStepLineupsDialogQuery' as const,
    ProManagerMonthlyLadderQuery: 'ProManagerMonthlyLadderQuery' as const,
    ProManagerOverviewQuery: 'ProManagerOverviewQuery' as const,
    ProManagerStepsWonQuery: 'ProManagerStepsWonQuery' as const,
    UserWatchlistsQuery: 'UserWatchlistsQuery' as const,
    RenderingGalleryQuery: 'RenderingGalleryQuery' as const,
    NewFixtureRewardsQuery: 'NewFixtureRewardsQuery' as const,
    PlayRewardsFixtureLayoutQuery: 'PlayRewardsFixtureLayoutQuery' as const,
    RewardPoolSharesListQuery: 'RewardPoolSharesListQuery' as const,
    UnclaimedDeliverableItemOrder: 'UnclaimedDeliverableItemOrder' as const,
    GameCardsPreviewQuery: 'GameCardsPreviewQuery' as const,
    MatchCenterViewDialogQuery: 'MatchCenterViewDialogQuery' as const,
    GuessTheScoreDialogQuery: 'GuessTheScoreDialogQuery' as const,
    HotStreaksTutorialStoryQuery: 'HotStreaksTutorialStoryQuery' as const,
    AddFriendsDialogQuery: 'AddFriendsDialogQuery' as const,
    FriendsDialogFollowersQuery: 'FriendsDialogFollowersQuery' as const,
    FriendsDialogFollowingQuery: 'FriendsDialogFollowingQuery' as const,
    AvailableEmojisQuery: 'AvailableEmojisQuery' as const,
    ReactionsDialogActivityQuery: 'ReactionsDialogActivityQuery' as const,
    ReactionsDialogQuery: 'ReactionsDialogQuery' as const,
    SeriesHubActivitiesQuery: 'SeriesHubActivitiesQuery' as const,
    SeriesHubMyActivitiesQuery: 'SeriesHubMyActivitiesQuery' as const,
    ConnectTaskDialogQuery: 'ConnectTaskDialogQuery' as const,
    StepComposeBenchQuery: 'StepComposeBenchQuery' as const,
    TargetHitCelebrationQuery: 'TargetHitCelebrationQuery' as const,
    TaskRecommendationsQuery: 'TaskRecommendationsQuery' as const,
    SeriesComposeBenchQuery: 'SeriesComposeBenchQuery' as const,
    TaskAddCardToLineupQuery: 'TaskAddCardToLineupQuery' as const,
    SetInviteCodeDialogQuery: 'SetInviteCodeDialogQuery' as const,
    ShopItemPickerQuery: 'ShopItemPickerQuery' as const,
    LeagueDetailsStepQuery: 'LeagueDetailsStepQuery' as const,
    TestLastFixtureStory: 'TestLastFixtureStory' as const,
    LastStoryFixtureQuery: 'LastStoryFixtureQuery' as const,
    SquadBoardSeriesMissionsQuery: 'SquadBoardSeriesMissionsQuery' as const,
    SquadJoinFromLinkQuery: 'SquadJoinFromLinkQuery' as const,
    SquadSearchQuery: 'SquadSearchQuery' as const,
    BenchObjectDrawerQuery: 'BenchObjectDrawerQuery' as const,
    PlayerGameScoreDrawerQuery: 'PlayerGameScoreDrawerQuery' as const,
    AppearanceDialogQuery: 'AppearanceDialogQuery' as const,
    FixtureTopPlayersQuery: 'FixtureTopPlayersQuery' as const,
    TrckGroupAsideGWSelectorQuery: 'TrckGroupAsideGWSelectorQuery' as const,
    TrckGroupAsideGWSelectorFixtureQuery: 'TrckGroupAsideGWSelectorFixtureQuery' as const,
    FixtureCompetitionTrckGrpDrawerQuery: 'FixtureCompetitionTrckGrpDrawerQuery' as const,
    BookmarksQuery: 'BookmarksQuery' as const,
    TaskLineupPreviewQuery: 'TaskLineupPreviewQuery' as const,
    ArenaFixtureLeaderboardGroupsQuery: 'ArenaFixtureLeaderboardGroupsQuery' as const,
    GetAllUserGroupsQuery: 'GetAllUserGroupsQuery' as const,
    FixtureCompetitionRewardsTrckLayoutQuery: 'FixtureCompetitionRewardsTrckLayoutQuery' as const,
    FixtureCompetitionTrckGrpLayoutQuery: 'FixtureCompetitionTrckGrpLayoutQuery' as const,
    FixtureCompetitionTrckLayoutQuery: 'FixtureCompetitionTrckLayoutQuery' as const,
    FixtureLayoutQuery: 'FixtureLayoutQuery' as const,
    MyClubSlugLayoutQuery: 'MyClubSlugLayoutQuery' as const,
    ScoutingCenterDayGameIdLayoutQuery: 'ScoutingCenterDayGameIdLayoutQuery' as const,
    GameCenterDayLayoutQuery: 'GameCenterDayLayoutQuery' as const,
    MyCardsCardsLayoutQuery: 'MyCardsCardsLayoutQuery' as const,
    MyCardsGalleryLayoutQuery: 'MyCardsGalleryLayoutQuery' as const,
    MyCardsLayoutQuery: 'MyCardsLayoutQuery' as const,
    MyClubCardsLayoutQuery: 'MyClubCardsLayoutQuery' as const,
    RewardsEssenceLayoutQuery: 'RewardsEssenceLayoutQuery' as const,
    RewardsFixtureLayoutQuery: 'RewardsFixtureLayoutQuery' as const,
    MyRevealableCardsSearchQuery: 'MyRevealableCardsSearchQuery' as const,
    MyRevealableCardCampaignQuery: 'MyRevealableCardCampaignQuery' as const,
    FixtureCompetitionRewardsPageQuery: 'FixtureCompetitionRewardsPageQuery' as const,
    FixtureCompetitionTrckGrpTrckRewardsContenderPageQuery: 'FixtureCompetitionTrckGrpTrckRewardsContenderPageQuery' as const,
    MatchCenterPaginatedQuery: 'MatchCenterPaginatedQuery' as const,
    MissionsCategorySelectorQuery: 'MissionsCategorySelectorQuery' as const,
    DelayedCardsQuery: 'DelayedCardsQuery' as const,
    PrizePoolContenderPageQuery: 'PrizePoolContenderPageQuery' as const,
    ScoutingCenterGameIdRedirectPageQuery: 'ScoutingCenterGameIdRedirectPageQuery' as const,
    BuyItemPageQuery: 'BuyItemPageQuery' as const,
    CluesConversionConfigsQuery: 'CluesConversionConfigsQuery' as const,
    CluesConversionBalancesQuery: 'CluesConversionBalancesQuery' as const,
    InventoryShardsPageQuery: 'InventoryShardsPageQuery' as const,
    HomeEventTypeQuery: 'HomeEventTypeQuery' as const,
    HowToPlayCardsQuery: 'HowToPlayCardsQuery' as const,
    ReferralProgramConfig: 'ReferralProgramConfig' as const,
    SetInvitePageQuery: 'SetInvitePageQuery' as const,
    SetInviteCreditQuery: 'SetInviteCreditQuery' as const,
    ArenaBoardFixtureLineupsPageQuery: 'ArenaBoardFixtureLineupsPageQuery' as const,
    CareerLineupsPageQuery: 'CareerLineupsPageQuery' as const,
    ManagerSalesStackPlayerQuery: 'ManagerSalesStackPlayerQuery' as const,
    WelcomeOfferPacksPageQuery: 'WelcomeOfferPacksPageQuery' as const,
    WelcomeOfferPageQuery: 'WelcomeOfferPageQuery' as const,
    WatchlistPageQuery: 'WatchlistPageQuery' as const,
    MissionsCategoryRarityLayoutQuery: 'MissionsCategoryRarityLayoutQuery' as const,
    MissionsCategoryRarityPageQuery: 'MissionsCategoryRarityPageQuery' as const,
    RefreshDailyActionTaskQuery: 'RefreshDailyActionTaskQuery' as const,
    MyCircleFixtureSlugPageQuery: 'MyCircleFixtureSlugPageQuery' as const,
    MyCircleLayoutQuery: 'MyCircleLayoutQuery' as const,
    MyCircleEventTypePageQuery: 'MyCircleEventTypePageQuery' as const,
    ManagerProfileQuery: 'ManagerProfileQuery' as const,
    UserTransactionsQuery: 'UserTransactionsQuery' as const,
    OnboardingProThresholdsQuery: 'OnboardingProThresholdsQuery' as const,
    LeagueStarterKitDialogQuery: 'LeagueStarterKitDialogQuery' as const,
    OnboardingBoardsQuery: 'OnboardingBoardsQuery' as const,
    OnboardingConversionCreditQuery: 'OnboardingConversionCreditQuery' as const,
    CompetitionGamesPageQuery: 'CompetitionGamesPageQuery' as const,
    CompetitionGamesPaginatedPageQuery: 'CompetitionGamesPaginatedPageQuery' as const,
    FixtureCompetitionTrckGrpSeasonalityPageQuery: 'FixtureCompetitionTrckGrpSeasonalityPageQuery' as const,
    FixtureCompetitionCompetitionPageQuery: 'FixtureCompetitionCompetitionPageQuery' as const,
    FootballFixtureCompetitionPageQuery: 'FootballFixtureCompetitionPageQuery' as const,
    GameplayRewardsFixturePageQuery: 'GameplayRewardsFixturePageQuery' as const,
    ContenderPageQuery: 'ContenderPageQuery' as const,
    GameplayPlayProFixturePageQuery: 'GameplayPlayProFixturePageQuery' as const,
    ArenaCompetitionGamesPageQuery: 'ArenaCompetitionGamesPageQuery' as const,
    ArenaCompetitionGamesPaginatedPageQuery: 'ArenaCompetitionGamesPaginatedPageQuery' as const,
    ArenaCompetitionFixtureCompetitionTrckGrpSeasonalityPageQuery: 'ArenaCompetitionFixtureCompetitionTrckGrpSeasonalityPageQuery' as const,
    ArenaCompetitionFixtureCompetitionCompetitionPageQuery: 'ArenaCompetitionFixtureCompetitionCompetitionPageQuery' as const,
    FootballArenaFixtureCompetitionPageQuery: 'FootballArenaFixtureCompetitionPageQuery' as const,
    ArenaContenderPageQuery: 'ArenaContenderPageQuery' as const,
    ArenaLineupsPageQuery: 'ArenaLineupsPageQuery' as const,
    PlayEventTypeArenaQuery: 'PlayEventTypeArenaQuery' as const,
    ChampionshipUserGroupUserQuery: 'ChampionshipUserGroupUserQuery' as const,
    ChampionshipQuery: 'ChampionshipQuery' as const,
    ChampionshipLayoutQuery: 'ChampionshipLayoutQuery' as const,
    ChampionshipCompetitionFullLeaderboardPageQuery: 'ChampionshipCompetitionFullLeaderboardPageQuery' as const,
    RankingsLineupPageQuery: 'RankingsLineupPageQuery' as const,
    RankingsPageQuery: 'RankingsPageQuery' as const,
    PlayEventTypeQuery: 'PlayEventTypeQuery' as const,
    ArenaBoardLineupsPageQuery: 'ArenaBoardLineupsPageQuery' as const,
    GameplayPlayBoardsArenaModeFixtureLineupsPageQuery: 'GameplayPlayBoardsArenaModeFixtureLineupsPageQuery' as const,
    BoardsArenaModePageQuery: 'BoardsArenaModePageQuery' as const,
    CareerComposeTeamEditLineupQuery: 'CareerComposeTeamEditLineupQuery' as const,
    CareerComposeTeamQuery: 'CareerComposeTeamQuery' as const,
    CareerTaskLineupsPageQuery: 'CareerTaskLineupsPageQuery' as const,
    QueuedTaskPreparedLineupsPageQuery: 'QueuedTaskPreparedLineupsPageQuery' as const,
    LadderLeaderboardPageQuery: 'LadderLeaderboardPageQuery' as const,
    BoardMissionsCollectPageQuery: 'BoardMissionsCollectPageQuery' as const,
    ProCareerBoardPageQuery: 'ProCareerBoardPageQuery' as const,
    ProCareerLineupsPageQuery: 'ProCareerLineupsPageQuery' as const,
    ProManagerProfileQuery: 'ProManagerProfileQuery' as const,
    ProCareerPageQuery: 'ProCareerPageQuery' as const,
    PlayMissionsCategoryRarityLayoutQuery: 'PlayMissionsCategoryRarityLayoutQuery' as const,
    PlayMissionsCategoryRarityPageQuery: 'PlayMissionsCategoryRarityPageQuery' as const,
    PlayRefreshDailyActionTaskQuery: 'PlayRefreshDailyActionTaskQuery' as const,
    LeaderboardGroupMissionsCollectPageQuery: 'LeaderboardGroupMissionsCollectPageQuery' as const,
    AnyPlayerCardsSupplyLayoutQuery: 'AnyPlayerCardsSupplyLayoutQuery' as const,
    PlayerFixturesQuery: 'PlayerFixturesQuery' as const,
    AnyPlayerHistoryQuery: 'AnyPlayerHistoryQuery' as const,
    AnyPlayerLayoutQuery: 'AnyPlayerLayoutQuery' as const,
    AnyPlayerPerformanceQuery: 'AnyPlayerPerformanceQuery' as const,
    ClubEditorPageQuery: 'ClubEditorPageQuery' as const,
    RenderingBaseballDeckQuery: 'RenderingBaseballDeckQuery' as const,
    RenderingFootballDeckQuery: 'RenderingFootballDeckQuery' as const,
    RenderingNbaDeckQuery: 'RenderingNbaDeckQuery' as const,
    RenderingBaseballManagerIdQuery: 'RenderingBaseballManagerIdQuery' as const,
    RenderingFootballManagerIdQuery: 'RenderingFootballManagerIdQuery' as const,
    RenderingNBAManagerIdQuery: 'RenderingNBAManagerIdQuery' as const,
    RewardsEssenceTierRarityPageQuery: 'RewardsEssenceTierRarityPageQuery' as const,
    RewardsFixtureLeagueTierRarityPageQuery: 'RewardsFixtureLeagueTierRarityPageQuery' as const,
    FixtureTopPlayersLayoutQuery: 'FixtureTopPlayersLayoutQuery' as const,
    SeriesComposeTeamEditLineupQuery: 'SeriesComposeTeamEditLineupQuery' as const,
    SeriesComposeTeamQuery: 'SeriesComposeTeamQuery' as const,
    SeriesTaskLineupsPageQuery: 'SeriesTaskLineupsPageQuery' as const,
    SeriesGuessTheScoreComposeTeamEditLineupQuery: 'SeriesGuessTheScoreComposeTeamEditLineupQuery' as const,
    SeriesGuessTheScoreComposeTeamQuery: 'SeriesGuessTheScoreComposeTeamQuery' as const,
    SeriesInboxPageQuery: 'SeriesInboxPageQuery' as const,
    SetReferralOnlineLandingQuery: 'SetReferralOnlineLandingQuery' as const,
    SeriesMissionsCollectPageQuery: 'SeriesMissionsCollectPageQuery' as const,
    SeriesMissionsPlayPageQuery: 'SeriesMissionsPlayPageQuery' as const,
    SeriesMissionsArenaPageQuery: 'SeriesMissionsArenaPageQuery' as const,
    SetManagerProfileQuery: 'SetManagerProfileQuery' as const,
    SelectCompetitionQuery: 'SelectCompetitionQuery' as const,
    SelectTeamQuery: 'SelectTeamQuery' as const,
    SeriesPlayPageQuery: 'SeriesPlayPageQuery' as const,
    SeriesPlayPageMissionsQuery: 'SeriesPlayPageMissionsQuery' as const,
    UnclaimedDeliverableItemOrdersQuery: 'UnclaimedDeliverableItemOrdersQuery' as const,
    SquadComposeStepIdQuery: 'SquadComposeStepIdQuery' as const,
    SquadCreatedPageQuery: 'SquadCreatedPageQuery' as const,
    SquadLineupsStepIdQuery: 'SquadLineupsStepIdQuery' as const,
    SquadMembersPageQuery: 'SquadMembersPageQuery' as const,
    SquadPageQuery: 'SquadPageQuery' as const,
    SeriesTrainingComposeTeamQuery: 'SeriesTrainingComposeTeamQuery' as const,
    SeriesTrainingPageQuery: 'SeriesTrainingPageQuery' as const,
    EmptyCollectionSlotContentQuery: 'EmptyCollectionSlotContentQuery' as const,
    SeriesCardPageQuery: 'SeriesCardPageQuery' as const,
    SetCardPagePacksQuery: 'SetCardPagePacksQuery' as const,
    MarketBannerQuery: 'MarketBannerQuery' as const,
    WheelHistoryQuery: 'WheelHistoryQuery' as const,
    HowToWinTicketDialogQuery: 'HowToWinTicketDialogQuery' as const,
    WheelOdds: 'WheelOdds' as const,
    WheelQuery: 'WheelQuery' as const,
    StreaksPromotionQuery: 'StreaksPromotionQuery' as const,
    BidPaymentFlowQuery: 'BidPaymentFlowQuery' as const,
    TokenAuctionBestBidQuery: 'TokenAuctionBestBidQuery' as const,
    BuyPaymentFlowQuery: 'BuyPaymentFlowQuery' as const,
    BuyTokenConfirmationQueryById: 'BuyTokenConfirmationQueryById' as const,
    KlarnaMinimumAmountQuery: 'KlarnaMinimumAmountQuery' as const,
    RefreshBillingAddress: 'RefreshBillingAddress' as const,
    AddToCartPopinQuery: 'AddToCartPopinQuery' as const,
    CartBuyerQuery: 'CartBuyerQuery' as const,
    RefreshCartPriceAndSignedAmount: 'RefreshCartPriceAndSignedAmount' as const,
    CartPromoDetailsQuery: 'CartPromoDetailsQuery' as const,
    CheckoutQuery: 'CheckoutQuery' as const,
    LazyCollectionUpsellElementQuery: 'LazyCollectionUpsellElementQuery' as const,
    MissingCardsForCollectionQuery: 'MissingCardsForCollectionQuery' as const,
    LazyCartPromosQuery: 'LazyCartPromosQuery' as const,
    BundleDetailsDialogQuery: 'BundleDetailsDialogQuery' as const,
    BuyGemsDialogQuery: 'BuyGemsDialogQuery' as const,
    BuyCardPackDialogQuery: 'BuyCardPackDialogQuery' as const,
    PurchasedPacksRevealQuery: 'PurchasedPacksRevealQuery' as const,
    SeriesCardPackGroupRefetchTaskQuery: 'SeriesCardPackGroupRefetchTaskQuery' as const,
    PackOddsSlotGameplayTierOddsQuery: 'PackOddsSlotGameplayTierOddsQuery' as const,
    PackContentDialogQuery: 'PackContentDialogQuery' as const,
    PackDetailsDialogQuery: 'PackDetailsDialogQuery' as const,
    PendingPackRevealQuery: 'PendingPackRevealQuery' as const,
    WelcomePackDialogQuery: 'WelcomePackDialogQuery' as const,
    WelcomePackPurchasedOfferQuery: 'WelcomePackPurchasedOfferQuery' as const,
    DeckEditorQuery: 'DeckEditorQuery' as const,
    CardsForDeckQuery: 'CardsForDeckQuery' as const,
    NewOfferCardsQuery: 'NewOfferCardsQuery' as const,
    TradeCardsSearchQuery: 'TradeCardsSearchQuery' as const,
    CardsShowQuery: 'CardsShowQuery' as const,
    AllTokenAuctionsQuery: 'AllTokenAuctionsQuery' as const,
    LostTokenAuctionsQuery: 'LostTokenAuctionsQuery' as const,
    OpenTokenAuctionsQuery: 'OpenTokenAuctionsQuery' as const,
    WonTokenAuctionsQuery: 'WonTokenAuctionsQuery' as const,
    CurrentUserFollowsQuery: 'CurrentUserFollowsQuery' as const,
    OfferQuery: 'OfferQuery' as const,
    BoughtPrimaryOffersQuery: 'BoughtPrimaryOffersQuery' as const,
    PurchasesQuery: 'PurchasesQuery' as const,
    AllSaleOffersQuery: 'AllSaleOffersQuery' as const,
    NoBuyerSaleOffersQuery: 'NoBuyerSaleOffersQuery' as const,
    OpenSaleOffersQuery: 'OpenSaleOffersQuery' as const,
    SoldSaleOffersQuery: 'SoldSaleOffersQuery' as const,
    FollowsForNotificationsQuery: 'FollowsForNotificationsQuery' as const,
    EssenceTransactionsQuery: 'EssenceTransactionsQuery' as const,
    GemsTransactionsQuery: 'GemsTransactionsQuery' as const,
    SpentFiatPaymentIntentsQuery: 'SpentFiatPaymentIntentsQuery' as const,
    UserAccountEntriesQuery: 'UserAccountEntriesQuery' as const,
    TRANSACTION_HISTORY_CONTENT_QUERY: 'TRANSACTION_HISTORY_CONTENT_QUERY' as const,
    GetCounterOfferQuery: 'GetCounterOfferQuery' as const,
    MyOffersQuery: 'MyOffersQuery' as const,
    CancelSalePopinQuery: 'CancelSalePopinQuery' as const,
    RoutedSaleDialogQuery: 'RoutedSaleDialogQuery' as const,
    CalendarTooltipQuery: 'CalendarTooltipQuery' as const,
    LazyAllLastOwnedCardsQuery: 'LazyAllLastOwnedCardsQuery' as const,
    LazyAllLastOwnedCardsBySo5CompetitionQuery: 'LazyAllLastOwnedCardsBySo5CompetitionQuery' as const,
    PlayerMarketDrawerContentQuery: 'PlayerMarketDrawerContentQuery' as const,
    TransactionsPageQuery: 'TransactionsPageQuery' as const,
    LazyPriceGraphQuery: 'LazyPriceGraphQuery' as const,
    AvailablePrimaryOfferForAPlayerQuery: 'AvailablePrimaryOfferForAPlayerQuery' as const,
    BuyPrimaryBuyConfirmationQueryById: 'BuyPrimaryBuyConfirmationQueryById' as const,
    PrimaryBuyPaymentFlowQuery: 'PrimaryBuyPaymentFlowQuery' as const,
    RefreshSignedAmountQuery: 'RefreshSignedAmountQuery' as const,
    MarketFeesOfferQuery: 'MarketFeesOfferQuery' as const,
    RarityVaultBannerQuery: 'RarityVaultBannerQuery' as const,
    RarityVaultHowItWorksDialogQuery: 'RarityVaultHowItWorksDialogQuery' as const,
    SealCardsDialogQuery: 'SealCardsDialogQuery' as const,
    SealingRecapQuery: 'SealingRecapQuery' as const,
    UnsealCardDialogQuery: 'UnsealCardDialogQuery' as const,
    UnsealingAnimationQuery: 'UnsealingAnimationQuery' as const,
    AuctionOwnershipDetailsQuery: 'AuctionOwnershipDetailsQuery' as const,
    DirectOfferOwnershipDetailsQuery: 'DirectOfferOwnershipDetailsQuery' as const,
    AlternativeStackedTokensByIdsQuery: 'AlternativeStackedTokensByIdsQuery' as const,
    UsedInLineupValidatorQuery: 'UsedInLineupValidatorQuery' as const,
    EthereumTokensQuery: 'EthereumTokensQuery' as const,
    AddToWatchlistQuery: 'AddToWatchlistQuery' as const,
    FavoritesWatchlistPageQuery: 'FavoritesWatchlistPageQuery' as const,
    AddWatchlistToCartButtonQuery: 'AddWatchlistToCartButtonQuery' as const,
    WatchlistsLayoutQuery: 'WatchlistsLayoutQuery' as const,
    WatchlistsPageQuery: 'WatchlistsPageQuery' as const,
    CurrentMarketplaceUserQuery: 'CurrentMarketplaceUserQuery' as const,
    MyBidsPictureInPictureQuery: 'MyBidsPictureInPictureQuery' as const,
    TokenAuctionLeaderQuery: 'TokenAuctionLeaderQuery' as const,
    NextRelayBatchNonceQuery: 'NextRelayBatchNonceQuery' as const,
    currentBlockHeightQuery: 'currentBlockHeightQuery' as const,
    MatchdayPicksQuery: 'MatchdayPicksQuery' as const,
    PollInGameCurrencyPackDelivery: 'PollInGameCurrencyPackDelivery' as const,
    PollingVoucher: 'PollingVoucher' as const,
    DefaultPrintablePlayerFacetValuesSearchQuery: 'DefaultPrintablePlayerFacetValuesSearchQuery' as const,
    MarketCardsSearchFacetValuesQuery: 'MarketCardsSearchFacetValuesQuery' as const,
    MarketCardsSearchQuery: 'MarketCardsSearchQuery' as const,
    MarketGroupedCardsSearchQuery: 'MarketGroupedCardsSearchQuery' as const,
    MarketCardsStackCountsQuery: 'MarketCardsStackCountsQuery' as const,
    UserCardsSearchFacetValuesQuery: 'UserCardsSearchFacetValuesQuery' as const,
    PriceHistoryQuery: 'PriceHistoryQuery' as const,
    PrimaryOfferBuyerQuery: 'PrimaryOfferBuyerQuery' as const,
    TokenPotentialDiscount: 'TokenPotentialDiscount' as const,
    AdvancedWatchlistSearchQuery: 'AdvancedWatchlistSearchQuery' as const,
    AdvancedWatchlistFacetSearchQuery: 'AdvancedWatchlistFacetSearchQuery' as const,
    AdvancedPlayersSearchQuery: 'AdvancedPlayersSearchQuery' as const,
    PlayerDetailsQuery: 'PlayerDetailsQuery' as const,
    LazyFixtureChartQuery: 'LazyFixtureChartQuery' as const,
    PlayerGameScoreDialogQuery: 'PlayerGameScoreDialogQuery' as const,
    getNBAPlayoffsFixtureGames: 'getNBAPlayoffsFixtureGames' as const,
    NBAComposeBenchQuery: 'NBAComposeBenchQuery' as const,
    NBAPostBuyBenchObjectsQuery: 'NBAPostBuyBenchObjectsQuery' as const,
    NBAComposeBuyQuery: 'NBAComposeBuyQuery' as const,
    NBASo5LeaderboardContenderDialogQuery: 'NBASo5LeaderboardContenderDialogQuery' as const,
    GameOfBasketballQuery: 'GameOfBasketballQuery' as const,
    NBAOnboardingComposeQuery: 'NBAOnboardingComposeQuery' as const,
    NBAPlayEventTyoeFixtureMatchCenterQuery: 'NBAPlayEventTyoeFixtureMatchCenterQuery' as const,
    NBAComposeLeaderboardLineupPageQuery: 'NBAComposeLeaderboardLineupPageQuery' as const,
    NBAComposeLeaderboardManagerTeamPageQuery: 'NBAComposeLeaderboardManagerTeamPageQuery' as const,
    NBAComposeLeaderboardPageQuery: 'NBAComposeLeaderboardPageQuery' as const,
    NBALineupSharingQuery: 'NBALineupSharingQuery' as const,
    NBAChampionshipUserGroupUserQuery: 'NBAChampionshipUserGroupUserQuery' as const,
    NBAChampionshipQuery: 'NBAChampionshipQuery' as const,
    NBAChaseCompetitionFullLeaderboardPageQuery: 'NBAChaseCompetitionFullLeaderboardPageQuery' as const,
    NBAGetChampionshipUserGroupQuery: 'NBAGetChampionshipUserGroupQuery' as const,
    NBAScoutingCenterGameIdBoxScorePageQuery: 'NBAScoutingCenterGameIdBoxScorePageQuery' as const,
    NBAScoutingCenterGameIdPlayersPageQuery: 'NBAScoutingCenterGameIdPlayersPageQuery' as const,
    NbaScoutingCenterTeamStatsQuery: 'NbaScoutingCenterTeamStatsQuery' as const,
    NbaTeamCardQuery: 'NbaTeamCardQuery' as const,
    NbaSeoTeamQuery: 'NbaSeoTeamQuery' as const,
    NbaTeamOverviewQuery: 'NbaTeamOverviewQuery' as const,
    CoverageQuery: 'CoverageQuery' as const,
    FootballCompetitionQuery: 'FootballCompetitionQuery' as const,
    LicensedClubsQuery: 'LicensedClubsQuery' as const,
    NetworkUserQuery: 'NetworkUserQuery' as const,
    AdminLeaderboardRewardsPageQuery: 'AdminLeaderboardRewardsPageQuery' as const,
    contentCreatorsQuery: 'contentCreatorsQuery' as const,
    TierZeroPlayersQuery: 'TierZeroPlayersQuery' as const,
    TierTwoPlayersQuery: 'TierTwoPlayersQuery' as const,
    TierFourPlayersQuery: 'TierFourPlayersQuery' as const,
    contentCreatorsCardsQuery: 'contentCreatorsCardsQuery' as const,
    BoughtPrimaryOfferQuery: 'BoughtPrimaryOfferQuery' as const
  },
  Mutation: {
    ConsumeEphemeralTokenMutation: 'ConsumeEphemeralTokenMutation' as const,
    SignInWithOAuthMutation: 'SignInWithOAuthMutation' as const,
    VisitCampaignPage: 'VisitCampaignPage' as const,
    ValidateApplePayMerchantSession: 'ValidateApplePayMerchantSession' as const,
    confirmDeviceWithCodeMutation: 'confirmDeviceWithCodeMutation' as const,
    AddDeviceMutation: 'AddDeviceMutation' as const,
    ValidateFiatWalletMutation: 'ValidateFiatWalletMutation' as const,
    StartFiatWalletIdentityVerificationMutation: 'StartFiatWalletIdentityVerificationMutation' as const,
    GetMangopayScaUrlQuery: 'GetMangopayScaUrlQuery' as const,
    UnblockWalletMutation: 'UnblockWalletMutation' as const,
    RequestJonumSelfExclusionMutation: 'RequestJonumSelfExclusionMutation' as const,
    UpdateJonumPlaytimeLimitMutation: 'UpdateJonumPlaytimeLimitMutation' as const,
    UpdateJonumSpendingLimitMutation: 'UpdateJonumSpendingLimitMutation' as const,
    CreateJonumVerificationMutation: 'CreateJonumVerificationMutation' as const,
    CollectJonumPersonalInfoMutation: 'CollectJonumPersonalInfoMutation' as const,
    SetJonumPlaytimeLimitMutation: 'SetJonumPlaytimeLimitMutation' as const,
    SetJonumSpendingLimitMutation: 'SetJonumSpendingLimitMutation' as const,
    CreateJonumVerificationDisclaimerMutation: 'CreateJonumVerificationDisclaimerMutation' as const,
    AskForProxyConsentMutation: 'AskForProxyConsentMutation' as const,
    CreateConnectedTasks: 'CreateConnectedTasks' as const,
    CreateOffRampBridgeCustomerMutation: 'CreateOffRampBridgeCustomerMutation' as const,
    CreateOffRampBridgeTosLinkMutation: 'CreateOffRampBridgeTosLinkMutation' as const,
    StartOffRampBridgeKycMutation: 'StartOffRampBridgeKycMutation' as const,
    UpdatePartnerOffersAgreementMutation: 'UpdatePartnerOffersAgreementMutation' as const,
    DeleteApiKeyMutation: 'DeleteApiKeyMutation' as const,
    CreateApiKeyMutation: 'CreateApiKeyMutation' as const,
    UnblockUserMutation: 'UnblockUserMutation' as const,
    DestroyUserAccountMutation: 'DestroyUserAccountMutation' as const,
    revokeDeviceMutation: 'revokeDeviceMutation' as const,
    UpdateUserSettingsDiscoverableMutation: 'UpdateUserSettingsDiscoverableMutation' as const,
    LogOutAllDevicesMutation: 'LogOutAllDevicesMutation' as const,
    GeneratePasskeyChallengeForCreate: 'GeneratePasskeyChallengeForCreate' as const,
    CreatePasskey: 'CreatePasskey' as const,
    DeletePasskeyMutation: 'DeletePasskeyMutation' as const,
    UpdateSectionNotificationPreferencesMutation: 'UpdateSectionNotificationPreferencesMutation' as const,
    UpdateNotificationPreferencesMutation: 'UpdateNotificationPreferencesMutation' as const,
    UpdateMaxDailyPushNotificationsMutation: 'UpdateMaxDailyPushNotificationsMutation' as const,
    UpdateOAuthApplicationMutation: 'UpdateOAuthApplicationMutation' as const,
    DeleteOAuthApplicationMutation: 'DeleteOAuthApplicationMutation' as const,
    CreateOAuthApplicationMutation: 'CreateOAuthApplicationMutation' as const,
    RevokeOAuthAccessTokenForApplicationMutation: 'RevokeOAuthAccessTokenForApplicationMutation' as const,
    DetachPaymentMethodMutation: 'DetachPaymentMethodMutation' as const,
    DeletePostalAddressMutation: 'DeletePostalAddressMutation' as const,
    UpdateUserPostalAddressMutation: 'UpdateUserPostalAddressMutation' as const,
    UpdateUserSettingsRewardCurrencyMutation: 'UpdateUserSettingsRewardCurrencyMutation' as const,
    UnblockEmailMutation: 'UnblockEmailMutation' as const,
    UpdateUserSettingsLocaleMutation: 'UpdateUserSettingsLocaleMutation' as const,
    DisconnectOmniauthProviderMutation: 'DisconnectOmniauthProviderMutation' as const,
    CheckPhoneNumberMutation: 'CheckPhoneNumberMutation' as const,
    VerifyPhoneNumberMutation: 'VerifyPhoneNumberMutation' as const,
    DepositWithApplePay: 'DepositWithApplePay' as const,
    CreateWireTransferDeposit: 'CreateWireTransferDeposit' as const,
    CreateDepositBankAccount: 'CreateDepositBankAccount' as const,
    createWithdrawalBankAccountMutation: 'createWithdrawalBankAccountMutation' as const,
    deleteWithdrawalBankAccount: 'deleteWithdrawalBankAccount' as const,
    createFiatWithdrawalMutation: 'createFiatWithdrawalMutation' as const,
    RevokeEip7702DelegationMutation: 'RevokeEip7702DelegationMutation' as const,
    CreateStarkwareEscapeHatchMutation: 'CreateStarkwareEscapeHatchMutation' as const,
    CreatePendingDepositMutation: 'CreatePendingDepositMutation' as const,
    AddEthereumAccountMutation: 'AddEthereumAccountMutation' as const,
    PrepareEthDepositMutation: 'PrepareEthDepositMutation' as const,
    UpdateUserSettingsLastWeb3ProviderMutation: 'UpdateUserSettingsLastWeb3ProviderMutation' as const,
    ReportTelemetry: 'ReportTelemetry' as const,
    AcceptTermsMutation: 'AcceptTermsMutation' as const,
    SignInMutation: 'SignInMutation' as const,
    ResendConfirmationInstructionsMutation: 'ResendConfirmationInstructionsMutation' as const,
    GeneratePasskeyChallengeForSignIn: 'GeneratePasskeyChallengeForSignIn' as const,
    UpdateExternalEthDeposit: 'UpdateExternalEthDeposit' as const,
    SetSolanaMutation: 'SetSolanaMutation' as const,
    UpdateUserEmailMutation: 'UpdateUserEmailMutation' as const,
    FetchEncryptedPrivateKey: 'FetchEncryptedPrivateKey' as const,
    SignUpMutationWithUser: 'SignUpMutationWithUser' as const,
    CreateCardAuthorization: 'CreateCardAuthorization' as const,
    CreateCardRegistration: 'CreateCardRegistration' as const,
    CreateFiatPayer: 'CreateFiatPayer' as const,
    PrepareDeposit: 'PrepareDeposit' as const,
    AddTokensToDeckMutation: 'AddTokensToDeckMutation' as const,
    CreateDeckMutation: 'CreateDeckMutation' as const,
    DeleteDeckMutation: 'DeleteDeckMutation' as const,
    EditDeckMutation: 'EditDeckMutation' as const,
    RemoveTokenFromDeckMutation: 'RemoveTokenFromDeckMutation' as const,
    UseMutationTestingMutation: 'UseMutationTestingMutation' as const,
    PrepareIdealDeposit: 'PrepareIdealDeposit' as const,
    MarkNotificationsAsReadMutation: 'MarkNotificationsAsReadMutation' as const,
    CreateOffRampMutation: 'CreateOffRampMutation' as const,
    PrepareOffRampMutation: 'PrepareOffRampMutation' as const,
    PreparePayByBankDeposit: 'PreparePayByBankDeposit' as const,
    PreparePaypalDeposit: 'PreparePaypalDeposit' as const,
    ActivateWalletRecoveryEmailMutation: 'ActivateWalletRecoveryEmailMutation' as const,
    AddWalletRecoveryEmailMutation: 'AddWalletRecoveryEmailMutation' as const,
    DeactivateWalletRecoveryEmailMutation: 'DeactivateWalletRecoveryEmailMutation' as const,
    ResendVerifationCodeForRecoveryEmailMutation: 'ResendVerifationCodeForRecoveryEmailMutation' as const,
    SendWalletRecoveryMutation: 'SendWalletRecoveryMutation' as const,
    ClaimSo5ReferralRewardMutation: 'ClaimSo5ReferralRewardMutation' as const,
    DestroyReferralMutation: 'DestroyReferralMutation' as const,
    CreateSubscriptionMutation: 'CreateSubscriptionMutation' as const,
    DeleteSubscriptionMutation: 'DeleteSubscriptionMutation' as const,
    UpdateSubscriptionMutation: 'UpdateSubscriptionMutation' as const,
    UpdateLifecycleMutation: 'UpdateLifecycleMutation' as const,
    LockProModeMutation: 'LockProModeMutation' as const,
    UpdateUserSettingsHideBalanceMutation: 'UpdateUserSettingsHideBalanceMutation' as const,
    SetTwaDeviceTokenMutation: 'SetTwaDeviceTokenMutation' as const,
    UnlockProModeMutation: 'UnlockProModeMutation' as const,
    Enable2FAMutation: 'Enable2FAMutation' as const,
    Disable2FAMutation: 'Disable2FAMutation' as const,
    GenerateOtpProvisioningUriMutation: 'GenerateOtpProvisioningUriMutation' as const,
    GenerateOtpBackupCodesMutation: 'GenerateOtpBackupCodesMutation' as const,
    UpdateUserSettingsCryptocurrencyMutation: 'UpdateUserSettingsCryptocurrencyMutation' as const,
    UpdateUserSettingsCurrencyMutation: 'UpdateUserSettingsCurrencyMutation' as const,
    UpdateSportProfileMutation: 'UpdateSportProfileMutation' as const,
    UpdateUserProfileMutation: 'UpdateUserProfileMutation' as const,
    BlockUserMutation: 'BlockUserMutation' as const,
    CreateJWTToken: 'CreateJWTToken' as const,
    ReportUserMutation: 'ReportUserMutation' as const,
    CreateFiatWalletMutation: 'CreateFiatWalletMutation' as const,
    UpdateFiatWalletMutation: 'UpdateFiatWalletMutation' as const,
    EnableWalletsMutation: 'EnableWalletsMutation' as const,
    UpdateCryptoCurrencyMutation: 'UpdateCryptoCurrencyMutation' as const,
    CreateBankWithdrawalMutation: 'CreateBankWithdrawalMutation' as const,
    PrepareBankWithdrawalMutation: 'PrepareBankWithdrawalMutation' as const,
    FootballSuggestLineupMutation: 'FootballSuggestLineupMutation' as const,
    RevealCard: 'RevealCard' as const,
    PullCardsMutation: 'PullCardsMutation' as const,
    PickPulledCardMutation: 'PickPulledCardMutation' as const,
    RejectCardPullMutation: 'RejectCardPullMutation' as const,
    ConfirmCardPullMutation: 'ConfirmCardPullMutation' as const,
    RevealPropertyMutation: 'RevealPropertyMutation' as const,
    CancelImportLineup: 'CancelImportLineup' as const,
    ConfirmImportLineup: 'ConfirmImportLineup' as const,
    LadderClaimRewardDialogClaimAnyRewardMutation: 'LadderClaimRewardDialogClaimAnyRewardMutation' as const,
    ClaimDailyActionSubTaskMutation: 'ClaimDailyActionSubTaskMutation' as const,
    completeDropChallengeMutation: 'completeDropChallengeMutation' as const,
    ClaimTaskWithPackMutation: 'ClaimTaskWithPackMutation' as const,
    UpsertTaskAppearances: 'UpsertTaskAppearances' as const,
    claimTaskMutation: 'claimTaskMutation' as const,
    AcceptSo5NoCardLineupMutation: 'AcceptSo5NoCardLineupMutation' as const,
    DeclineSo5NoCardLineupMutation: 'DeclineSo5NoCardLineupMutation' as const,
    ConfirmSo5NoCardLineupMutation: 'ConfirmSo5NoCardLineupMutation' as const,
    AcceptNoCardBoardDraftableAppearanceMutation: 'AcceptNoCardBoardDraftableAppearanceMutation' as const,
    AcceptNoCardDraftableAppearanceMutation: 'AcceptNoCardDraftableAppearanceMutation' as const,
    CreateSo5NoCardBoardLineupMutation: 'CreateSo5NoCardBoardLineupMutation' as const,
    GenerateSo5NoCardLineupMutation: 'GenerateSo5NoCardLineupMutation' as const,
    RequestSo5NoCardBoardDraftableAppearanceMutation: 'RequestSo5NoCardBoardDraftableAppearanceMutation' as const,
    RequestSo5NoCardDraftableAppearanceMutation: 'RequestSo5NoCardDraftableAppearanceMutation' as const,
    ResetNoCardBoardDraftedAppearancesMutation: 'ResetNoCardBoardDraftedAppearancesMutation' as const,
    ResetNoCardDraftedAppearancesMutation: 'ResetNoCardDraftedAppearancesMutation' as const,
    ClaimDeliverableItemOrder: 'ClaimDeliverableItemOrder' as const,
    upsertGuessTheScoreTaskLineupMutation: 'upsertGuessTheScoreTaskLineupMutation' as const,
    unlockNextBoardMutation: 'unlockNextBoardMutation' as const,
    RemoveActivityMutation: 'RemoveActivityMutation' as const,
    MarkSocialFeedAsReadMutation: 'MarkSocialFeedAsReadMutation' as const,
    ReactToActivityMutation: 'ReactToActivityMutation' as const,
    AddReferrerCodeMutation: 'AddReferrerCodeMutation' as const,
    shareLineupMutation: 'shareLineupMutation' as const,
    DeleteTaskLineupMutation: 'DeleteTaskLineupMutation' as const,
    RemoveMemberFromSquadMutation: 'RemoveMemberFromSquadMutation' as const,
    CreateBookmarkMutation: 'CreateBookmarkMutation' as const,
    DeleteBookmarkMutation: 'DeleteBookmarkMutation' as const,
    claimOnboardingConversionCreditMutation: 'claimOnboardingConversionCreditMutation' as const,
    skipOnboardingMutation: 'skipOnboardingMutation' as const,
    upsertStepLineupMutation: 'upsertStepLineupMutation' as const,
    upsertReplayTaskMutation: 'upsertReplayTaskMutation' as const,
    ClaimRewardsMutation: 'ClaimRewardsMutation' as const,
    ConfirmSo5LineupsMutation: 'ConfirmSo5LineupsMutation' as const,
    CreateOrUpdateSo5LineupMutation: 'CreateOrUpdateSo5LineupMutation' as const,
    DeleteSo5LineupMutation: 'DeleteSo5LineupMutation' as const,
    FootballLoadSuggestLineupMutation: 'FootballLoadSuggestLineupMutation' as const,
    UpdateManagerTeamMutation: 'UpdateManagerTeamMutation' as const,
    MarkSpotlightAsSeenMutation: 'MarkSpotlightAsSeenMutation' as const,
    CreateSquadMutation: 'CreateSquadMutation' as const,
    JoinSquadMutation: 'JoinSquadMutation' as const,
    UpdateSquadPrivacyMutation: 'UpdateSquadPrivacyMutation' as const,
    MarkStoriesAsReadMutation: 'MarkStoriesAsReadMutation' as const,
    CreateTaskPreparedLineupFromTaskLineupMutation: 'CreateTaskPreparedLineupFromTaskLineupMutation' as const,
    DeleteConnectedTaskMutation: 'DeleteConnectedTaskMutation' as const,
    DestroyTaskPreparedLineupMutation: 'DestroyTaskPreparedLineupMutation' as const,
    ReorderTaskPreparedLineupMutation: 'ReorderTaskPreparedLineupMutation' as const,
    RestartTasksTrackMutation: 'RestartTasksTrackMutation' as const,
    UpdateTaskConfigPreferencesMutation: 'UpdateTaskConfigPreferencesMutation' as const,
    UpdateTaskPreparedLineupsCarryOverMutation: 'UpdateTaskPreparedLineupsCarryOverMutation' as const,
    UpsertTaskPreparedLineupMutation: 'UpsertTaskPreparedLineupMutation' as const,
    useEnsureReferrerCodeMutation: 'useEnsureReferrerCodeMutation' as const,
    UpdateSo5LineupSettingsMutation: 'UpdateSo5LineupSettingsMutation' as const,
    RevealAllEarlyAccessCards: 'RevealAllEarlyAccessCards' as const,
    ConvertCraftCluesMutation: 'ConvertCraftCluesMutation' as const,
    MarkShardsThresholdAsSeen: 'MarkShardsThresholdAsSeen' as const,
    markAsProOnboardedMutation: 'markAsProOnboardedMutation' as const,
    SelectTeamClaimStarterPackMutation: 'SelectTeamClaimStarterPackMutation' as const,
    SquadLineupsStickyFooterAcknowledgeStepMutation: 'SquadLineupsStickyFooterAcknowledgeStepMutation' as const,
    ClaimFreeTicketMutation: 'ClaimFreeTicketMutation' as const,
    SpinWheelMutation: 'SpinWheelMutation' as const,
    DropAndAddCards: 'DropAndAddCards' as const,
    shareCardPackMutation: 'shareCardPackMutation' as const,
    claimCardsFromPackMutation: 'claimCardsFromPackMutation' as const,
    claimPackCardsOnCloseMutation: 'claimPackCardsOnCloseMutation' as const,
    claimBoughtPacksCountTaskMutation: 'claimBoughtPacksCountTaskMutation' as const,
    GenerateAccountingExtractMutation: 'GenerateAccountingExtractMutation' as const,
    SetTokenTradeStatus: 'SetTokenTradeStatus' as const,
    CreateOrUpdateSingleBuyOfferMinPriceMutation: 'CreateOrUpdateSingleBuyOfferMinPriceMutation' as const,
    SealingCardsMutation: 'SealingCardsMutation' as const,
    UnsealingCardsMutation: 'UnsealingCardsMutation' as const,
    AddToWatchlistMutation: 'AddToWatchlistMutation' as const,
    AddAuctionReminderMutation: 'AddAuctionReminderMutation' as const,
    BidWithWalletMutation: 'BidWithWalletMutation' as const,
    PrepareAcceptTradeWithWalletAndCreditCard: 'PrepareAcceptTradeWithWalletAndCreditCard' as const,
    PrepareBidMutation: 'PrepareBidMutation' as const,
    RemoveAuctionReminderMutation: 'RemoveAuctionReminderMutation' as const,
    StopAutoBidMutation: 'StopAutoBidMutation' as const,
    AcceptOfferMutation: 'AcceptOfferMutation' as const,
    ApproveMigratorMutation: 'ApproveMigratorMutation' as const,
    CancelOfferMutation: 'CancelOfferMutation' as const,
    CreateDirectOfferMutation: 'CreateDirectOfferMutation' as const,
    CreateSingleSaleOfferMutation: 'CreateSingleSaleOfferMutation' as const,
    PrepareAcceptOfferMutation: 'PrepareAcceptOfferMutation' as const,
    PrepareOfferMutation: 'PrepareOfferMutation' as const,
    RejectOfferMutation: 'RejectOfferMutation' as const,
    useBuyCardPackMutation: 'useBuyCardPackMutation' as const,
    useSeriesClaimDailyPackMutation: 'useSeriesClaimDailyPackMutation' as const,
    AddToCartMutation: 'AddToCartMutation' as const,
    RemoveFromCartMutation: 'RemoveFromCartMutation' as const,
    SaveForLaterMutation: 'SaveForLaterMutation' as const,
    RefreshCartMutation: 'RefreshCartMutation' as const,
    LevelUpCardsWithXpCurrencyMutation: 'LevelUpCardsWithXpCurrencyMutation' as const,
    VerifyIdentityMutation: 'VerifyIdentityMutation' as const,
    RemoveFromWatchlistMutation: 'RemoveFromWatchlistMutation' as const,
    UpsertWatchlistMutation: 'UpsertWatchlistMutation' as const,
    DestroyWatchlistMutation: 'DestroyWatchlistMutation' as const,
    UpdateSavedFiltersMutation: 'UpdateSavedFiltersMutation' as const,
    ConfirmEmailMutation: 'ConfirmEmailMutation' as const,
    confirmDevice: 'confirmDevice' as const,
    ClaimConversionCreditMutation: 'ClaimConversionCreditMutation' as const,
    UnsubscribeFromEmailsMutation: 'UnsubscribeFromEmailsMutation' as const
  },
  Subscription: {
    onDeviceWasUpdated: 'onDeviceWasUpdated' as const,
    onCurrentUserWasUpdated: 'onCurrentUserWasUpdated' as const,
    onMatchViewDataUpdated: 'onMatchViewDataUpdated' as const,
    CollectionCards_subscription: 'CollectionCards_subscription' as const,
    CurrentUserTaskWasUpdatedSubscription: 'CurrentUserTaskWasUpdatedSubscription' as const,
    SeriesHubOrbActivityWasHighlightedSubscription: 'SeriesHubOrbActivityWasHighlightedSubscription' as const,
    WeeklyDealsSection_remainingSupplyWasUpdated: 'WeeklyDealsSection_remainingSupplyWasUpdated' as const,
    onOfferUpdated: 'onOfferUpdated' as const,
    TokenAuctionUpdate: 'TokenAuctionUpdate' as const,
    TokenOfferUpdate: 'TokenOfferUpdate' as const,
    PrimaryOfferUpdate: 'PrimaryOfferUpdate' as const,
    GameBoxScoreGameSubscription: 'GameBoxScoreGameSubscription' as const,
    NbaScoutingCenterTeamStatsSubscription: 'NbaScoutingCenterTeamStatsSubscription' as const
  },
  Fragment: {
    TopHitterPitcher_anyGameInterface: 'TopHitterPitcher_anyGameInterface' as const,
    MLBBasicBenchCard_composeTeamBenchObjectInterface: 'MLBBasicBenchCard_composeTeamBenchObjectInterface' as const,
    MLBBasicBenchCard_appearanceRule: 'MLBBasicBenchCard_appearanceRule' as const,
    MLBBasicFilters_so5Leaderboard: 'MLBBasicFilters_so5Leaderboard' as const,
    MLBBasicMarketCard_anyCardInterface: 'MLBBasicMarketCard_anyCardInterface' as const,
    MLBBasicMarketCard_appearanceRule: 'MLBBasicMarketCard_appearanceRule' as const,
    MLBCompose_sharedBenchObjectFragment_composeTeamBenchObjectInterface: 'MLBCompose_sharedBenchObjectFragment_composeTeamBenchObjectInterface' as const,
    MLBCompose_composeTeamBenchObjectInterface: 'MLBCompose_composeTeamBenchObjectInterface' as const,
    MLBCompose_so5Leaderboard: 'MLBCompose_so5Leaderboard' as const,
    MLBCompose_so5Lineup: 'MLBCompose_so5Lineup' as const,
    MLBCompose_managerTeam: 'MLBCompose_managerTeam' as const,
    MLBFieldCard_composeTeamBenchObjectInterface: 'MLBFieldCard_composeTeamBenchObjectInterface' as const,
    MLBFieldCard_appearanceRule: 'MLBFieldCard_appearanceRule' as const,
    GameStatsCells_PlayerGameScoreInterface: 'GameStatsCells_PlayerGameScoreInterface' as const,
    PlayerRow_GameOfBaseball: 'PlayerRow_GameOfBaseball' as const,
    PlayerRow_BaseballPlayer: 'PlayerRow_BaseballPlayer' as const,
    GameBoxPlayersTable_So5Appearance: 'GameBoxPlayersTable_So5Appearance' as const,
    GameBoxPlayersTable_GameOfBaseball: 'GameBoxPlayersTable_GameOfBaseball' as const,
    GameBoxPlayersTable_BaseballPlayer: 'GameBoxPlayersTable_BaseballPlayer' as const,
    GameBoxScore_BaseballPlayer: 'GameBoxScore_BaseballPlayer' as const,
    GameBoxScore_GameOfBaseball: 'GameBoxScore_GameOfBaseball' as const,
    TeamBox_TeamInterface: 'TeamBox_TeamInterface' as const,
    TeamPlayers_BaseballPlayer: 'TeamPlayers_BaseballPlayer' as const,
    TeamPlayers_So5Appearance: 'TeamPlayers_So5Appearance' as const,
    TeamPlayers_TeamInterface: 'TeamPlayers_TeamInterface' as const,
    TeamProbablePitcher_So5Appearance: 'TeamProbablePitcher_So5Appearance' as const,
    TeamProbablePitcher_TeamInterface: 'TeamProbablePitcher_TeamInterface' as const,
    TeamProbablePitcher_BaseballPlayer: 'TeamProbablePitcher_BaseballPlayer' as const,
    TopPlayer_anyPlayerInterface: 'TopPlayer_anyPlayerInterface' as const,
    TopPlayer_teamInterface: 'TopPlayer_teamInterface' as const,
    UpcomingGameView_GameOfBaseball: 'UpcomingGameView_GameOfBaseball' as const,
    GameView_GameOfBaseball: 'GameView_GameOfBaseball' as const,
    BaseballSo5LineupSharing_so5Lineup: 'BaseballSo5LineupSharing_so5Lineup' as const,
    BaseballTeamSearch_teamInterface: 'BaseballTeamSearch_teamInterface' as const,
    getTeamStyleVariables_TeamInterface: 'getTeamStyleVariables_TeamInterface' as const,
    CardPicture_screenshottableCard: 'CardPicture_screenshottableCard' as const,
    Normal_card: 'Normal_card' as const,
    PlayerPicture_card: 'PlayerPicture_card' as const,
    Serial_card: 'Serial_card' as const,
    PicturePosition_card: 'PicturePosition_card' as const,
    getPicturePosition_ScreenshottableCard: 'getPicturePosition_ScreenshottableCard' as const,
    ArtEdition_card: 'ArtEdition_card' as const,
    GenericFoil_card: 'GenericFoil_card' as const,
    GenericNormal_card: 'GenericNormal_card' as const,
    BaseballCard2024Default_card: 'BaseballCard2024Default_card' as const,
    BaseballCardNormal2024Default_card: 'BaseballCardNormal2024Default_card' as const,
    BaseballCardNormal2024_card: 'BaseballCardNormal2024_card' as const,
    BaseballCard2024Postseason_card: 'BaseballCard2024Postseason_card' as const,
    PostseasonNormal_card: 'PostseasonNormal_card' as const,
    BaseballCard2024_card: 'BaseballCard2024_card' as const,
    BaseballCard2025Default_card: 'BaseballCard2025Default_card' as const,
    BaseballCard2025_card: 'BaseballCard2025_card' as const,
    BaseballCardNormal2025_card: 'BaseballCardNormal2025_card' as const,
    BaseballCardDefault2026_card: 'BaseballCardDefault2026_card' as const,
    BaseballCardEarlyAccess2026_card: 'BaseballCardEarlyAccess2026_card' as const,
    BaseballCard2026_card: 'BaseballCard2026_card' as const,
    BaseballNormal2026_card: 'BaseballNormal2026_card' as const,
    FootballCard2023Unlicensed_card: 'FootballCard2023Unlicensed_card' as const,
    FootballCard2023_card: 'FootballCard2023_card' as const,
    FootballNormal2023_card: 'FootballNormal2023_card' as const,
    FootballCardDefault2024_card: 'FootballCardDefault2024_card' as const,
    FootballCardEarlyAccess2024_card: 'FootballCardEarlyAccess2024_card' as const,
    FootballCard2024_card: 'FootballCard2024_card' as const,
    FootballNormal2024_card: 'FootballNormal2024_card' as const,
    FootballCardVintage2024_card: 'FootballCardVintage2024_card' as const,
    FootballCardDefault2025_card: 'FootballCardDefault2025_card' as const,
    FootballCardEarlyAccess2025_card: 'FootballCardEarlyAccess2025_card' as const,
    FootballCard2025_card: 'FootballCard2025_card' as const,
    FootballNormal2025_card: 'FootballNormal2025_card' as const,
    FootballCardDefault2026_card: 'FootballCardDefault2026_card' as const,
    FootballCardEarlyAccess2026_card: 'FootballCardEarlyAccess2026_card' as const,
    FootballCard2026_card: 'FootballCard2026_card' as const,
    FootballNormal2026_card: 'FootballNormal2026_card' as const,
    NBACardDefault2024_card: 'NBACardDefault2024_card' as const,
    NBACardEarlyAccess2024_card: 'NBACardEarlyAccess2024_card' as const,
    NBACard2024_card: 'NBACard2024_card' as const,
    NBACard2024Normal_card: 'NBACard2024Normal_card' as const,
    NBACardDefault2025_card: 'NBACardDefault2025_card' as const,
    NBACardDraft2025_card: 'NBACardDraft2025_card' as const,
    NBACardEarlyAccess2025_card: 'NBACardEarlyAccess2025_card' as const,
    NBACard2025_card: 'NBACard2025_card' as const,
    NBACard2025Normal_card: 'NBACard2025Normal_card' as const,
    NBACardDefault2026_card: 'NBACardDefault2026_card' as const,
    NBACardEarlyAccess2026_card: 'NBACardEarlyAccess2026_card' as const,
    NBACard2026_card: 'NBACard2026_card' as const,
    NBACard2026Normal_card: 'NBACard2026Normal_card' as const,
    NBACard2023Normal_card: 'NBACard2023Normal_card' as const,
    RewardIcon_AnyRewardInterface: 'RewardIcon_AnyRewardInterface' as const,
    FallbackPicture_anyCardInterface: 'FallbackPicture_anyCardInterface' as const,
    Card3DWithFallback_anyCardInterface: 'Card3DWithFallback_anyCardInterface' as const,
    DeliverableReward_deliverableItemInterface: 'DeliverableReward_deliverableItemInterface' as const,
    InGameCurrency3d_inGameCurrencyReward: 'InGameCurrency3d_inGameCurrencyReward' as const,
    InGameCurrency3d_ProbabilisticBundleSlotInGameCurrencyItem: 'InGameCurrency3d_ProbabilisticBundleSlotInGameCurrencyItem' as const,
    Reward_AnyRewardInterface: 'Reward_AnyRewardInterface' as const,
    CardSetChip_cardSet: 'CardSetChip_cardSet' as const,
    CommonShards_cardSet: 'CommonShards_cardSet' as const,
    InstructionsContainer_anyPlayer: 'InstructionsContainer_anyPlayer' as const,
    PlayerInformation_anyPlayer: 'PlayerInformation_anyPlayer' as const,
    Hero_card: 'Hero_card' as const,
    ScorePoints_card: 'ScorePoints_card' as const,
    HowToPlay_card: 'HowToPlay_card' as const,
    EssenceBalance_cardSet: 'EssenceBalance_cardSet' as const,
    AmountWithConversion_monetaryAmount: 'AmountWithConversion_monetaryAmount' as const,
    RewardTitle_AnyRewardInterface: 'RewardTitle_AnyRewardInterface' as const,
    BuyConfirmation_anyCard: 'BuyConfirmation_anyCard' as const,
    BuyConfirmation_anyReward: 'BuyConfirmation_anyReward' as const,
    CreditCard_creditCard: 'CreditCard_creditCard' as const,
    CardAvatar_anyCard: 'CardAvatar_anyCard' as const,
    BonusBreakdownTooltip_powerBreakdown: 'BonusBreakdownTooltip_powerBreakdown' as const,
    BonusBreakdownTooltip_so5AppearanceBonusInterface: 'BonusBreakdownTooltip_so5AppearanceBonusInterface' as const,
    BonusChip_powerBreakdown: 'BonusChip_powerBreakdown' as const,
    BonusChip_so5AppearanceBonusInterface: 'BonusChip_so5AppearanceBonusInterface' as const,
    Card_anyCard: 'Card_anyCard' as const,
    Card_composeTeamBenchObjectInterface: 'Card_composeTeamBenchObjectInterface' as const,
    Card_commonPlayer: 'Card_commonPlayer' as const,
    CardMeta_AnyCardInterface: 'CardMeta_AnyCardInterface' as const,
    CardMeta_anyPlayerInterface: 'CardMeta_anyPlayerInterface' as const,
    NBAGameplayTierBadge_anyPlayerInterface: 'NBAGameplayTierBadge_anyPlayerInterface' as const,
    earlyAccessOverlay2024_AnyCardInterface: 'earlyAccessOverlay2024_AnyCardInterface' as const,
    earlyAccessOverlay2025_AnyCardInterface: 'earlyAccessOverlay2025_AnyCardInterface' as const,
    earlyAccessOverlay2026_AnyCardInterface: 'earlyAccessOverlay2026_AnyCardInterface' as const,
    anyCardStatsOverlay2025_AnyCardInterface: 'anyCardStatsOverlay2025_AnyCardInterface' as const,
    anyCardStatsOverlay2026_AnyCardInterface: 'anyCardStatsOverlay2026_AnyCardInterface' as const,
    baseballStatsOverlay2025_AnyCardInterface: 'baseballStatsOverlay2025_AnyCardInterface' as const,
    drawHightlightedStat_AnyCardInterface: 'drawHightlightedStat_AnyCardInterface' as const,
    drawObtainedInfos_AnyCardInterface: 'drawObtainedInfos_AnyCardInterface' as const,
    drawOwner_AnyCardInterface: 'drawOwner_AnyCardInterface' as const,
    drawPlayerName_AnyCardInterface: 'drawPlayerName_AnyCardInterface' as const,
    footballStatsOverlay2024_AnyCardInterface: 'footballStatsOverlay2024_AnyCardInterface' as const,
    nbaStatsOverlay2024_AnyCardInterface: 'nbaStatsOverlay2024_AnyCardInterface' as const,
    celebrationOverlay_AnyCardInterface: 'celebrationOverlay_AnyCardInterface' as const,
    celebrationNormalOverlay_AnyCardInterface: 'celebrationNormalOverlay_AnyCardInterface' as const,
    earlyAccessOverlay_AnyCardInterface: 'earlyAccessOverlay_AnyCardInterface' as const,
    statsOverlay_AnyCardInterface: 'statsOverlay_AnyCardInterface' as const,
    UnsealableOverlay_anyCard: 'UnsealableOverlay_anyCard' as const,
    PlayerAppearance_composeTeamBenchObjectInterface: 'PlayerAppearance_composeTeamBenchObjectInterface' as const,
    StackedCards_anyCard: 'StackedCards_anyCard' as const,
    TeamAvatar_team: 'TeamAvatar_team' as const,
    CardSetLabel_cardSet: 'CardSetLabel_cardSet' as const,
    CollectionGameHelper_cardCollection: 'CollectionGameHelper_cardCollection' as const,
    CollectionOwner_publicUserInfoInterface: 'CollectionOwner_publicUserInfoInterface' as const,
    SimpleCollectionPreview_cardCollection: 'SimpleCollectionPreview_cardCollection' as const,
    SkinEditionChips_skinEdition: 'SkinEditionChips_skinEdition' as const,
    SplitProgressBar_cardCollection: 'SplitProgressBar_cardCollection' as const,
    SplitProgressBar_userCardCollection: 'SplitProgressBar_userCardCollection' as const,
    TaskCampaignDialog_taskCampaignsHomepageTutorial: 'TaskCampaignDialog_taskCampaignsHomepageTutorial' as const,
    FavoriteHeartButton_subscribable: 'FavoriteHeartButton_subscribable' as const,
    JonumVerificationFields: 'JonumVerificationFields' as const,
    AnySportPastWinner_so5Leaderboard: 'AnySportPastWinner_so5Leaderboard' as const,
    LeaderboardRow_publicUserInfoInterface: 'LeaderboardRow_publicUserInfoInterface' as const,
    DivisionLogo_so5Leaderboard: 'DivisionLogo_so5Leaderboard' as const,
    WarningRow_anyCard: 'WarningRow_anyCard' as const,
    LeaderboardStatus_so5Leaderboard: 'LeaderboardStatus_so5Leaderboard' as const,
    AccountEntry_userAccountEntry: 'AccountEntry_userAccountEntry' as const,
    AccountEntryState_userAccountEntry: 'AccountEntryState_userAccountEntry' as const,
    Deposit_userAccountEntry: 'Deposit_userAccountEntry' as const,
    InternalTransfer_userAccountEntry: 'InternalTransfer_userAccountEntry' as const,
    Withdrawal_userAccountEntry: 'Withdrawal_userAccountEntry' as const,
    MobileSeriesUserCurrencies_cardSet: 'MobileSeriesUserCurrencies_cardSet' as const,
    ShardRarityItem_cardShardsChest: 'ShardRarityItem_cardShardsChest' as const,
    MyClubPageHeader_user: 'MyClubPageHeader_user' as const,
    MyClubNavItem_UserSportProfileInterface: 'MyClubNavItem_UserSportProfileInterface' as const,
    UserNav_cardSet: 'UserNav_cardSet' as const,
    PromoBanner_conversionCredit: 'PromoBanner_conversionCredit' as const,
    InjuryTable_injury: 'InjuryTable_injury' as const,
    InjuryTagTemplate_injury: 'InjuryTagTemplate_injury' as const,
    NewsUpdates_PlayerNewsUpdate: 'NewsUpdates_PlayerNewsUpdate' as const,
    PlayerHandsInfo_AnyPlayerInterface: 'PlayerHandsInfo_AnyPlayerInterface' as const,
    NotificationPreference_subscription: 'NotificationPreference_subscription' as const,
    PrivacyPolicyDialog_dataPartner: 'PrivacyPolicyDialog_dataPartner' as const,
    Follower_subscription: 'Follower_subscription' as const,
    Follower_dataPartner: 'Follower_dataPartner' as const,
    ClaimReferralRewardsDialog_referralReward: 'ClaimReferralRewardsDialog_referralReward' as const,
    InProgressReferralBar_Referral: 'InProgressReferralBar_Referral' as const,
    ReadyToClaimReferralBar_ReferralReward: 'ReadyToClaimReferralBar_ReferralReward' as const,
    ReferralBar_currentUser: 'ReferralBar_currentUser' as const,
    BoostedRewardConfigText_anyRewardConfigInterface: 'BoostedRewardConfigText_anyRewardConfigInterface' as const,
    RewardConfigImage_anyRewardConfigInterface: 'RewardConfigImage_anyRewardConfigInterface' as const,
    RewardConfigText_anyRewardConfigInterface: 'RewardConfigText_anyRewardConfigInterface' as const,
    RewardMultiplier_lineup: 'RewardMultiplier_lineup' as const,
    AnyRewardConfig_anyRewardConfigInterface: 'AnyRewardConfig_anyRewardConfigInterface' as const,
    getAnyRewardConfigColors_anyRewardConfigInterface: 'getAnyRewardConfigColors_anyRewardConfigInterface' as const,
    Discount_MonetaryAmount: 'Discount_MonetaryAmount' as const,
    RewardCardPlaceholder_anyCardInterface: 'RewardCardPlaceholder_anyCardInterface' as const,
    RewardTooltip_AnyRewardInterface: 'RewardTooltip_AnyRewardInterface' as const,
    BenchObjectScore_composeTeamBenchObjectInterface: 'BenchObjectScore_composeTeamBenchObjectInterface' as const,
    CardScore_anyCard: 'CardScore_anyCard' as const,
    PlayerAppearance_anyPlayer: 'PlayerAppearance_anyPlayer' as const,
    PlayerGameScoreScore_playerGameScoreInterface: 'PlayerGameScoreScore_playerGameScoreInterface' as const,
    PlayerScore_anyPlayer: 'PlayerScore_anyPlayer' as const,
    Score_anyGameInterface: 'Score_anyGameInterface' as const,
    Header_subscription: 'Header_subscription' as const,
    Header_dataPartner: 'Header_dataPartner' as const,
    NewHeader_subscription: 'NewHeader_subscription' as const,
    NewHeader_dataPartner: 'NewHeader_dataPartner' as const,
    FullCardSupply_anyPlayerInterface: 'FullCardSupply_anyPlayerInterface' as const,
    Departures_TeamInterface: 'Departures_TeamInterface' as const,
    ApiKeyRow_apiKey: 'ApiKeyRow_apiKey' as const,
    Devices_UserDevice: 'Devices_UserDevice' as const,
    PasskeyRow_passkey: 'PasskeyRow_passkey' as const,
    DropdownSelector_notificationPreference: 'DropdownSelector_notificationPreference' as const,
    PreferenceToggleButton_notificationPreference: 'PreferenceToggleButton_notificationPreference' as const,
    NotificationPreference_notificationPreference: 'NotificationPreference_notificationPreference' as const,
    NotificationSection_notificationSection: 'NotificationSection_notificationSection' as const,
    OAuthApplicationRow_oAuthApplication: 'OAuthApplicationRow_oAuthApplication' as const,
    OAuthApplication_oAuthApplication: 'OAuthApplication_oAuthApplication' as const,
    PostalAddressForm_userSettings: 'PostalAddressForm_userSettings' as const,
    TokenMetas_anyCard: 'TokenMetas_anyCard' as const,
    ActiveUserAvatar_user: 'ActiveUserAvatar_user' as const,
    ActivityIndicator_user: 'ActivityIndicator_user' as const,
    Avatar_userSportProfileInterface: 'Avatar_userSportProfileInterface' as const,
    Avatar_user: 'Avatar_user' as const,
    Avatar_publicUserInfoInterface: 'Avatar_publicUserInfoInterface' as const,
    Avatar_anonymousUser: 'Avatar_anonymousUser' as const,
    Avatar_ethereumAccount: 'Avatar_ethereumAccount' as const,
    Avatar_starkwareAccount: 'Avatar_starkwareAccount' as const,
    BlockButton_publicUserInfoInterface: 'BlockButton_publicUserInfoInterface' as const,
    DiscordUser_userProfile: 'DiscordUser_userProfile' as const,
    MyClubLink_publicUserInfoInterface: 'MyClubLink_publicUserInfoInterface' as const,
    Nickname_publicUserInfoInterface: 'Nickname_publicUserInfoInterface' as const,
    SocialShare_Content_socialPictureDerivative: 'SocialShare_Content_socialPictureDerivative' as const,
    TwitterUser_userProfile: 'TwitterUser_userProfile' as const,
    UserName_publicUserInfoInterface: 'UserName_publicUserInfoInterface' as const,
    FastWithdrawal_fastWithdrawalWithRates: 'FastWithdrawal_fastWithdrawalWithRates' as const,
    PendingDeposit_pendingDeposit: 'PendingDeposit_pendingDeposit' as const,
    RecentActivity_userAccountEntry: 'RecentActivity_userAccountEntry' as const,
    BankAccount_bankAccount: 'BankAccount_bankAccount' as const,
    ReviewWithdrawFiat_bankAccount: 'ReviewWithdrawFiat_bankAccount' as const,
    useWithdrawalFee_bankAccount: 'useWithdrawalFee_bankAccount' as const,
    getAccountIdentifier_bankAccount: 'getAccountIdentifier_bankAccount' as const,
    WithdrawalItem_withdrawalWithRates: 'WithdrawalItem_withdrawalWithRates' as const,
    WithdrawalItem_fastWithdrawalWithRates: 'WithdrawalItem_fastWithdrawalWithRates' as const,
    ConfigProvider_TeamsPlayingNextGameWeek: 'ConfigProvider_TeamsPlayingNextGameWeek' as const,
    ConfigProvider_exchangeRate: 'ConfigProvider_exchangeRate' as const,
    ScoutableSo5Competitions_query: 'ScoutableSo5Competitions_query' as const,
    UpcomingSo5Fixture_query: 'UpcomingSo5Fixture_query' as const,
    CurrentUserProvider_userSportProfile: 'CurrentUserProvider_userSportProfile' as const,
    CurrentUserProvider_cardCounts: 'CurrentUserProvider_cardCounts' as const,
    CurrentUseProvider_sportProfile: 'CurrentUseProvider_sportProfile' as const,
    CurrentUserProvider_walletRecovery: 'CurrentUserProvider_walletRecovery' as const,
    CurrentUseProvider_ethereumAccounts: 'CurrentUseProvider_ethereumAccounts' as const,
    CurrentUseProvider_fiatAccounts: 'CurrentUseProvider_fiatAccounts' as const,
    CurrentUserProvider_anyCard: 'CurrentUserProvider_anyCard' as const,
    CurrentUserProvider_myCart: 'CurrentUserProvider_myCart' as const,
    CurrentUserProvider_conversionCreditsWithoutPurchase: 'CurrentUserProvider_conversionCreditsWithoutPurchase' as const,
    CurrentUserProvider_sportConversionCredits: 'CurrentUserProvider_sportConversionCredits' as const,
    CurrentUserProvider_completablePromotionalEventCompletion: 'CurrentUserProvider_completablePromotionalEventCompletion' as const,
    CurrentUserProvider_currentSportUnreadNotificationsCount: 'CurrentUserProvider_currentSportUnreadNotificationsCount' as const,
    commonCardMarketplace_currentUser: 'commonCardMarketplace_currentUser' as const,
    CurrentUserProvider_inGameCurrencyBalance: 'CurrentUserProvider_inGameCurrencyBalance' as const,
    CurrentUserProvider_availableBalances: 'CurrentUserProvider_availableBalances' as const,
    CurrentUserProvider_perSportProfiles: 'CurrentUserProvider_perSportProfiles' as const,
    CurrentUserProvider_currentUser: 'CurrentUserProvider_currentUser' as const,
    deckFragments_deck: 'deckFragments_deck' as const,
    PrivateKeyRecoveryPayloads_CurrentUser: 'PrivateKeyRecoveryPayloads_CurrentUser' as const,
    useClaimReferralReward_referralReward: 'useClaimReferralReward_referralReward' as const,
    useReferralRewards_referralReward: 'useReferralRewards_referralReward' as const,
    useAcceptedCurrencies_publicUserInfoInterface: 'useAcceptedCurrencies_publicUserInfoInterface' as const,
    useAmountWithConversion_monetaryAmount: 'useAmountWithConversion_monetaryAmount' as const,
    useAuctionConversionCredit_auction: 'useAuctionConversionCredit_auction' as const,
    useGetAuthorizationApprovals_authorizationRequest: 'useGetAuthorizationApprovals_authorizationRequest' as const,
    useMonetaryAmount_monetaryAmount: 'useMonetaryAmount_monetaryAmount' as const,
    useProbabilisticBundleConfigSummary_ProbabilisticBundleConfig: 'useProbabilisticBundleConfigSummary_ProbabilisticBundleConfig' as const,
    useProbableRewardConfigSummary_ProbableRewardConfig: 'useProbableRewardConfigSummary_ProbableRewardConfig' as const,
    useStoreAmount_primaryOffer: 'useStoreAmount_primaryOffer' as const,
    useTokenBelongsToUser_anyCard: 'useTokenBelongsToUser_anyCard' as const,
    useTokenOfferBelongsToUser_offer: 'useTokenOfferBelongsToUser_offer' as const,
    useActivityIndicator_user: 'useActivityIndicator_user' as const,
    Algolia_CardHit_anyCard: 'Algolia_CardHit_anyCard' as const,
    getCardSpecialEditionBonus_anyCardInterface: 'getCardSpecialEditionBonus_anyCardInterface' as const,
    getHumanReadableSerialNumber_anyCard: 'getHumanReadableSerialNumber_anyCard' as const,
    getName_anyCard: 'getName_anyCard' as const,
    isTokenListedOnMarket_anyCard: 'isTokenListedOnMarket_anyCard' as const,
    isMyCardListedOnMarket_anyCard: 'isMyCardListedOnMarket_anyCard' as const,
    isSentInDirectOffer_anyCard: 'isSentInDirectOffer_anyCard' as const,
    getAnimatedCardVideoSources_anyCardInterface: 'getAnimatedCardVideoSources_anyCardInterface' as const,
    getAnimatedCardVideoSources_composeTeamBenchObjectInterface: 'getAnimatedCardVideoSources_composeTeamBenchObjectInterface' as const,
    getOverlays_anyCardInterface: 'getOverlays_anyCardInterface' as const,
    getCardRepresentation_anyCardInterface: 'getCardRepresentation_anyCardInterface' as const,
    getShieldScoreRequirement_skinShopItem: 'getShieldScoreRequirement_skinShopItem' as const,
    getCollectionsShield_cardCollection: 'getCollectionsShield_cardCollection' as const,
    getRewardRGBColor_anyRewardConfigInterface: 'getRewardRGBColor_anyRewardConfigInterface' as const,
    getCommonCardShardsCount_currentUser: 'getCommonCardShardsCount_currentUser' as const,
    getDeliverableItemImageUrl_deliverableItem: 'getDeliverableItemImageUrl_deliverableItem' as const,
    getInGameCurrencyDescription_probabilisticBundleSlotItemInterface: 'getInGameCurrencyDescription_probabilisticBundleSlotItemInterface' as const,
    getInGameCurrencyDescription_InGameCurrencyReward: 'getInGameCurrencyDescription_InGameCurrencyReward' as const,
    getCardEligibleLeaderboards_anyCardInterface: 'getCardEligibleLeaderboards_anyCardInterface' as const,
    getCardRewardBoost_anyCardInterface: 'getCardRewardBoost_anyCardInterface' as const,
    MonetaryAmountFragment_monetaryAmount: 'MonetaryAmountFragment_monetaryAmount' as const,
    RatesFragment_rates: 'RatesFragment_rates' as const,
    getSortedAppearancesFromRules_so5Lineup: 'getSortedAppearancesFromRules_so5Lineup' as const,
    getSortedAppearancesFromRules_so5Leaderboard: 'getSortedAppearancesFromRules_so5Leaderboard' as const,
    getAppearancePercentage_anyPlayerInterface: 'getAppearancePercentage_anyPlayerInterface' as const,
    rewardsOverviewToSimpleRewards_rewardsOverview: 'rewardsOverviewToSimpleRewards_rewardsOverview' as const,
    parseRankingRewards_so5RewardConfig: 'parseRankingRewards_so5RewardConfig' as const,
    getPlayerPoolLeagues_so5Fixture: 'getPlayerPoolLeagues_so5Fixture' as const,
    mergeRewards_anyRewardInterface: 'mergeRewards_anyRewardInterface' as const,
    mergeRewardsConfig_anyRewardConfigInterface: 'mergeRewardsConfig_anyRewardConfigInterface' as const,
    getRewardImage_anyRewardInterface: 'getRewardImage_anyRewardInterface' as const,
    getRewardImage_anyRewardConfigInterface: 'getRewardImage_anyRewardConfigInterface' as const,
    formatLineupDisplayName_so5Lineup: 'formatLineupDisplayName_so5Lineup' as const,
    nationalTeamPictureUrl_nationalTeam: 'nationalTeamPictureUrl_nationalTeam' as const,
    teamPictureUrl_teamInterface: 'teamPictureUrl_teamInterface' as const,
    smallTeamPictureUrl_teamInterface: 'smallTeamPictureUrl_teamInterface' as const,
    isSpecialEventSo5LeaderboardType_so5Leaderboard: 'isSpecialEventSo5LeaderboardType_so5Leaderboard' as const,
    validateVaultRequirements_so5Leaderboard: 'validateVaultRequirements_so5Leaderboard' as const,
    leaderboardHasEntryFees_so5Leaderboard: 'leaderboardHasEntryFees_so5Leaderboard' as const,
    useCardSetBranding_cardSet: 'useCardSetBranding_cardSet' as const,
    BundledAuctionTitle_card: 'BundledAuctionTitle_card' as const,
    RelatedClub_club: 'RelatedClub_club' as const,
    RelatedNationalTeam_nationalTeam: 'RelatedNationalTeam_nationalTeam' as const,
    RelatedTeam_team: 'RelatedTeam_team' as const,
    TeamPicture_team: 'TeamPicture_team' as const,
    FootballBasicBenchCard_composeTeamBenchObjectInterface: 'FootballBasicBenchCard_composeTeamBenchObjectInterface' as const,
    FootballBasicMarketCard_anyCardInterface: 'FootballBasicMarketCard_anyCardInterface' as const,
    FootballCompose_composeTeamBenchObjectInterface: 'FootballCompose_composeTeamBenchObjectInterface' as const,
    FootballCompose_so5Leaderboard: 'FootballCompose_so5Leaderboard' as const,
    FootballCompose_so5Lineup: 'FootballCompose_so5Lineup' as const,
    FootballCompose_managerTeam: 'FootballCompose_managerTeam' as const,
    BaseObjectiveBar_so5Leaderboard: 'BaseObjectiveBar_so5Leaderboard' as const,
    sharedBenchObjectFragment_composeTeamBenchObjectInterface: 'sharedBenchObjectFragment_composeTeamBenchObjectInterface' as const,
    FootballComposeBench_so5Root: 'FootballComposeBench_so5Root' as const,
    FootballComposeBench_so5Leaderboard: 'FootballComposeBench_so5Leaderboard' as const,
    FootballComposeBench_composeTeamBenchObjectInterface: 'FootballComposeBench_composeTeamBenchObjectInterface' as const,
    FootballComposeBench_composeTeamBenchObjectInterfaceConnection: 'FootballComposeBench_composeTeamBenchObjectInterfaceConnection' as const,
    FootballComposeBench_so5LineupPreview: 'FootballComposeBench_so5LineupPreview' as const,
    FootballComposeBench_so5AppearanceBonusInterface: 'FootballComposeBench_so5AppearanceBonusInterface' as const,
    FootballFieldCard_composeTeamBenchObjectInterface: 'FootballFieldCard_composeTeamBenchObjectInterface' as const,
    FootballFieldCard_appearanceRule: 'FootballFieldCard_appearanceRule' as const,
    FootballFieldCard_so5AppearancePreview: 'FootballFieldCard_so5AppearancePreview' as const,
    FootballBasicFilters_so5Leaderboard: 'FootballBasicFilters_so5Leaderboard' as const,
    FootballSo5LineupSharing_so5Lineup: 'FootballSo5LineupSharing_so5Lineup' as const,
    PromoButton_conversionCredit: 'PromoButton_conversionCredit' as const,
    ScoutingCenterHeader_so5LeaderboardGroup: 'ScoutingCenterHeader_so5LeaderboardGroup' as const,
    ScoutingCenterHeader_so5Competition: 'ScoutingCenterHeader_so5Competition' as const,
    ScoutingCenterHeader_competition: 'ScoutingCenterHeader_competition' as const,
    TopPlayers_player: 'TopPlayers_player' as const,
    CardCollection_cardCollection: 'CardCollection_cardCollection' as const,
    CardCollection_user: 'CardCollection_user' as const,
    FixtureCompetitionPage_so5LeaderboardGroupInterface: 'FixtureCompetitionPage_so5LeaderboardGroupInterface' as const,
    TrckGroupCompetitionPrizePool_so5LeaderboardGroupInterface: 'TrckGroupCompetitionPrizePool_so5LeaderboardGroupInterface' as const,
    ThresholdReward_anyRewardConfig: 'ThresholdReward_anyRewardConfig' as const,
    ThresholdReward_TaskCampaign: 'ThresholdReward_TaskCampaign' as const,
    ThresholdRewardCollapseItem_taskCampaign: 'ThresholdRewardCollapseItem_taskCampaign' as const,
    ThresholdRewardCollapseItem_thresholdStreakTaskThreshold: 'ThresholdRewardCollapseItem_thresholdStreakTaskThreshold' as const,
    ThresholdRewardsCollapse_taskCampaign: 'ThresholdRewardsCollapse_taskCampaign' as const,
    ThresholdRewardsCollapse_thresholdStreakTaskThreshold: 'ThresholdRewardsCollapse_thresholdStreakTaskThreshold' as const,
    ThresholdScore_thresholdStreakTaskThreshold: 'ThresholdScore_thresholdStreakTaskThreshold' as const,
    ThresholdsBar_thresholdStreakTaskThreshold: 'ThresholdsBar_thresholdStreakTaskThreshold' as const,
    TrckGroupPVECompetitionPrizePool_thresholdsStreakTask: 'TrckGroupPVECompetitionPrizePool_thresholdsStreakTask' as const,
    TrckGroupPVECompetitionPrizePool_so5Leaderboard: 'TrckGroupPVECompetitionPrizePool_so5Leaderboard' as const,
    FixtureCompetitionTrckPage_so5LeaderboardGroupInterface: 'FixtureCompetitionTrckPage_so5LeaderboardGroupInterface' as const,
    LeaderboardGroupTeams_so5LeaderboardGroupInterface: 'LeaderboardGroupTeams_so5LeaderboardGroupInterface' as const,
    LegacyPlayEventTypeFixturePage_nextSo5Fixture: 'LegacyPlayEventTypeFixturePage_nextSo5Fixture' as const,
    LegacyPlayEventTypeFixturePage_so5Fixture: 'LegacyPlayEventTypeFixturePage_so5Fixture' as const,
    FootballBench_anyPlayer: 'FootballBench_anyPlayer' as const,
    FootballBench_anyPlayerInterfaceSubscription: 'FootballBench_anyPlayerInterfaceSubscription' as const,
    FootballField_game: 'FootballField_game' as const,
    FootballField_gameSubscription: 'FootballField_gameSubscription' as const,
    Formation_game: 'Formation_game' as const,
    Formation_gameSubscription: 'Formation_gameSubscription' as const,
    MatchPlayingStatusOdds_game: 'MatchPlayingStatusOdds_game' as const,
    Overview_game: 'Overview_game' as const,
    Player_anyPlayer: 'Player_anyPlayer' as const,
    Player_anyPlayerInterfaceSubscription: 'Player_anyPlayerInterfaceSubscription' as const,
    PlayerDetailsHeaderStats_anyPlayerInterface: 'PlayerDetailsHeaderStats_anyPlayerInterface' as const,
    PlayerDetailsHeaderStats_playerGameScoreInterface: 'PlayerDetailsHeaderStats_playerGameScoreInterface' as const,
    MatchView_gameSubscription: 'MatchView_gameSubscription' as const,
    MatchView_game: 'MatchView_game' as const,
    PlayEventTypeFixturePage_nextSo5Fixture: 'PlayEventTypeFixturePage_nextSo5Fixture' as const,
    PlayEventTypeFixturePage_so5Fixture: 'PlayEventTypeFixturePage_so5Fixture' as const,
    NotRevealable_AnyCardInterface: 'NotRevealable_AnyCardInterface' as const,
    PlayerChanged_AnyCardInterface: 'PlayerChanged_AnyCardInterface' as const,
    RevealCeremony_AnyCardInterface: 'RevealCeremony_AnyCardInterface' as const,
    BlueprintCountByRarity_CurrentUser: 'BlueprintCountByRarity_CurrentUser' as const,
    Announcement_announcement: 'Announcement_announcement' as const,
    DumbNotification_userAvatar: 'DumbNotification_userAvatar' as const,
    AnnouncementNotification_announcementNotification: 'AnnouncementNotification_announcementNotification' as const,
    Rewards_anyRewardInterface: 'Rewards_anyRewardInterface' as const,
    AuctionNotification_auctionNotification: 'AuctionNotification_auctionNotification' as const,
    AuctionLink_auction: 'AuctionLink_auction' as const,
    TokenAuction_auctionReminderNotification: 'TokenAuction_auctionReminderNotification' as const,
    ReminderNotification_auctionReminderNotification: 'ReminderNotification_auctionReminderNotification' as const,
    AutoClaimNotification_autoClaimNotification: 'AutoClaimNotification_autoClaimNotification' as const,
    CardCollectionNotification_cardCollectionNotification: 'CardCollectionNotification_cardCollectionNotification' as const,
    CardNotification_cardNotification: 'CardNotification_cardNotification' as const,
    ConversionCreditNotification_ConversionCreditNotification: 'ConversionCreditNotification_ConversionCreditNotification' as const,
    ExternalDepositNotification_externalDepositNotification: 'ExternalDepositNotification_externalDepositNotification' as const,
    InGameCurrencyNotification_inGameCurrencyNotification: 'InGameCurrencyNotification_inGameCurrencyNotification' as const,
    KycRequestNotification_kycRequestNotification: 'KycRequestNotification_kycRequestNotification' as const,
    MarketingNotification_marketingNotification: 'MarketingNotification_marketingNotification' as const,
    OfferNotification_offerNotification: 'OfferNotification_offerNotification' as const,
    ReferralRewardNotification_referralRewardNotification: 'ReferralRewardNotification_referralRewardNotification' as const,
    SaleNotification_saleNotification: 'SaleNotification_saleNotification' as const,
    So5LineupNotification_so5LineupNotification: 'So5LineupNotification_so5LineupNotification' as const,
    TaskNotification_taskNotification: 'TaskNotification_taskNotification' as const,
    UserRelationNotification_userRelationNotification: 'UserRelationNotification_userRelationNotification' as const,
    Notification_notificationInterface: 'Notification_notificationInterface' as const,
    Notification_notification: 'Notification_notification' as const,
    So5AppearanceScore_so5Appearance: 'So5AppearanceScore_so5Appearance' as const,
    ArenaBoardFixtureSelector_so5Leaderboard: 'ArenaBoardFixtureSelector_so5Leaderboard' as const,
    ArenaCostChip_anyRewardConfigInterface: 'ArenaCostChip_anyRewardConfigInterface' as const,
    ArenaEntries_so5LeaderboardGroupInterface: 'ArenaEntries_so5LeaderboardGroupInterface' as const,
    ArenaEntryBlock_so5Leaderboard: 'ArenaEntryBlock_so5Leaderboard' as const,
    ArenaEntryBlock_so5LeaderboardGroupInterface: 'ArenaEntryBlock_so5LeaderboardGroupInterface' as const,
    ArenaEntryBlocks_so5LeaderboardGroupInterface: 'ArenaEntryBlocks_so5LeaderboardGroupInterface' as const,
    ArenaGameList_gameDates: 'ArenaGameList_gameDates' as const,
    ArenaLineupPlaceholder_so5Leaderboard: 'ArenaLineupPlaceholder_so5Leaderboard' as const,
    ArenaLineupsFilter_so5LeaderboardGroupInterface: 'ArenaLineupsFilter_so5LeaderboardGroupInterface' as const,
    ArenaTableRow_so5Leaderboard: 'ArenaTableRow_so5Leaderboard' as const,
    ArenaTableRow_so5LeaderboardGroupInterface: 'ArenaTableRow_so5LeaderboardGroupInterface' as const,
    ArenaTable_so5LeaderboardGroupInterface: 'ArenaTable_so5LeaderboardGroupInterface' as const,
    LineupsCountTooltip_so5Leaderboard: 'LineupsCountTooltip_so5Leaderboard' as const,
    ThresholdsStreakTarget_so5Leaderboard: 'ThresholdsStreakTarget_so5Leaderboard' as const,
    LeaderboardBoardTile_so5Leaderboard: 'LeaderboardBoardTile_so5Leaderboard' as const,
    RewardTaskCampaignWidget_so5LeagueTrack: 'RewardTaskCampaignWidget_so5LeagueTrack' as const,
    So5LeaderboardLineupsHeader_so5Leaderboard: 'So5LeaderboardLineupsHeader_so5Leaderboard' as const,
    Matchups_playerGameScoreInterface: 'Matchups_playerGameScoreInterface' as const,
    MatchupsWithPlayedInfo_playerGameScoreInterface: 'MatchupsWithPlayedInfo_playerGameScoreInterface' as const,
    ArcadeKycVerificationBanner_careerStep: 'ArcadeKycVerificationBanner_careerStep' as const,
    ArcadeTaskProgress_careerStep: 'ArcadeTaskProgress_careerStep' as const,
    CareerTaskLineupsStickyFooter_task: 'CareerTaskLineupsStickyFooter_task' as const,
    ProKycVerificationBanner_thresholdPickerTask: 'ProKycVerificationBanner_thresholdPickerTask' as const,
    ProTaskProgress_thresholdPickerTask: 'ProTaskProgress_thresholdPickerTask' as const,
    TaskLineupsHeader_anyRewardConfigInterface: 'TaskLineupsHeader_anyRewardConfigInterface' as const,
    TaskLineupsHeader_task: 'TaskLineupsHeader_task' as const,
    TaskLineupsStickyFooter_task: 'TaskLineupsStickyFooter_task' as const,
    TaskLineupsStickyFooter_careerStep: 'TaskLineupsStickyFooter_careerStep' as const,
    TaskLineupsStickyFooter_currentUser: 'TaskLineupsStickyFooter_currentUser' as const,
    ArcadeHotStreakTile_careerStep: 'ArcadeHotStreakTile_careerStep' as const,
    ArcadeLifes_careerStep: 'ArcadeLifes_careerStep' as const,
    TaskTooltipContent_thresholdPickerTask: 'TaskTooltipContent_thresholdPickerTask' as const,
    TaskTooltipContent_careerStep: 'TaskTooltipContent_careerStep' as const,
    TileReward_anyRewardConfigInterface: 'TileReward_anyRewardConfigInterface' as const,
    TooltipContent_anyRewardConfigInterface: 'TooltipContent_anyRewardConfigInterface' as const,
    ProBoardTimer_thresholdPickerTask: 'ProBoardTimer_thresholdPickerTask' as const,
    ProHotStreakTile_thresholdPickerTask: 'ProHotStreakTile_thresholdPickerTask' as const,
    ProLifes_thresholdPickerTask: 'ProLifes_thresholdPickerTask' as const,
    BoardShortcutRow_careerBoard: 'BoardShortcutRow_careerBoard' as const,
    LeaderboardShortcutRow_so5Leaderboard: 'LeaderboardShortcutRow_so5Leaderboard' as const,
    ShortcutsList_bookmark: 'ShortcutsList_bookmark' as const,
    CardPage_ItemEligibility_card: 'CardPage_ItemEligibility_card' as const,
    Bonuses_card: 'Bonuses_card' as const,
    CollectionInfo_card: 'CollectionInfo_card' as const,
    ChampionshipCompetitionSelect_so5UserGroup: 'ChampionshipCompetitionSelect_so5UserGroup' as const,
    ChampionshipLeaderboard_so5UserGroup: 'ChampionshipLeaderboard_so5UserGroup' as const,
    ChampionshipLineupPosition_so5LeaderboardContender: 'ChampionshipLineupPosition_so5LeaderboardContender' as const,
    ChampionshipPage_so5UserGroup: 'ChampionshipPage_so5UserGroup' as const,
    ChampionshipPage_user: 'ChampionshipPage_user' as const,
    ChampionshipPreview_so5UserGroup: 'ChampionshipPreview_so5UserGroup' as const,
    ChampionshipRaritySelect_so5UserGroup: 'ChampionshipRaritySelect_so5UserGroup' as const,
    ChampionshipStoryTitle_userGroupMembershipShopItemsUpdate: 'ChampionshipStoryTitle_userGroupMembershipShopItemsUpdate' as const,
    ChampionshipStory_userGroupMembershipShopItemsUpdate: 'ChampionshipStory_userGroupMembershipShopItemsUpdate' as const,
    ChampionshipUserLineups_user: 'ChampionshipUserLineups_user' as const,
    ChampionshipUserLineups_so5UserGroup: 'ChampionshipUserLineups_so5UserGroup' as const,
    AllStepsProgressBar_cardCollection: 'AllStepsProgressBar_cardCollection' as const,
    CardPreview_cardCollectionCard: 'CardPreview_cardCollectionCard' as const,
    CardPreview_cardCollection: 'CardPreview_cardCollection' as const,
    CardsCountBadge_userCardCollectionSlot: 'CardsCountBadge_userCardCollectionSlot' as const,
    CollectionBonuses_cardCollectionCard: 'CollectionBonuses_cardCollectionCard' as const,
    CollectionHeader_cardCollection: 'CollectionHeader_cardCollection' as const,
    CollectionHeader_userCardCollection: 'CollectionHeader_userCardCollection' as const,
    CollectionLeaderboardRow_userCardCollection: 'CollectionLeaderboardRow_userCardCollection' as const,
    CollectionLeaderboard_userCardCollection: 'CollectionLeaderboard_userCardCollection' as const,
    CollectionPreviewHeader_cardCollection: 'CollectionPreviewHeader_cardCollection' as const,
    CollectionPreviewStats_userCardCollection: 'CollectionPreviewStats_userCardCollection' as const,
    CollectionSlotsStats_userCardCollection: 'CollectionSlotsStats_userCardCollection' as const,
    EmptyCollection_cardCollection: 'EmptyCollection_cardCollection' as const,
    CollectionPreview_cardCollection: 'CollectionPreview_cardCollection' as const,
    useCardCollectionData_cardCollection: 'useCardCollectionData_cardCollection' as const,
    CollectionSlots_anyPlayer: 'CollectionSlots_anyPlayer' as const,
    CollectionSlots_userCardCollectionSlot: 'CollectionSlots_userCardCollectionSlot' as const,
    CollectionSlots_cardCollection: 'CollectionSlots_cardCollection' as const,
    CollectionsFilters_cardCollectionConnection: 'CollectionsFilters_cardCollectionConnection' as const,
    CommonCollectionPreview_cardCollection: 'CommonCollectionPreview_cardCollection' as const,
    DetailsDialog_cardCollection: 'DetailsDialog_cardCollection' as const,
    EmptyCommonSlot_userCardCollectionSlot: 'EmptyCommonSlot_userCardCollectionSlot' as const,
    EmptyCommonSlot_cardCollectionSlot: 'EmptyCommonSlot_cardCollectionSlot' as const,
    FulfilledSlot_userCardCollectionSlot: 'FulfilledSlot_userCardCollectionSlot' as const,
    FulfilledSlot_cardCollection: 'FulfilledSlot_cardCollection' as const,
    CompleteCollectionModal_anyCard: 'CompleteCollectionModal_anyCard' as const,
    LevelUpModal_anyCard: 'LevelUpModal_anyCard' as const,
    LevelUpModal_cardCollection: 'LevelUpModal_cardCollection' as const,
    LevelUpModal_userCardCollection: 'LevelUpModal_userCardCollection' as const,
    ProgressBar_cardCollection: 'ProgressBar_cardCollection' as const,
    SlotsPreview_cardCollection: 'SlotsPreview_cardCollection' as const,
    getTeamStyleVariables_team: 'getTeamStyleVariables_team' as const,
    CommonPacks_marketRoot: 'CommonPacks_marketRoot' as const,
    CommonPacks_cardSetRoot: 'CommonPacks_cardSetRoot' as const,
    CommonPacks_currentUser: 'CommonPacks_currentUser' as const,
    AddToCartWrapper_anyCardInterface: 'AddToCartWrapper_anyCardInterface' as const,
    AdvancedBench_so5Leaderboard: 'AdvancedBench_so5Leaderboard' as const,
    AdvancedBench_appearanceRule: 'AdvancedBench_appearanceRule' as const,
    AdvancedBenchCard_composeTeamBenchObjectInterface: 'AdvancedBenchCard_composeTeamBenchObjectInterface' as const,
    AdvancedMarket_searchPlayers: 'AdvancedMarket_searchPlayers' as const,
    AdvancedMarketCard_anyCardInterface: 'AdvancedMarketCard_anyCardInterface' as const,
    ArenaEntryConfirmDialog_so5Leaderboard: 'ArenaEntryConfirmDialog_so5Leaderboard' as const,
    AsideHeader_so5Leaderboard: 'AsideHeader_so5Leaderboard' as const,
    AsideHeader_composeTeamBenchObjectInterface: 'AsideHeader_composeTeamBenchObjectInterface' as const,
    BasicBench_so5Leaderboard: 'BasicBench_so5Leaderboard' as const,
    BasicBench_appearanceRule: 'BasicBench_appearanceRule' as const,
    BasicMarketCard_anyCardInterface: 'BasicMarketCard_anyCardInterface' as const,
    BenchExtraInjury_anyPlayerInterface: 'BenchExtraInjury_anyPlayerInterface' as const,
    BenchExtra_anyCardInterface: 'BenchExtra_anyCardInterface' as const,
    BenchExtra_anyPlayerInterface: 'BenchExtra_anyPlayerInterface' as const,
    BenchExtra_suspension: 'BenchExtra_suspension' as const,
    BenchExtraInjuryTooltip_injury: 'BenchExtraInjuryTooltip_injury' as const,
    BenchExtraTooltip_so5Lineup: 'BenchExtraTooltip_so5Lineup' as const,
    BenchExtraTooltip_anyCardInterface: 'BenchExtraTooltip_anyCardInterface' as const,
    BenchExtraTooltip_anyPlayerInterface: 'BenchExtraTooltip_anyPlayerInterface' as const,
    BenchExtraTooltip_suspension: 'BenchExtraTooltip_suspension' as const,
    BenchObjectFooter_composeTeamBenchObjectInterface: 'BenchObjectFooter_composeTeamBenchObjectInterface' as const,
    BenchObjectFooter_so5AppearancePreview: 'BenchObjectFooter_so5AppearancePreview' as const,
    BenchObjectMetasCell_composeTeamBenchObjectInterface: 'BenchObjectMetasCell_composeTeamBenchObjectInterface' as const,
    CardMetasCell_anyCardInterface: 'CardMetasCell_anyCardInterface' as const,
    getCardUsage_cardUsageInterface: 'getCardUsage_cardUsageInterface' as const,
    Compose_so5Leaderboard: 'Compose_so5Leaderboard' as const,
    Compose_so5Lineup: 'Compose_so5Lineup' as const,
    Compose_benchQuerySo5Leaderboard: 'Compose_benchQuerySo5Leaderboard' as const,
    Compose_so5LineupPreview: 'Compose_so5LineupPreview' as const,
    Compose_managerTeam: 'Compose_managerTeam' as const,
    Compose_composeTeamBenchObjectInterface: 'Compose_composeTeamBenchObjectInterface' as const,
    useComposeState_so5Leaderboard: 'useComposeState_so5Leaderboard' as const,
    useComposeState_composeTeamBenchObjectInterface: 'useComposeState_composeTeamBenchObjectInterface' as const,
    useComposeState_so5Lineup: 'useComposeState_so5Lineup' as const,
    useComposeState_managerTeam: 'useComposeState_managerTeam' as const,
    EmptyBench_cardPack: 'EmptyBench_cardPack' as const,
    FieldCard_composeTeamBenchObjectInterface: 'FieldCard_composeTeamBenchObjectInterface' as const,
    FieldCard_appearanceRule: 'FieldCard_appearanceRule' as const,
    FieldHeader_so5Leaderboard: 'FieldHeader_so5Leaderboard' as const,
    FieldHeader_managerTeam: 'FieldHeader_managerTeam' as const,
    FieldHeader_so5LineupPreview: 'FieldHeader_so5LineupPreview' as const,
    FieldHeader_benchSo5RewardConfig: 'FieldHeader_benchSo5RewardConfig' as const,
    FieldHeader_composeTeamBenchObjectInterface: 'FieldHeader_composeTeamBenchObjectInterface' as const,
    FieldHeader_so5AppearanceBonusInterface: 'FieldHeader_so5AppearanceBonusInterface' as const,
    LeaderboardHeader_so5Leaderboard: 'LeaderboardHeader_so5Leaderboard' as const,
    LeaderboardHeader_managerTeam: 'LeaderboardHeader_managerTeam' as const,
    LeaderboardHeader_benchSo5RewardConfig: 'LeaderboardHeader_benchSo5RewardConfig' as const,
    LeaderboardHeader_so5LineupPreview: 'LeaderboardHeader_so5LineupPreview' as const,
    MarketCardFooterPrice_anyCardInterface: 'MarketCardFooterPrice_anyCardInterface' as const,
    NBAMarketCardFooter_anyCardInterface: 'NBAMarketCardFooter_anyCardInterface' as const,
    MarketCardFooter_anyCardInterface: 'MarketCardFooter_anyCardInterface' as const,
    MobileFooterActions_so5AppearanceBonusInterface: 'MobileFooterActions_so5AppearanceBonusInterface' as const,
    MobileFooterActions_so5LineupPreview: 'MobileFooterActions_so5LineupPreview' as const,
    MobileFooterActions_so5Leaderboard: 'MobileFooterActions_so5Leaderboard' as const,
    MobileSlot_composeTeamBenchObjectInterface: 'MobileSlot_composeTeamBenchObjectInterface' as const,
    MobileSlot_appearanceRule: 'MobileSlot_appearanceRule' as const,
    NBACardFooterWithGame_anyPlayerInterface: 'NBACardFooterWithGame_anyPlayerInterface' as const,
    NBACardFooterWithGame_playerGameScoreInterface: 'NBACardFooterWithGame_playerGameScoreInterface' as const,
    NBAGameplayTierStarsCell_anyPlayerInterface: 'NBAGameplayTierStarsCell_anyPlayerInterface' as const,
    RewardBoostDropdown_so5LineupPreview: 'RewardBoostDropdown_so5LineupPreview' as const,
    RewardBoostPill_composeTeamLineupPreview: 'RewardBoostPill_composeTeamLineupPreview' as const,
    RewardBoostRow_rewardBoost: 'RewardBoostRow_rewardBoost' as const,
    RewardBoostsDialog_rewardMultiplierConfiguration: 'RewardBoostsDialog_rewardMultiplierConfiguration' as const,
    LineupBonusesExplanation_so5AppearanceBonusInterface: 'LineupBonusesExplanation_so5AppearanceBonusInterface' as const,
    RulesPrizePoolDrawer_so5Leaderboard: 'RulesPrizePoolDrawer_so5Leaderboard' as const,
    RulesPrizePoolDrawer_so5RuleFeedback: 'RulesPrizePoolDrawer_so5RuleFeedback' as const,
    RulesPrizePoolDrawer_so5AppearanceBonusInterface: 'RulesPrizePoolDrawer_so5AppearanceBonusInterface' as const,
    So5LeaderboardRulesDropdown_so5Leaderboard: 'So5LeaderboardRulesDropdown_so5Leaderboard' as const,
    So5LeaderboardRulesDropdown_so5RuleFeedback: 'So5LeaderboardRulesDropdown_so5RuleFeedback' as const,
    useStarPreviewHover_composeTeamBenchObjectInterface: 'useStarPreviewHover_composeTeamBenchObjectInterface' as const,
    TaskRulesDropdown_taskInterface: 'TaskRulesDropdown_taskInterface' as const,
    TaskRulesDropdown_so5RuleFeedback: 'TaskRulesDropdown_so5RuleFeedback' as const,
    UnlockableRewards_so5RewardConfigFragment: 'UnlockableRewards_so5RewardConfigFragment' as const,
    UnlockableRewards_benchSo5RewardConfig: 'UnlockableRewards_benchSo5RewardConfig' as const,
    UnlockableRewards_so5RewardConfig: 'UnlockableRewards_so5RewardConfig' as const,
    AdvancedStarterOddsFilter_so5Leaderboard: 'AdvancedStarterOddsFilter_so5Leaderboard' as const,
    RaritiesFilter_displayedTypedRules: 'RaritiesFilter_displayedTypedRules' as const,
    RequiredEditionsFilter_displayedTypedRules: 'RequiredEditionsFilter_displayedTypedRules' as const,
    SortFilter_sortingType: 'SortFilter_sortingType' as const,
    StarterOddsFilter_so5Leaderboard: 'StarterOddsFilter_so5Leaderboard' as const,
    StarterOddsFilterWrapper_so5Leaderboard: 'StarterOddsFilterWrapper_so5Leaderboard' as const,
    TasksDetails_thresholdsStreakTask: 'TasksDetails_thresholdsStreakTask' as const,
    TasksDropdown_so5Leaderboard: 'TasksDropdown_so5Leaderboard' as const,
    LineupSetAnimation_so5Leaderboard: 'LineupSetAnimation_so5Leaderboard' as const,
    Thresholds_so5Leaderboard: 'Thresholds_so5Leaderboard' as const,
    CompactContender_so5LeaderboardContender: 'CompactContender_so5LeaderboardContender' as const,
    ContenderDrawerContent_so5LeaderboardContender: 'ContenderDrawerContent_so5LeaderboardContender' as const,
    ContenderDrawer_so5LeaderboardContender: 'ContenderDrawer_so5LeaderboardContender' as const,
    CardConfirmedDialog_anyCardInterface: 'CardConfirmedDialog_anyCardInterface' as const,
    CardPullExperienceView_cardPullConfig: 'CardPullExperienceView_cardPullConfig' as const,
    CardPullExperienceView_currentUser: 'CardPullExperienceView_currentUser' as const,
    CardPullExperienceView_cardShardsChest: 'CardPullExperienceView_cardShardsChest' as const,
    CardPullExperienceView_anyCardInterface: 'CardPullExperienceView_anyCardInterface' as const,
    EssenceFlavours_cardPull: 'EssenceFlavours_cardPull' as const,
    CardPullInfos_cardPullConfig: 'CardPullInfos_cardPullConfig' as const,
    CardPullInfos_cardShardsChest: 'CardPullInfos_cardShardsChest' as const,
    CardPullInfos_cardPull: 'CardPullInfos_cardPull' as const,
    CardPullRulesButton_cardPullConfig: 'CardPullRulesButton_cardPullConfig' as const,
    CardPullRulesButton_cardShardsChest: 'CardPullRulesButton_cardShardsChest' as const,
    AvailableCompetitions_competition: 'AvailableCompetitions_competition' as const,
    Clues_cardPullConfig: 'Clues_cardPullConfig' as const,
    OddsDescription_cardShardsChest: 'OddsDescription_cardShardsChest' as const,
    DrawAndOdds_cardShardsChest: 'DrawAndOdds_cardShardsChest' as const,
    CardPullRulesDialog_cardPullConfig: 'CardPullRulesDialog_cardPullConfig' as const,
    CardPullRulesDialog_cardShardsChest: 'CardPullRulesDialog_cardShardsChest' as const,
    CraftCluesBalance_cardPullConfig: 'CraftCluesBalance_cardPullConfig' as const,
    RaritySwitcher_cardsShardChest: 'RaritySwitcher_cardsShardChest' as const,
    CardsPull_cardPullConfig: 'CardsPull_cardPullConfig' as const,
    CardsPull_cardShardsChest: 'CardsPull_cardShardsChest' as const,
    AnimatedCardFooter_anyCardInterface: 'AnimatedCardFooter_anyCardInterface' as const,
    AnimatedCardFooter_cardPulledCard: 'AnimatedCardFooter_cardPulledCard' as const,
    AnimatedCards_cardPull: 'AnimatedCards_cardPull' as const,
    useAnimatedCardStyles_cardPullCard: 'useAnimatedCardStyles_cardPullCard' as const,
    BestStarRank_cardPull: 'BestStarRank_cardPull' as const,
    ClueCta_revealCost: 'ClueCta_revealCost' as const,
    CluesPickerConfirmDialog_revealCost: 'CluesPickerConfirmDialog_revealCost' as const,
    CluesPicker_cardPull: 'CluesPicker_cardPull' as const,
    RevealingCardPlaceholder_cardPulledCard: 'RevealingCardPlaceholder_cardPulledCard' as const,
    Shuffled_cardPull: 'Shuffled_cardPull' as const,
    CardsReveal_cardPull: 'CardsReveal_cardPull' as const,
    CompetitionAvailability_cardShardsChest: 'CompetitionAvailability_cardShardsChest' as const,
    CompetitionWarning_cardShardsChest: 'CompetitionWarning_cardShardsChest' as const,
    CraftingClosedOverlay_currentUser: 'CraftingClosedOverlay_currentUser' as const,
    CraftingClosedOverlay_cardShardsChest: 'CraftingClosedOverlay_cardShardsChest' as const,
    SpecialCraftHeader_PromotionalEventInterface: 'SpecialCraftHeader_PromotionalEventInterface' as const,
    CardPullExperience_cardPullConfig: 'CardPullExperience_cardPullConfig' as const,
    CardPullExperience_currentUser: 'CardPullExperience_currentUser' as const,
    CardPullExperience_cardShardsChest: 'CardPullExperience_cardShardsChest' as const,
    useCardPullUIState_cardPull: 'useCardPullUIState_cardPull' as const,
    EmptyState_so5Fixture: 'EmptyState_so5Fixture' as const,
    FixtureSelector_so5Fixture: 'FixtureSelector_so5Fixture' as const,
    FixtureStatus_so5Leaderboard: 'FixtureStatus_so5Leaderboard' as const,
    FixtureStatus_so5Lineup: 'FixtureStatus_so5Lineup' as const,
    FixtureStatus_composeTeamBenchObjectInterface: 'FixtureStatus_composeTeamBenchObjectInterface' as const,
    FixtureOverviewTasks_so5Fixture: 'FixtureOverviewTasks_so5Fixture' as const,
    FixtureOverviewTitle_so5Fixture: 'FixtureOverviewTitle_so5Fixture' as const,
    FixtureOverview_so5Fixture: 'FixtureOverview_so5Fixture' as const,
    LazyFixtureTeamsOverviewTabContent_so5Fixture: 'LazyFixtureTeamsOverviewTabContent_so5Fixture' as const,
    UpcomingFixtureLeague_so5LeaderboardGroupInterface: 'UpcomingFixtureLeague_so5LeaderboardGroupInterface' as const,
    UpcomingFixtureOverview_so5Fixture: 'UpcomingFixtureOverview_so5Fixture' as const,
    FixtureTeamsOverview_so5Fixture: 'FixtureTeamsOverview_so5Fixture' as const,
    FixtureTimelineGame_game: 'FixtureTimelineGame_game' as const,
    FixtureTimeline_game: 'FixtureTimeline_game' as const,
    FixtureTimeline_so5Leaderboard: 'FixtureTimeline_so5Leaderboard' as const,
    FixtureTimeline_composeTeamBenchObjectInterface: 'FixtureTimeline_composeTeamBenchObjectInterface' as const,
    FixtureTimeline_so5Lineup: 'FixtureTimeline_so5Lineup' as const,
    BaseballScoreCells_fixturePlayer: 'BaseballScoreCells_fixturePlayer' as const,
    FootballScoreCells_fixturePlayer: 'FootballScoreCells_fixturePlayer' as const,
    NBAScoreCells_fixturePlayer: 'NBAScoreCells_fixturePlayer' as const,
    FixtureTopPlayersTableRow_fixturePlayer: 'FixtureTopPlayersTableRow_fixturePlayer' as const,
    FixtureTopPlayersTable_so5Fixture: 'FixtureTopPlayersTable_so5Fixture' as const,
    LeaguesCarousel_so5Fixture: 'LeaguesCarousel_so5Fixture' as const,
    LobbyFixturePickerItem_so5Fixture: 'LobbyFixturePickerItem_so5Fixture' as const,
    LeagueItem_so5LeaderboardGroup: 'LeagueItem_so5LeaderboardGroup' as const,
    so5LeaderboardGroupFragment_so5LeaderboardGroupInterface: 'so5LeaderboardGroupFragment_so5LeaderboardGroupInterface' as const,
    NewEmptyState_so5Fixture: 'NewEmptyState_so5Fixture' as const,
    PastFixtureSelectorFooter_so5Fixture: 'PastFixtureSelectorFooter_so5Fixture' as const,
    FeaturedPlayersList_team: 'FeaturedPlayersList_team' as const,
    FeaturedPlayerListItem_anyPlayerInterface: 'FeaturedPlayerListItem_anyPlayerInterface' as const,
    AppearanceAvatarWithScore_cardWithPlayerGameScoreInterface: 'AppearanceAvatarWithScore_cardWithPlayerGameScoreInterface' as const,
    GameTeamsMatchup_pollingAnyGameInterface: 'GameTeamsMatchup_pollingAnyGameInterface' as const,
    GameTeamsMatchup_anyGameInterface: 'GameTeamsMatchup_anyGameInterface' as const,
    GameWinOddsProjection_teamGameStatsInterface: 'GameWinOddsProjection_teamGameStatsInterface' as const,
    GameWinOddsProjection_anyGameInterface: 'GameWinOddsProjection_anyGameInterface' as const,
    Game_anyGameInterface: 'Game_anyGameInterface' as const,
    GameTime_AnyGameInterface: 'GameTime_AnyGameInterface' as const,
    HorizontalGame_anyGameInterface: 'HorizontalGame_anyGameInterface' as const,
    SquaredFeaturedPlayer_anyPlayerInterface: 'SquaredFeaturedPlayer_anyPlayerInterface' as const,
    TeamBox_team: 'TeamBox_team' as const,
    TeamTableStatsBox_team: 'TeamTableStatsBox_team' as const,
    DailyFixtureBlock_so5Fixture: 'DailyFixtureBlock_so5Fixture' as const,
    FeaturedCompetitionBlock_so5Fixture: 'FeaturedCompetitionBlock_so5Fixture' as const,
    FeaturedUniversalSo5UserGroup_so5UserGroup: 'FeaturedUniversalSo5UserGroup_so5UserGroup' as const,
    MarketBlock_promotionalEventInterface: 'MarketBlock_promotionalEventInterface' as const,
    UpcomingFixtureBlock_so5Fixture: 'UpcomingFixtureBlock_so5Fixture' as const,
    ForYouWidget_so5Root: 'ForYouWidget_so5Root' as const,
    ForYouWidget_tokenRoot: 'ForYouWidget_tokenRoot' as const,
    ForYouWidget_marketRoot: 'ForYouWidget_marketRoot' as const,
    LeaderboardBlock_so5Leaderboard: 'LeaderboardBlock_so5Leaderboard' as const,
    ContenderBlock_so5LeaderboardContender: 'ContenderBlock_so5LeaderboardContender' as const,
    ContenderBlock_so5Fixture: 'ContenderBlock_so5Fixture' as const,
    LineupsContendersWidget_so5LeaderboardContender: 'LineupsContendersWidget_so5LeaderboardContender' as const,
    LineupsContendersWidget_featuredSo5LeaderboardContenders: 'LineupsContendersWidget_featuredSo5LeaderboardContenders' as const,
    LeaderboardGroupBlock_so5LeaderboardGroupInterface: 'LeaderboardGroupBlock_so5LeaderboardGroupInterface' as const,
    LeaderboardGroupBlock_so5Fixture: 'LeaderboardGroupBlock_so5Fixture' as const,
    LineupsLeaderboardGroupsWidget_so5LeaderboardGroupInterface: 'LineupsLeaderboardGroupsWidget_so5LeaderboardGroupInterface' as const,
    LineupsLeaderboardGroupsWidget_featuredSo5LeaderboardGroups: 'LineupsLeaderboardGroupsWidget_featuredSo5LeaderboardGroups' as const,
    FixtureLineupsRecap_so5Fixture: 'FixtureLineupsRecap_so5Fixture' as const,
    LineupsWidgetRecap_so5Fixture: 'LineupsWidgetRecap_so5Fixture' as const,
    LineupsWidgetRewardsRecap_so5Fixture: 'LineupsWidgetRewardsRecap_so5Fixture' as const,
    LineupsWidgetTitle_so5Fixture: 'LineupsWidgetTitle_so5Fixture' as const,
    UpcomingGroupItem_so5LeaderboardGroup: 'UpcomingGroupItem_so5LeaderboardGroup' as const,
    UpcomingSo5LeaderboardGroups_so5Root: 'UpcomingSo5LeaderboardGroups_so5Root' as const,
    LineupsWidgetWrapper_so5Fixture: 'LineupsWidgetWrapper_so5Fixture' as const,
    LineupsWidget_so5Root: 'LineupsWidget_so5Root' as const,
    MyCirclesResult_so5Root: 'MyCirclesResult_so5Root' as const,
    DeletedLineups_so5Lineup: 'DeletedLineups_so5Lineup' as const,
    ImportedLineups_so5LineupImport: 'ImportedLineups_so5LineupImport' as const,
    So5LeaderboardGroupWrapper_so5LeaderboardGroupInterface: 'So5LeaderboardGroupWrapper_so5LeaderboardGroupInterface' as const,
    ImportLineupContent_so5LineupImportsBatch: 'ImportLineupContent_so5LineupImportsBatch' as const,
    useHierarchiedLineups_so5LineupImport: 'useHierarchiedLineups_so5LineupImport' as const,
    useHierarchiedSo5Lineups_so5Lineup: 'useHierarchiedSo5Lineups_so5Lineup' as const,
    InboxTaskDialog_taskInterface: 'InboxTaskDialog_taskInterface' as const,
    InboxTaskRow_taskInterface: 'InboxTaskRow_taskInterface' as const,
    InboxTaskRow_cardSet: 'InboxTaskRow_cardSet' as const,
    InboxTasks_currentUser: 'InboxTasks_currentUser' as const,
    InboxTasks_cardSet: 'InboxTasks_cardSet' as const,
    OfflineLanding_config: 'OfflineLanding_config' as const,
    CardsEarned_currentUser: 'CardsEarned_currentUser' as const,
    CreditsEarned_currentUser: 'CreditsEarned_currentUser' as const,
    ReferralItem_referral: 'ReferralItem_referral' as const,
    OnlineLanding_currentUser: 'OnlineLanding_currentUser' as const,
    OnlineLanding_config: 'OnlineLanding_config' as const,
    WalletLandingBranding: 'WalletLandingBranding' as const,
    CardsLeft_so5Lineup: 'CardsLeft_so5Lineup' as const,
    ComposeBonuses_so5AppearanceBonusInterface: 'ComposeBonuses_so5AppearanceBonusInterface' as const,
    ScoringMatrixRules_so5Leaderboard: 'ScoringMatrixRules_so5Leaderboard' as const,
    SpecialEventTitleAndDesc_so5Fixture: 'SpecialEventTitleAndDesc_so5Fixture' as const,
    SpecialEventTitleAndDesc_so5League: 'SpecialEventTitleAndDesc_so5League' as const,
    SpecialEventTitleAndDesc_so5LeaderboardGroupInterface: 'SpecialEventTitleAndDesc_so5LeaderboardGroupInterface' as const,
    ComposeRules_displayedTypedRule: 'ComposeRules_displayedTypedRule' as const,
    ComposeRules_so5RuleFeedback: 'ComposeRules_so5RuleFeedback' as const,
    CumulativeRankReward_so5RewardConfig: 'CumulativeRankReward_so5RewardConfig' as const,
    CumulativeRankReward_So5UserGroupMembership: 'CumulativeRankReward_So5UserGroupMembership' as const,
    RankRow_userRankingInterface: 'RankRow_userRankingInterface' as const,
    CumulativeRanking_So5UserGroupMembership: 'CumulativeRanking_So5UserGroupMembership' as const,
    DivisionChangeConfigBar_so5Leaderboard: 'DivisionChangeConfigBar_so5Leaderboard' as const,
    DivisionChangeConfigBar_so5Lineup: 'DivisionChangeConfigBar_so5Lineup' as const,
    DivisionSelector_so5Leaderboard: 'DivisionSelector_so5Leaderboard' as const,
    LadderClaimRewardDialog_anyRewardInterface: 'LadderClaimRewardDialog_anyRewardInterface' as const,
    LadderLeaderboardHeader_ladderLeaderboard: 'LadderLeaderboardHeader_ladderLeaderboard' as const,
    LadderLeaderboardHeader_ladderLeaderboardSelector: 'LadderLeaderboardHeader_ladderLeaderboardSelector' as const,
    LadderMonthSelector_ladderLeaderboard: 'LadderMonthSelector_ladderLeaderboard' as const,
    LadderRankRow_publicUserInfoInterface: 'LadderRankRow_publicUserInfoInterface' as const,
    LadderRankedList_rewardBracket: 'LadderRankedList_rewardBracket' as const,
    LadderRankedList_myRanking: 'LadderRankedList_myRanking' as const,
    LadderLeaderboard_ladderLeaderboard: 'LadderLeaderboard_ladderLeaderboard' as const,
    LadderLeaderboard_ladderLeaderboardSelector: 'LadderLeaderboard_ladderLeaderboardSelector' as const,
    LeaderboardComposable_so5Leaderboard: 'LeaderboardComposable_so5Leaderboard' as const,
    LeaderboardComposable_so5LeagueTrack: 'LeaderboardComposable_so5LeagueTrack' as const,
    LeaderboardEntryCost_so5Leaderboard: 'LeaderboardEntryCost_so5Leaderboard' as const,
    LeaderboardInlineInfo_so5Leaderboard: 'LeaderboardInlineInfo_so5Leaderboard' as const,
    LeaderboardRewards_so5Leaderboard: 'LeaderboardRewards_so5Leaderboard' as const,
    LeaderboardTasks_so5Leaderboard: 'LeaderboardTasks_so5Leaderboard' as const,
    LeaderboardTeamsCap_so5Leaderboard: 'LeaderboardTeamsCap_so5Leaderboard' as const,
    LiveStreakProgress_so5Lineup: 'LiveStreakProgress_so5Lineup' as const,
    PaginatedRankings_so5Ranking: 'PaginatedRankings_so5Ranking' as const,
    CumulativePrizePool_so5Leaderboard: 'CumulativePrizePool_so5Leaderboard' as const,
    CumulativePrizePool_so5LeaderboardContender: 'CumulativePrizePool_so5LeaderboardContender' as const,
    DefaultPrizePool_so5Leaderboard: 'DefaultPrizePool_so5Leaderboard' as const,
    DefaultPrizePool_so5LeaderboardContender: 'DefaultPrizePool_so5LeaderboardContender' as const,
    RankingFullLeaderboardRow_so5Ranking: 'RankingFullLeaderboardRow_so5Ranking' as const,
    FullLeaderboardPaginatedRankings_so5Ranking: 'FullLeaderboardPaginatedRankings_so5Ranking' as const,
    PrizePoolWidget_so5Leaderboard: 'PrizePoolWidget_so5Leaderboard' as const,
    PrizePoolWidget_so5LeaderboardContender: 'PrizePoolWidget_so5LeaderboardContender' as const,
    RankReward_so5Leaderboard: 'RankReward_so5Leaderboard' as const,
    RankReward_so5RewardConfig: 'RankReward_so5RewardConfig' as const,
    RankReward_so5Ranking: 'RankReward_so5Ranking' as const,
    RankRewardsRanking_so5Ranking: 'RankRewardsRanking_so5Ranking' as const,
    RankRewards_so5Leaderboard: 'RankRewards_so5Leaderboard' as const,
    RankRewards_so5Ranking: 'RankRewards_so5Ranking' as const,
    ScoreRewards_so5RewardConfig: 'ScoreRewards_so5RewardConfig' as const,
    ScoreRewards_so5League: 'ScoreRewards_so5League' as const,
    ScoreRewards_so5Ranking: 'ScoreRewards_so5Ranking' as const,
    TargetsCarousel_so5Lineup: 'TargetsCarousel_so5Lineup' as const,
    TargetsCarousel_so5Leaderboard: 'TargetsCarousel_so5Leaderboard' as const,
    ThresholdProgressBar_so5Leaderboard: 'ThresholdProgressBar_so5Leaderboard' as const,
    ThresholdProgressBar_so5Lineup: 'ThresholdProgressBar_so5Lineup' as const,
    ThresholdRewards_so5RewardConfig: 'ThresholdRewards_so5RewardConfig' as const,
    ThresholdRewards_so5League: 'ThresholdRewards_so5League' as const,
    AddTeamLayout_so5LeaderboardGroupInterface: 'AddTeamLayout_so5LeaderboardGroupInterface' as const,
    AddTeamWrapper_so5LeaderboardGroupInterface: 'AddTeamWrapper_so5LeaderboardGroupInterface' as const,
    EligibleCards_so5LeaderboardGroupInterface: 'EligibleCards_so5LeaderboardGroupInterface' as const,
    LeagueDelayedEntryChip_so5LeaderboardGroup: 'LeagueDelayedEntryChip_so5LeaderboardGroup' as const,
    LeagueDot_so5LeaderboardGroupInterface: 'LeagueDot_so5LeaderboardGroupInterface' as const,
    LeagueEntryStateChip_so5LeaderboardGroupInterface: 'LeagueEntryStateChip_so5LeaderboardGroupInterface' as const,
    LeagueIndicators_so5LeaderboardGroupInterface: 'LeagueIndicators_so5LeaderboardGroupInterface' as const,
    LeagueSelect_so5LeaderboardGroupInterface: 'LeagueSelect_so5LeaderboardGroupInterface' as const,
    Rewards_so5LeaderboardGroupInterface: 'Rewards_so5LeaderboardGroupInterface' as const,
    LeagueSquareLink_so5LeaderboardGroupInterface: 'LeagueSquareLink_so5LeaderboardGroupInterface' as const,
    LeagueTrckGroupSelect_so5LeagueTrackGroup: 'LeagueTrckGroupSelect_so5LeagueTrackGroup' as const,
    FootballLeagueTrckSlotsPicker_so5LeagueTrack: 'FootballLeagueTrckSlotsPicker_so5LeagueTrack' as const,
    LeagueTrckTeamViewDialog_so5LeagueTrack: 'LeagueTrckTeamViewDialog_so5LeagueTrack' as const,
    MatchesPlayedStat_so5LeaderboardGroupInterface: 'MatchesPlayedStat_so5LeaderboardGroupInterface' as const,
    RewardsIndicator_so5LeaderboardGroupInterface: 'RewardsIndicator_so5LeaderboardGroupInterface' as const,
    LeagueTrckSlotCta_so5LeagueTrack: 'LeagueTrckSlotCta_so5LeagueTrack' as const,
    LeagueTrckSlot_so5LeaderboardContender: 'LeagueTrckSlot_so5LeaderboardContender' as const,
    LeagueTrckSlots_so5LeagueTrack: 'LeagueTrckSlots_so5LeagueTrack' as const,
    LeagueTrckSlotsPicker_so5LeagueTrack: 'LeagueTrckSlotsPicker_so5LeagueTrack' as const,
    LeagueTrckVaultGated_so5Leaderboard: 'LeagueTrckVaultGated_so5Leaderboard' as const,
    LeagueTrckVaultGatedHowItWorksDialog_sealingConfig: 'LeagueTrckVaultGatedHowItWorksDialog_sealingConfig' as const,
    LeagueTrckVaultGatedHowItWorksDialog_so5Leaderboard: 'LeagueTrckVaultGatedHowItWorksDialog_so5Leaderboard' as const,
    getLeagueTrackSlotsInfo_so5LeagueTrack: 'getLeagueTrackSlotsInfo_so5LeagueTrack' as const,
    AppearanceRuleContributor_appearanceRule: 'AppearanceRuleContributor_appearanceRule' as const,
    AppearanceRuleIcon_appearanceRule: 'AppearanceRuleIcon_appearanceRule' as const,
    CompactSo5Lineup_so5Lineup: 'CompactSo5Lineup_so5Lineup' as const,
    ContenderLiveFooter_so5LeaderboardContender: 'ContenderLiveFooter_so5LeaderboardContender' as const,
    ContenderPveFooter_so5LeaderboardContender: 'ContenderPveFooter_so5LeaderboardContender' as const,
    ContenderUpcomingFooter_so5LeaderboardContender: 'ContenderUpcomingFooter_so5LeaderboardContender' as const,
    ContenderFooter_so5LeaderboardContender: 'ContenderFooter_so5LeaderboardContender' as const,
    ContenderLiveFooter_so5Ranking: 'ContenderLiveFooter_so5Ranking' as const,
    Contender_so5LeaderboardContender: 'Contender_so5LeaderboardContender' as const,
    AppearanceAvatar_appearanceInterface: 'AppearanceAvatar_appearanceInterface' as const,
    CardBlock_appearance: 'CardBlock_appearance' as const,
    AppearanceBonusBreakdown_appearance: 'AppearanceBonusBreakdown_appearance' as const,
    SetAppearanceBonusBreakdown_appearance: 'SetAppearanceBonusBreakdown_appearance' as const,
    LineupBonusDetails_appearanceInterface: 'LineupBonusDetails_appearanceInterface' as const,
    LineupBonusDetails_so5Appearance: 'LineupBonusDetails_so5Appearance' as const,
    LineupBonusDetails_so5AppearanceBonusInterface: 'LineupBonusDetails_so5AppearanceBonusInterface' as const,
    ManagerTeamUpdateDialog_managerTeam: 'ManagerTeamUpdateDialog_managerTeam' as const,
    LineupButtons_so5Lineup: 'LineupButtons_so5Lineup' as const,
    LineupButtons_managerTeam: 'LineupButtons_managerTeam' as const,
    LineupButtons_so5Leaderboard: 'LineupButtons_so5Leaderboard' as const,
    LineupDate_fixture: 'LineupDate_fixture' as const,
    LobbyLineupHeader_so5LeaderboardContender: 'LobbyLineupHeader_so5LeaderboardContender' as const,
    LineupLayoutWrapper_so5LeaderboardContender: 'LineupLayoutWrapper_so5LeaderboardContender' as const,
    LineupLayoutWrapper_placeholder: 'LineupLayoutWrapper_placeholder' as const,
    LineupPlaceholder_so5RuleInterface: 'LineupPlaceholder_so5RuleInterface' as const,
    LineupSharing_so5Lineup: 'LineupSharing_so5Lineup' as const,
    PlayerCard_appearanceInterface: 'PlayerCard_appearanceInterface' as const,
    PlayerCard_composeTeamBenchObjectInterface: 'PlayerCard_composeTeamBenchObjectInterface' as const,
    PlayerCardPlaceholder_so5Lineup: 'PlayerCardPlaceholder_so5Lineup' as const,
    PlayerCardPlaceholder_managerTeam: 'PlayerCardPlaceholder_managerTeam' as const,
    PlayerCardPlaceholder_so5Leaderboard: 'PlayerCardPlaceholder_so5Leaderboard' as const,
    So5Lineup_so5LeaderboardContender: 'So5Lineup_so5LeaderboardContender' as const,
    WarningDialog_anyCard: 'WarningDialog_anyCard' as const,
    ManagerTeamBadge_so5Leaderboard: 'ManagerTeamBadge_so5Leaderboard' as const,
    ManagerTeamBadge_so5Ranking: 'ManagerTeamBadge_so5Ranking' as const,
    ManagerTeamBadge_managerTeam: 'ManagerTeamBadge_managerTeam' as const,
    ManagerTeamBadgeIcon_so5Leaderboard: 'ManagerTeamBadgeIcon_so5Leaderboard' as const,
    ManagerTeamBadgeIcon_managerTeam: 'ManagerTeamBadgeIcon_managerTeam' as const,
    Status_so5Ranking: 'Status_so5Ranking' as const,
    AnyTask_taskInterface: 'AnyTask_taskInterface' as const,
    AnyTaskBasicClaimStory_taskInterface: 'AnyTaskBasicClaimStory_taskInterface' as const,
    AnyTaskClaimStory_taskInterface: 'AnyTaskClaimStory_taskInterface' as const,
    CardCollectionDetailsDialog_taskInterface: 'CardCollectionDetailsDialog_taskInterface' as const,
    CardCollectionTask_taskInterface: 'CardCollectionTask_taskInterface' as const,
    ClaimedTask_taskInterface: 'ClaimedTask_taskInterface' as const,
    CollectionCompletionDetailsDialog_taskInterface: 'CollectionCompletionDetailsDialog_taskInterface' as const,
    CollectionCompletionTask_taskInterface: 'CollectionCompletionTask_taskInterface' as const,
    CollectionTaskFooter_taskInterface: 'CollectionTaskFooter_taskInterface' as const,
    CollectionToastContent_taskInterface: 'CollectionToastContent_taskInterface' as const,
    DailyBoostToastContent_task: 'DailyBoostToastContent_task' as const,
    MissionToast_taskInterface: 'MissionToast_taskInterface' as const,
    DailyActionSubTask_taskInterface: 'DailyActionSubTask_taskInterface' as const,
    DailyActionTaskReward_anyRewardConfig: 'DailyActionTaskReward_anyRewardConfig' as const,
    DailyActionTaskRewards_taskInterface: 'DailyActionTaskRewards_taskInterface' as const,
    DailyActionTask_taskInterface: 'DailyActionTask_taskInterface' as const,
    DecisivePlayerPickerTaskClaimStory_decisivePlayerPickerTask: 'DecisivePlayerPickerTaskClaimStory_decisivePlayerPickerTask' as const,
    ChooseYourRewardStory_rewardConfig: 'ChooseYourRewardStory_rewardConfig' as const,
    ChooseYourRewardStory_alternativeRewardConfig: 'ChooseYourRewardStory_alternativeRewardConfig' as const,
    ClaimYourRewardsStory_decisivePlayerPickerTaskAppearance: 'ClaimYourRewardsStory_decisivePlayerPickerTaskAppearance' as const,
    ClaimYourRewardsStory_taskAppearance: 'ClaimYourRewardsStory_taskAppearance' as const,
    ClaimYourRewardsStory_decisivePlayerPickerTask: 'ClaimYourRewardsStory_decisivePlayerPickerTask' as const,
    ClaimYourRewardsStory_taskInterface: 'ClaimYourRewardsStory_taskInterface' as const,
    DecisivePlayerPickerTaskStatus_decisivePlayerPickerTask: 'DecisivePlayerPickerTaskStatus_decisivePlayerPickerTask' as const,
    DropChallengePickerDialog_dropChallengeTask: 'DropChallengePickerDialog_dropChallengeTask' as const,
    DropChallengeButton_taskInterface: 'DropChallengeButton_taskInterface' as const,
    DailyTask_taskInterface: 'DailyTask_taskInterface' as const,
    FeaturedCollectionTask_taskInterface: 'FeaturedCollectionTask_taskInterface' as const,
    FeaturedPlayTask_taskInterface: 'FeaturedPlayTask_taskInterface' as const,
    GameWeeklyTask_taskInterface: 'GameWeeklyTask_taskInterface' as const,
    Missions_taskInterface: 'Missions_taskInterface' as const,
    MissionsDialog_taskInterface: 'MissionsDialog_taskInterface' as const,
    OnboardingTask_taskInterface: 'OnboardingTask_taskInterface' as const,
    PlayMissionDetails_tasksTrack: 'PlayMissionDetails_tasksTrack' as const,
    PlayMissions_currentUser: 'PlayMissions_currentUser' as const,
    PlayMissionsButton_currentUser: 'PlayMissionsButton_currentUser' as const,
    DecisivePlayerPickerTaskRow_decisivePlayerPickerTask: 'DecisivePlayerPickerTaskRow_decisivePlayerPickerTask' as const,
    GenericTaskRow_taskInterface: 'GenericTaskRow_taskInterface' as const,
    StepsMissionRow_tasksTrack: 'StepsMissionRow_tasksTrack' as const,
    PlayMissionsTaskRow_taskInterface: 'PlayMissionsTaskRow_taskInterface' as const,
    ProgressTaskCard_taskInterface: 'ProgressTaskCard_taskInterface' as const,
    ProgressTaskCard_anyRewardConfigInterface: 'ProgressTaskCard_anyRewardConfigInterface' as const,
    Rewards_anyRewardConfig: 'Rewards_anyRewardConfig' as const,
    TaskDetailsDescription_taskInterface: 'TaskDetailsDescription_taskInterface' as const,
    SetCollectionTaskDetails_taskInterface: 'SetCollectionTaskDetails_taskInterface' as const,
    SetCollectionTaskPreview_taskInterface: 'SetCollectionTaskPreview_taskInterface' as const,
    TaskCardPacks_taskInterface: 'TaskCardPacks_taskInterface' as const,
    TaskCards_taskInterface: 'TaskCards_taskInterface' as const,
    MissionCollectionCard_cardCollectionWithProgress: 'MissionCollectionCard_cardCollectionWithProgress' as const,
    TaskCollections_taskInterface: 'TaskCollections_taskInterface' as const,
    TaskCardsOrCollections_taskInterface: 'TaskCardsOrCollections_taskInterface' as const,
    ThresholdRewardRow_taskInterface: 'ThresholdRewardRow_taskInterface' as const,
    TaskRewards_taskInterface: 'TaskRewards_taskInterface' as const,
    SetCollectionTask_taskInterface: 'SetCollectionTask_taskInterface' as const,
    SharedJackpotClaimStory_taskInterface: 'SharedJackpotClaimStory_taskInterface' as const,
    StreakTaskFooter_taskInterface: 'StreakTaskFooter_taskInterface' as const,
    StreakTask_taskInterface: 'StreakTask_taskInterface' as const,
    DetailsDialog_thresholdStreakTask: 'DetailsDialog_thresholdStreakTask' as const,
    StreakProgress_managerTaskInterface: 'StreakProgress_managerTaskInterface' as const,
    StreakProgressBar_so5Lineup: 'StreakProgressBar_so5Lineup' as const,
    StreakProgressIndicator_thresholdsStreakTask: 'StreakProgressIndicator_thresholdsStreakTask' as const,
    StreakTaskClaimButton_so5Lineup: 'StreakTaskClaimButton_so5Lineup' as const,
    TaskCampaignLabel_taskCampaign: 'TaskCampaignLabel_taskCampaign' as const,
    TaskCampaignText_taskCampaign: 'TaskCampaignText_taskCampaign' as const,
    ClaimYourStreakRewardsStory_thresholdsStreakTask: 'ClaimYourStreakRewardsStory_thresholdsStreakTask' as const,
    ClaimYourStreakRewardsStory_taskInterface: 'ClaimYourStreakRewardsStory_taskInterface' as const,
    ThresholdsStreakTaskClaimStory_thresholdsStreakTask: 'ThresholdsStreakTaskClaimStory_thresholdsStreakTask' as const,
    TutoRewards_thresholdStreakTask: 'TutoRewards_thresholdStreakTask' as const,
    TaskCampaignBanner_taskCampaignsHomepage: 'TaskCampaignBanner_taskCampaignsHomepage' as const,
    TaskClaimedDialogs_taskInterface: 'TaskClaimedDialogs_taskInterface' as const,
    TaskClaimedDialogs_anyRewardInterface: 'TaskClaimedDialogs_anyRewardInterface' as const,
    TaskIcon_task: 'TaskIcon_task' as const,
    TaskRules_so5RuleInterface: 'TaskRules_so5RuleInterface' as const,
    TaskStepsProgress_taskInterface: 'TaskStepsProgress_taskInterface' as const,
    ThresholdsDuoTaskDialogLeg_user: 'ThresholdsDuoTaskDialogLeg_user' as const,
    ThresholdsDuoTaskDialog_taskInterface: 'ThresholdsDuoTaskDialog_taskInterface' as const,
    DuoTaskLeg_user: 'DuoTaskLeg_user' as const,
    ThresholdsDuoTaskScores_taskInterface: 'ThresholdsDuoTaskScores_taskInterface' as const,
    ThresholdsDuoTask_taskInterface: 'ThresholdsDuoTask_taskInterface' as const,
    RewardsContent_taskCampaign: 'RewardsContent_taskCampaign' as const,
    DuoTaskHowItWorksDialog_taskCampaign: 'DuoTaskHowItWorksDialog_taskCampaign' as const,
    ThresholdsDuoTaskCampaign_taskCampaign: 'ThresholdsDuoTaskCampaign_taskCampaign' as const,
    ClaimButton_taskInterface: 'ClaimButton_taskInterface' as const,
    useFiatWalletValidation_taskInterface: 'useFiatWalletValidation_taskInterface' as const,
    UnclaimedTask_taskInterface: 'UnclaimedTask_taskInterface' as const,
    WithFlavour_anyRewardConfigInterface: 'WithFlavour_anyRewardConfigInterface' as const,
    getTaskColors_taskInterface: 'getTaskColors_taskInterface' as const,
    getTasksSections_taskGroup: 'getTasksSections_taskGroup' as const,
    getTasksSections_dailyActionTaskInterface: 'getTasksSections_dailyActionTaskInterface' as const,
    markCareerStepClaimedTest_careerStep: 'markCareerStepClaimedTest_careerStep' as const,
    BaseSlot_anyCardInterface: 'BaseSlot_anyCardInterface' as const,
    DecisivePickerSlot_taskAppearance: 'DecisivePickerSlot_taskAppearance' as const,
    DecisivePickerSlot_card: 'DecisivePickerSlot_card' as const,
    NoCardState_game: 'NoCardState_game' as const,
    NoCardState_task: 'NoCardState_task' as const,
    StatThresholdsBar_taskStatThreshold: 'StatThresholdsBar_taskStatThreshold' as const,
    DecisivePlayerPickerDialog_taskAppearances: 'DecisivePlayerPickerDialog_taskAppearances' as const,
    OwnedCardFooter_anyCardInterface: 'OwnedCardFooter_anyCardInterface' as const,
    TaskCardsPicker_anyCardInterface: 'TaskCardsPicker_anyCardInterface' as const,
    TaskPickerDialogLayout_task: 'TaskPickerDialogLayout_task' as const,
    getTasksTrackStep_tasksTrack: 'getTasksTrackStep_tasksTrack' as const,
    LadderPointsStory_ladderContribution: 'LadderPointsStory_ladderContribution' as const,
    RewardUnlockedStory_rewardConfig: 'RewardUnlockedStory_rewardConfig' as const,
    RewardUnlockedStory_reward: 'RewardUnlockedStory_reward' as const,
    useClaimTask_currentUser: 'useClaimTask_currentUser' as const,
    useTaskButtonProps_taskInterface: 'useTaskButtonProps_taskInterface' as const,
    isTaskLive_gameWeeklyTask: 'isTaskLive_gameWeeklyTask' as const,
    hasEditableTaskAppearance_taskInterface: 'hasEditableTaskAppearance_taskInterface' as const,
    CardOrCollectionRaritySwitcher_user: 'CardOrCollectionRaritySwitcher_user' as const,
    CollectionNavigationSwitch_user: 'CollectionNavigationSwitch_user' as const,
    CollectionSlot_userCardCollectionSlot: 'CollectionSlot_userCardCollectionSlot' as const,
    PlaceholderSlot_userCardCollectionSlot: 'PlaceholderSlot_userCardCollectionSlot' as const,
    MyCardsGrid_searchCards: 'MyCardsGrid_searchCards' as const,
    MyCardsSearchSidebar_user: 'MyCardsSearchSidebar_user' as const,
    BackendMyClubCardsSearchContent_user: 'BackendMyClubCardsSearchContent_user' as const,
    RevealNavigationSwitch_user: 'RevealNavigationSwitch_user' as const,
    UserSetProgress_currentUser: 'UserSetProgress_currentUser' as const,
    Network_user: 'Network_user' as const,
    UserNetworkInfo_publicUserInfoInterface: 'UserNetworkInfo_publicUserInfoInterface' as const,
    UserNetwork_user: 'UserNetwork_user' as const,
    TrendingCards_competition: 'TrendingCards_competition' as const,
    ExpandedLeagueLaunch_competition: 'ExpandedLeagueLaunch_competition' as const,
    ExpandedLeagueLaunch_so5Competition: 'ExpandedLeagueLaunch_so5Competition' as const,
    FeaturedMainLeagueLaunchCardsSearch_competition: 'FeaturedMainLeagueLaunchCardsSearch_competition' as const,
    FeaturedMainLeagueLaunch_competition: 'FeaturedMainLeagueLaunch_competition' as const,
    FeaturedMainLeagueLaunch_so5Competition: 'FeaturedMainLeagueLaunch_so5Competition' as const,
    LeagueLaunch_competition: 'LeagueLaunch_competition' as const,
    LeagueLaunch_so5Competition: 'LeagueLaunch_so5Competition' as const,
    LeagueNavigator_competition: 'LeagueNavigator_competition' as const,
    LeagueNavigator_so5Competition: 'LeagueNavigator_so5Competition' as const,
    MainLeagueLaunch_competition: 'MainLeagueLaunch_competition' as const,
    MainLeagueLaunch_so5Competition: 'MainLeagueLaunch_so5Competition' as const,
    NewSeasonHeader_competition: 'NewSeasonHeader_competition' as const,
    NewSeasonHeader_so5Competition: 'NewSeasonHeader_so5Competition' as const,
    ReleasedLeagues_competition: 'ReleasedLeagues_competition' as const,
    ReleasedLeagues_so5Competition: 'ReleasedLeagues_so5Competition' as const,
    AnnouncementNotificationDialog_announcementNotification: 'AnnouncementNotificationDialog_announcementNotification' as const,
    ImportantNotificationDialog_notificationInterface: 'ImportantNotificationDialog_notificationInterface' as const,
    AuctionWonContent_tokenAuction: 'AuctionWonContent_tokenAuction' as const,
    AuctionNotificationContent_anyReward: 'AuctionNotificationContent_anyReward' as const,
    NotificationDialog_auctionNotification: 'NotificationDialog_auctionNotification' as const,
    NotificationDialog_notificationInterface: 'NotificationDialog_notificationInterface' as const,
    Notifications_currentUser: 'Notifications_currentUser' as const,
    SignFirstPlayersDialog_careerBoard: 'SignFirstPlayersDialog_careerBoard' as const,
    OnboardingSeriesBackground_cardSet: 'OnboardingSeriesBackground_cardSet' as const,
    ArenaPickers_so5LeaderboardGroup: 'ArenaPickers_so5LeaderboardGroup' as const,
    careerProSteps_careerBoard: 'careerProSteps_careerBoard' as const,
    BoardPickerOption_careerBoard: 'BoardPickerOption_careerBoard' as const,
    boardsWithCareerProSteps_careerBoard: 'boardsWithCareerProSteps_careerBoard' as const,
    BoardPicker_careerBoard: 'BoardPicker_careerBoard' as const,
    DuoPicker_careerBoard: 'DuoPicker_careerBoard' as const,
    LeaderboardGroupPicker_so5LeaderboardGroup: 'LeaderboardGroupPicker_so5LeaderboardGroup' as const,
    LeaderboardPicker_so5Leaderboard: 'LeaderboardPicker_so5Leaderboard' as const,
    ProBoardPickers_careerBoard: 'ProBoardPickers_careerBoard' as const,
    ProBoardPickers_selectedCareerBoard: 'ProBoardPickers_selectedCareerBoard' as const,
    AnyPlayerHeaderRow_anyPlayer: 'AnyPlayerHeaderRow_anyPlayer' as const,
    AnyPlayerHeader_anyPlayer: 'AnyPlayerHeader_anyPlayer' as const,
    MobilePlayerPageFooterItem_anyCard: 'MobilePlayerPageFooterItem_anyCard' as const,
    MobilePlayerPageFooter_anyPlayer: 'MobilePlayerPageFooter_anyPlayer' as const,
    Performance_anyPlayer: 'Performance_anyPlayer' as const,
    GameplayPlayerAvatar_anyPlayer: 'GameplayPlayerAvatar_anyPlayer' as const,
    PlayerInjuries_injury: 'PlayerInjuries_injury' as const,
    PlayerListItem_player: 'PlayerListItem_player' as const,
    Header_currentUser: 'Header_currentUser' as const,
    LadderEntryPointWidget_ladderLeaderboard: 'LadderEntryPointWidget_ladderLeaderboard' as const,
    NextGameTooltipContent_anyGame: 'NextGameTooltipContent_anyGame' as const,
    RareBonusRewardTutorial_careerProStep: 'RareBonusRewardTutorial_careerProStep' as const,
    SharedPoolButton_careerBoard: 'SharedPoolButton_careerBoard' as const,
    ProBoard_currentUser: 'ProBoard_currentUser' as const,
    EligibleCardsSection_careerBoard: 'EligibleCardsSection_careerBoard' as const,
    ProBoardGameList_careerBoard: 'ProBoardGameList_careerBoard' as const,
    ThresholdStep_rewardConfig: 'ThresholdStep_rewardConfig' as const,
    ThresholdStep_originalRewardConfig: 'ThresholdStep_originalRewardConfig' as const,
    ThresholdStep_careerProStep: 'ThresholdStep_careerProStep' as const,
    OfferCard_packConfigPurchasableItem: 'OfferCard_packConfigPurchasableItem' as const,
    BuyCta_board: 'BuyCta_board' as const,
    BuyCta_packConfigPurchasableItem: 'BuyCta_packConfigPurchasableItem' as const,
    CardOdds_cardPack: 'CardOdds_cardPack' as const,
    LaptopForm_board: 'LaptopForm_board' as const,
    LaptopForm_packConfigPurchasableItem: 'LaptopForm_packConfigPurchasableItem' as const,
    MobileForm_board: 'MobileForm_board' as const,
    MobileForm_packConfigPurchasableItem: 'MobileForm_packConfigPurchasableItem' as const,
    OwnYourGame_stepInterface: 'OwnYourGame_stepInterface' as const,
    PackContent_cardPack: 'PackContent_cardPack' as const,
    PlayerMeta_anyPlayer: 'PlayerMeta_anyPlayer' as const,
    PlayerInformations_anyPlayer: 'PlayerInformations_anyPlayer' as const,
    PackDetails_board: 'PackDetails_board' as const,
    PackDetails_packConfigPurchasableItem: 'PackDetails_packConfigPurchasableItem' as const,
    WelcomeOfferPageContent_purchasableItemsVoucher: 'WelcomeOfferPageContent_purchasableItemsVoucher' as const,
    CurrentFixture_so5Fixture: 'CurrentFixture_so5Fixture' as const,
    CurrentFixture_user: 'CurrentFixture_user' as const,
    GalleryCards_anyCard: 'GalleryCards_anyCard' as const,
    Gallery_anyCard: 'Gallery_anyCard' as const,
    Gallery_deck: 'Gallery_deck' as const,
    Gallery_publicUserInfoInterface: 'Gallery_publicUserInfoInterface' as const,
    ClubEditor_userSportProfile: 'ClubEditor_userSportProfile' as const,
    Share_socialPictureDerivative: 'Share_socialPictureDerivative' as const,
    ManagerBoardProgress_taskInterface: 'ManagerBoardProgress_taskInterface' as const,
    FormattedStatistic_UserSportStatistic: 'FormattedStatistic_UserSportStatistic' as const,
    ManagerIDStat_userSportStatistic: 'ManagerIDStat_userSportStatistic' as const,
    ManagerIDHeader_user: 'ManagerIDHeader_user' as const,
    ManagerIDHeader_userSportProfile: 'ManagerIDHeader_userSportProfile' as const,
    ManagerInfo_user: 'ManagerInfo_user' as const,
    ProManagerCurrentStreak_user: 'ProManagerCurrentStreak_user' as const,
    ProManagerInfo_user: 'ProManagerInfo_user' as const,
    ProManagerMonthlyLadder_user: 'ProManagerMonthlyLadder_user' as const,
    RecentPurchase_anyCardInterface: 'RecentPurchase_anyCardInterface' as const,
    RecentPurchases_tokenOperationTradeInterface: 'RecentPurchases_tokenOperationTradeInterface' as const,
    SetManagerActions_user: 'SetManagerActions_user' as const,
    SetManagerBestCards_user: 'SetManagerBestCards_user' as const,
    BoardLineups_thresholdPickerTask: 'BoardLineups_thresholdPickerTask' as const,
    SetManagerCurrentBoard_user: 'SetManagerCurrentBoard_user' as const,
    SetManagerInfo_user: 'SetManagerInfo_user' as const,
    SetManagerInfo_currentUser: 'SetManagerInfo_currentUser' as const,
    SetManagerPageHeader_user: 'SetManagerPageHeader_user' as const,
    SetManagerProfileEditor_user: 'SetManagerProfileEditor_user' as const,
    BestScoreGauge_taskLineupInterface: 'BestScoreGauge_taskLineupInterface' as const,
    SetManagerStats_user: 'SetManagerStats_user' as const,
    SetManagerStepsWon_user: 'SetManagerStepsWon_user' as const,
    UserFixtureResults_so5Fixture: 'UserFixtureResults_so5Fixture' as const,
    UserFixtureResultsHeader_so5Fixture: 'UserFixtureResultsHeader_so5Fixture' as const,
    UserFixtureResultsHeader_user: 'UserFixtureResultsHeader_user' as const,
    UserFixtureResultsHeader_anyRewardConfigInterface: 'UserFixtureResultsHeader_anyRewardConfigInterface' as const,
    WatchlistsBlock_user: 'WatchlistsBlock_user' as const,
    CardCounts_user: 'CardCounts_user' as const,
    Deck_user: 'Deck_user' as const,
    Deck_deck: 'Deck_deck' as const,
    Infos_user: 'Infos_user' as const,
    ManagerIdRendering_user: 'ManagerIdRendering_user' as const,
    ManagerIdRendering_userSportProfile: 'ManagerIdRendering_userSportProfile' as const,
    So5RankingRewards_so5Lineup: 'So5RankingRewards_so5Lineup' as const,
    ClickableAnyRewardConfig_anyRewardConfigInterface: 'ClickableAnyRewardConfig_anyRewardConfigInterface' as const,
    ClickableAnyRewardConfig_so5League: 'ClickableAnyRewardConfig_so5League' as const,
    CraftingPoolButton_so5Leaderboard: 'CraftingPoolButton_so5Leaderboard' as const,
    FixtureNeonRewards_so5Fixture: 'FixtureNeonRewards_so5Fixture' as const,
    LivePastLeaderboard_so5LeaderboardGroup: 'LivePastLeaderboard_so5LeaderboardGroup' as const,
    NeonRewardConfigs_rewardConfig: 'NeonRewardConfigs_rewardConfig' as const,
    ShardRewards_cardShardRewardConfig: 'ShardRewards_cardShardRewardConfig' as const,
    NeonRewards_anyRewardConfigInterface: 'NeonRewards_anyRewardConfigInterface' as const,
    NewRewardsBanner_so5Reward: 'NewRewardsBanner_so5Reward' as const,
    PlayerWithSupply_playerWithSupply: 'PlayerWithSupply_playerWithSupply' as const,
    PlayerWithSupply_so5League: 'PlayerWithSupply_so5League' as const,
    PoolCompetitionFilter_competition: 'PoolCompetitionFilter_competition' as const,
    RewardConfigsOverview_so5Lineup: 'RewardConfigsOverview_so5Lineup' as const,
    RewardConfigsOverview_rarityRewardConfigs: 'RewardConfigsOverview_rarityRewardConfigs' as const,
    RewardConfigsOverview_anyRewardConfigInterface: 'RewardConfigsOverview_anyRewardConfigInterface' as const,
    RewardConfigsOverviewHeader_so5Fixture: 'RewardConfigsOverviewHeader_so5Fixture' as const,
    RewardConfigsOverviewHeader_anyRewardConfigInterface: 'RewardConfigsOverviewHeader_anyRewardConfigInterface' as const,
    SpecialRoomReward_roomsConfig: 'SpecialRoomReward_roomsConfig' as const,
    JerseyRewardPreview_JerseyDetails: 'JerseyRewardPreview_JerseyDetails' as const,
    DeliverableItemOrderFormDialog_deliverableItemOrderFragment: 'DeliverableItemOrderFormDialog_deliverableItemOrderFragment' as const,
    DeliverableItemPreview_deliverableItem: 'DeliverableItemPreview_deliverableItem' as const,
    DeliveryConfirmed_DeliverableItem: 'DeliveryConfirmed_DeliverableItem' as const,
    UnclaimedDeliverableItemOrderButton_deliverableItemOrder: 'UnclaimedDeliverableItemOrderButton_deliverableItemOrder' as const,
    BottomPerformers_anyGameInterface: 'BottomPerformers_anyGameInterface' as const,
    GameCardsPreview_cardWithPlayerGameScoreInterface: 'GameCardsPreview_cardWithPlayerGameScoreInterface' as const,
    GameCardsPreview_gameWithCardsPreview: 'GameCardsPreview_gameWithCardsPreview' as const,
    TeamStatsFragment_teamGameStatsInterface: 'TeamStatsFragment_teamGameStatsInterface' as const,
    GameStats_anyGameInterface: 'GameStats_anyGameInterface' as const,
    GameViewHeader_anyGameInterface: 'GameViewHeader_anyGameInterface' as const,
    GameViewHeader_anyGameInterfaceSubscription: 'GameViewHeader_anyGameInterfaceSubscription' as const,
    MyCard_anyCardInterface: 'MyCard_anyCardInterface' as const,
    MyCard_So5Appearance: 'MyCard_So5Appearance' as const,
    MyCards_anyCardInterface: 'MyCards_anyCardInterface' as const,
    MyCards_anyGameInterface: 'MyCards_anyGameInterface' as const,
    MyLineups_so5LeaderboardContender: 'MyLineups_so5LeaderboardContender' as const,
    RHEGrid_GameOfBaseball: 'RHEGrid_GameOfBaseball' as const,
    ScoresByInning_GameOfBaseball: 'ScoresByInning_GameOfBaseball' as const,
    TopPerformers_anyGameInterface: 'TopPerformers_anyGameInterface' as const,
    TopPlayers_AnyGameInterface: 'TopPlayers_AnyGameInterface' as const,
    CompetitionsFilter_competition: 'CompetitionsFilter_competition' as const,
    CompetitionsOptions_competition: 'CompetitionsOptions_competition' as const,
    Games_anyGameInterface: 'Games_anyGameInterface' as const,
    GamesNavigator_anyGameInterface: 'GamesNavigator_anyGameInterface' as const,
    Matches_anyGameInterface: 'Matches_anyGameInterface' as const,
    ChooseRewardCurrency_monetaryRewardConfig: 'ChooseRewardCurrency_monetaryRewardConfig' as const,
    ClaimWelcomeBackRewards_currentUser: 'ClaimWelcomeBackRewards_currentUser' as const,
    ClaimWelcomeBackRewards_cardSet: 'ClaimWelcomeBackRewards_cardSet' as const,
    ClaimStarterPack_cardSet: 'ClaimStarterPack_cardSet' as const,
    ClaimStarterPack_currentUser: 'ClaimStarterPack_currentUser' as const,
    ClaimStarterPack_cardSetRoot: 'ClaimStarterPack_cardSetRoot' as const,
    DailyRewardsCalendar_cardSet: 'DailyRewardsCalendar_cardSet' as const,
    DailyRewardsCalendar_taskInterface: 'DailyRewardsCalendar_taskInterface' as const,
    RewardSlot_anyRewardConfigInterface: 'RewardSlot_anyRewardConfigInterface' as const,
    DailyRewardsCalendarBoard_cardSet: 'DailyRewardsCalendarBoard_cardSet' as const,
    DailyRewardsCalendarBoard_taskInterface: 'DailyRewardsCalendarBoard_taskInterface' as const,
    DailyRewardsCalendarOrb_cardSet: 'DailyRewardsCalendarOrb_cardSet' as const,
    DailyRewardsCalendarOrb_taskInterface: 'DailyRewardsCalendarOrb_taskInterface' as const,
    GuessTheScoreComposeTeam_task: 'GuessTheScoreComposeTeam_task' as const,
    GuessTheScoreComposeTeam_lineup: 'GuessTheScoreComposeTeam_lineup' as const,
    HotStreaksTutorialStory_careerBoard: 'HotStreaksTutorialStory_careerBoard' as const,
    PickGoldenScore_guessTheScoreTask: 'PickGoldenScore_guessTheScoreTask' as const,
    NextTrckTile_cardSet: 'NextTrckTile_cardSet' as const,
    SetOnboardingNotificationsPrompt_cardSet: 'SetOnboardingNotificationsPrompt_cardSet' as const,
    hasPendingRewardStory_currentUser: 'hasPendingRewardStory_currentUser' as const,
    SeriesBoard_currentUser: 'SeriesBoard_currentUser' as const,
    SeriesBoard_cardSetRoot: 'SeriesBoard_cardSetRoot' as const,
    SeriesBoard_deliverableItemOrder: 'SeriesBoard_deliverableItemOrder' as const,
    TaskBenchCard_anyCardInterface: 'TaskBenchCard_anyCardInterface' as const,
    TaskBenchCard_composeTeamBenchObjectInterface: 'TaskBenchCard_composeTeamBenchObjectInterface' as const,
    TaskBenchExtra_anyCardInterface: 'TaskBenchExtra_anyCardInterface' as const,
    TaskBenchExtra_anyPlayerInterface: 'TaskBenchExtra_anyPlayerInterface' as const,
    TaskBenchObjectFooter_composeTeamBenchObjectInterface: 'TaskBenchObjectFooter_composeTeamBenchObjectInterface' as const,
    TaskCornerBadges_composeTeamBenchObjectInterface: 'TaskCornerBadges_composeTeamBenchObjectInterface' as const,
    TaskFieldCard_appearanceRule: 'TaskFieldCard_appearanceRule' as const,
    TaskFieldCard_composeTeamBenchObjectInterface: 'TaskFieldCard_composeTeamBenchObjectInterface' as const,
    ActivityOptions_activityFeedInterface: 'ActivityOptions_activityFeedInterface' as const,
    ActivityReactions_activityFeedInterface: 'ActivityReactions_activityFeedInterface' as const,
    CardPackActivity_cardPackActivityFeed: 'CardPackActivity_cardPackActivityFeed' as const,
    RecommendedManager_publicUserInfoInterface: 'RecommendedManager_publicUserInfoInterface' as const,
    Friend_publicUserInfoInterface: 'Friend_publicUserInfoInterface' as const,
    LineupActivity_lineupActivityFeed: 'LineupActivity_lineupActivityFeed' as const,
    ReactToActivity_activityFeedInterface: 'ReactToActivity_activityFeedInterface' as const,
    ReactionManager_activityReaction: 'ReactionManager_activityReaction' as const,
    SeriesHubOrb_cardPackActivityFeed: 'SeriesHubOrb_cardPackActivityFeed' as const,
    SeriesHubOrb_currentUser: 'SeriesHubOrb_currentUser' as const,
    ReferralMission_inviteTaskAsReferrer: 'ReferralMission_inviteTaskAsReferrer' as const,
    ReferralMissionDetails_inviteTaskAsReferrer: 'ReferralMissionDetails_inviteTaskAsReferrer' as const,
    ReferralMissionDialog_inviteTaskAsReferrer: 'ReferralMissionDialog_inviteTaskAsReferrer' as const,
    ConnectTaskWidget_currentUser: 'ConnectTaskWidget_currentUser' as const,
    ConnectTaskWidget_cardSetRoot: 'ConnectTaskWidget_cardSetRoot' as const,
    DailyActionTaskWidget_dailyActionTask: 'DailyActionTaskWidget_dailyActionTask' as const,
    FeaturedCollectionTaskWidget_taskInterface: 'FeaturedCollectionTaskWidget_taskInterface' as const,
    PlayMissionWidget_taskInterface: 'PlayMissionWidget_taskInterface' as const,
    SeriesMissionsWidgets_currentUser: 'SeriesMissionsWidgets_currentUser' as const,
    SeriesMissionsWidgets_cardSetRoot: 'SeriesMissionsWidgets_cardSetRoot' as const,
    SeriesMissionsWidgets_deliverableItemOrder: 'SeriesMissionsWidgets_deliverableItemOrder' as const,
    SeriesMissions_currentUser: 'SeriesMissions_currentUser' as const,
    SeriesMissions_deliverableItemOrder: 'SeriesMissions_deliverableItemOrder' as const,
    SeriesScheduleDialog_cardSet: 'SeriesScheduleDialog_cardSet' as const,
    SeriesScheduleDialog_thresholdPickerTaskLineup: 'SeriesScheduleDialog_thresholdPickerTaskLineup' as const,
    StepComposeTeam_composeTeamBenchObjectInterface: 'StepComposeTeam_composeTeamBenchObjectInterface' as const,
    StepComposeTeam_stepInterface: 'StepComposeTeam_stepInterface' as const,
    StepComposeTeam_lineupInterface: 'StepComposeTeam_lineupInterface' as const,
    CelebrationLineup_taskLineupInterface: 'CelebrationLineup_taskLineupInterface' as const,
    TargetHitCelebration_taskLineupInterface: 'TargetHitCelebration_taskLineupInterface' as const,
    usePendingTargetHitStep_careerBoard: 'usePendingTargetHitStep_careerBoard' as const,
    TaskComposeFilters_sortingType: 'TaskComposeFilters_sortingType' as const,
    TaskComposeFilters_displayedTypedRules: 'TaskComposeFilters_displayedTypedRules' as const,
    TaskComposeTeam_composeTeamBenchObjectInterface: 'TaskComposeTeam_composeTeamBenchObjectInterface' as const,
    TaskComposeTeam_taskInterface: 'TaskComposeTeam_taskInterface' as const,
    TaskComposeTeam_lineup: 'TaskComposeTeam_lineup' as const,
    TaskComposeTeam_preparedLineup: 'TaskComposeTeam_preparedLineup' as const,
    TrainingReplayDialog_thresholdPickerTaskLineup: 'TrainingReplayDialog_thresholdPickerTaskLineup' as const,
    TrainingTitle_careerBoard: 'TrainingTitle_careerBoard' as const,
    TrainingSetBoard_currentUser: 'TrainingSetBoard_currentUser' as const,
    TrainingSetBoard_cardSetRoot: 'TrainingSetBoard_cardSetRoot' as const,
    TrainingSetDialog_taskInterface: 'TrainingSetDialog_taskInterface' as const,
    InviteContent_cardSetRoot: 'InviteContent_cardSetRoot' as const,
    RewardsContent_cardSetRoot: 'RewardsContent_cardSetRoot' as const,
    RefereeExclusiveReward_currentUser: 'RefereeExclusiveReward_currentUser' as const,
    RefereeExclusiveReward_cardSet: 'RefereeExclusiveReward_cardSet' as const,
    ReferrerReward_inviteTaskAsReferrer: 'ReferrerReward_inviteTaskAsReferrer' as const,
    ReferrerReward_cardSet: 'ReferrerReward_cardSet' as const,
    GuessTheScoreTaskLineupHeader_guessTheScoreTask: 'GuessTheScoreTaskLineupHeader_guessTheScoreTask' as const,
    GuessTheScoreTaskLineupHeader_guessTheScoreTaskLineup: 'GuessTheScoreTaskLineupHeader_guessTheScoreTaskLineup' as const,
    GuessTheScoreTaskLineup_guessTheScoreTask: 'GuessTheScoreTaskLineup_guessTheScoreTask' as const,
    GuessTheScoreTaskLineup_guessTheScoreTaskLineup: 'GuessTheScoreTaskLineup_guessTheScoreTaskLineup' as const,
    LineupButtons_lineupInterface: 'LineupButtons_lineupInterface' as const,
    LineupCards_so5RuleInterface: 'LineupCards_so5RuleInterface' as const,
    LineupCards_taskLineupInterface: 'LineupCards_taskLineupInterface' as const,
    MissionHighlightBanner_task: 'MissionHighlightBanner_task' as const,
    ShareLineupButton_taskLineupInterface: 'ShareLineupButton_taskLineupInterface' as const,
    TaskLineupScore_taskLineupInterface: 'TaskLineupScore_taskLineupInterface' as const,
    TaskLineup_taskLineupInterface: 'TaskLineup_taskLineupInterface' as const,
    TaskLineup_task: 'TaskLineup_task' as const,
    TaskLineup_careerProStep: 'TaskLineup_careerProStep' as const,
    DefaultContent_clubShopItem: 'DefaultContent_clubShopItem' as const,
    LogoContent_clubShopItem: 'LogoContent_clubShopItem' as const,
    SkinContent_clubShopItem: 'SkinContent_clubShopItem' as const,
    Details_shopItem: 'Details_shopItem' as const,
    ItemPreviewDialog_shopItem: 'ItemPreviewDialog_shopItem' as const,
    DefaultListing_shopItem: 'DefaultListing_shopItem' as const,
    DefaultListing_userSportProfile: 'DefaultListing_userSportProfile' as const,
    ComposeTeamTutorial_so5Leaderboard: 'ComposeTeamTutorial_so5Leaderboard' as const,
    CardLayout_so5lineup: 'CardLayout_so5lineup' as const,
    LevelUp_cardXpGradeThreshold: 'LevelUp_cardXpGradeThreshold' as const,
    LevelUp_leveledUpCard: 'LevelUp_leveledUpCard' as const,
    CardLeveledUp_cardXpGradeThreshold: 'CardLeveledUp_cardXpGradeThreshold' as const,
    CardLeveledUp_so5Fixture: 'CardLeveledUp_so5Fixture' as const,
    CardLeveledup_leveledUpCard: 'CardLeveledup_leveledUpCard' as const,
    AlternativeRewardButton_anyRewardConfigInterface: 'AlternativeRewardButton_anyRewardConfigInterface' as const,
    AmountReward_anyRewardConfigInterface: 'AmountReward_anyRewardConfigInterface' as const,
    AmountReward_so5Reward: 'AmountReward_so5Reward' as const,
    CardReveal_anyCard: 'CardReveal_anyCard' as const,
    CardRewardWithRewardChoices_so5Reward: 'CardRewardWithRewardChoices_so5Reward' as const,
    CardShardsReward_anyRewardConfigInterface: 'CardShardsReward_anyRewardConfigInterface' as const,
    CardShardsReward_so5Reward: 'CardShardsReward_so5Reward' as const,
    InGameCurrencyReward_anyRewardConfigInterface: 'InGameCurrencyReward_anyRewardConfigInterface' as const,
    RankingInfo_so5Ranking: 'RankingInfo_so5Ranking' as const,
    RevealableReward_anyRewardConfigInterface: 'RevealableReward_anyRewardConfigInterface' as const,
    RevealableReward_so5Reward: 'RevealableReward_so5Reward' as const,
    RewardWithAlternaltiveReward_anyRewardConfigInterface: 'RewardWithAlternaltiveReward_anyRewardConfigInterface' as const,
    RewardWithAlternaltiveReward_so5Reward: 'RewardWithAlternaltiveReward_so5Reward' as const,
    CardRewardsReveal_so5Reward: 'CardRewardsReveal_so5Reward' as const,
    CardRewardsReveal_so5Fixture: 'CardRewardsReveal_so5Fixture' as const,
    StreakProgressAnimated_thresholdsStreakTask: 'StreakProgressAnimated_thresholdsStreakTask' as const,
    StreakRewardAnimated_anyRewardConfigInterface: 'StreakRewardAnimated_anyRewardConfigInterface' as const,
    StreakCard_thresholdsStreakTask: 'StreakCard_thresholdsStreakTask' as const,
    CompletedStreakTask_so5Fixture: 'CompletedStreakTask_so5Fixture' as const,
    CompletedStreakTask_thresholdsStreakTask: 'CompletedStreakTask_thresholdsStreakTask' as const,
    Intro_so5Reward: 'Intro_so5Reward' as const,
    Intro_so5Fixture: 'Intro_so5Fixture' as const,
    Title_so5Fixture: 'Title_so5Fixture' as const,
    LeaderboardDivisionChangeRecap_so5Ranking: 'LeaderboardDivisionChangeRecap_so5Ranking' as const,
    Promotion_so5Fixture: 'Promotion_so5Fixture' as const,
    Relegation_so5Fixture: 'Relegation_so5Fixture' as const,
    RewardsFlow_userGroupMembershipShopItemsUpdate: 'RewardsFlow_userGroupMembershipShopItemsUpdate' as const,
    RewardsFlow_currentUser: 'RewardsFlow_currentUser' as const,
    RewardsFlow_thresholdsStreakTask: 'RewardsFlow_thresholdsStreakTask' as const,
    RewardsFlow_cardXpGradeThreshold: 'RewardsFlow_cardXpGradeThreshold' as const,
    RewardsFlow_leveledUpCard: 'RewardsFlow_leveledUpCard' as const,
    RewardsFlow_so5Reward: 'RewardsFlow_so5Reward' as const,
    RewardsFlow_so5Fixture: 'RewardsFlow_so5Fixture' as const,
    DeliverableItemBlock_deliverableItemReward: 'DeliverableItemBlock_deliverableItemReward' as const,
    DeliverableItemBlock_deliverableItemOrder: 'DeliverableItemBlock_deliverableItemOrder' as const,
    RewardsRecap_anyRewardConfigInterface: 'RewardsRecap_anyRewardConfigInterface' as const,
    RewardsRecap_rarityRewardConfigs: 'RewardsRecap_rarityRewardConfigs' as const,
    RewardsRecap_so5Reward: 'RewardsRecap_so5Reward' as const,
    RewardsRecap_so5Fixture: 'RewardsRecap_so5Fixture' as const,
    useRewardsVerification_so5Reward: 'useRewardsVerification_so5Reward' as const,
    LazyLastFixtureStory_story: 'LazyLastFixtureStory_story' as const,
    useDisplayFixtureStory_story: 'useDisplayFixtureStory_story' as const,
    Spotlight_spotlight: 'Spotlight_spotlight' as const,
    SpotlightShortcut_spotlight: 'SpotlightShortcut_spotlight' as const,
    SpotlightStatTiles_spotlight: 'SpotlightStatTiles_spotlight' as const,
    Spotlights_spotlight: 'Spotlights_spotlight' as const,
    SpotlightsTrigger_spotlight: 'SpotlightsTrigger_spotlight' as const,
    GuessTheScoreIntroDialog_guessTheScoreTask: 'GuessTheScoreIntroDialog_guessTheScoreTask' as const,
    GuessTheScoreBadge_taskInterface: 'GuessTheScoreBadge_taskInterface' as const,
    JoinSquadDialog_squad: 'JoinSquadDialog_squad' as const,
    ProOnboardingBadge_cardSet: 'ProOnboardingBadge_cardSet' as const,
    RewardBlock_cardPacksRewardConfig: 'RewardBlock_cardPacksRewardConfig' as const,
    SquadAvatars_squadStep: 'SquadAvatars_squadStep' as const,
    SquadBadge_squadBoard: 'SquadBadge_squadBoard' as const,
    SquadBadge_squadStep: 'SquadBadge_squadStep' as const,
    ScoreBlock_squadStep: 'ScoreBlock_squadStep' as const,
    ScoreBlock_squadBoard: 'ScoreBlock_squadBoard' as const,
    SquadStepTile_squadStep: 'SquadStepTile_squadStep' as const,
    SquadBoard_currentUser: 'SquadBoard_currentUser' as const,
    SquadCreated_squad: 'SquadCreated_squad' as const,
    SquadEntryBadge_board: 'SquadEntryBadge_board' as const,
    SquadEntryBadge_squad: 'SquadEntryBadge_squad' as const,
    SquadJoined_squad: 'SquadJoined_squad' as const,
    SquadLineup_lineupInterface: 'SquadLineup_lineupInterface' as const,
    SquadLineup_so5RuleInterface: 'SquadLineup_so5RuleInterface' as const,
    SquadLineupsPageHeader_squadStep: 'SquadLineupsPageHeader_squadStep' as const,
    SquadMembersButton_squad: 'SquadMembersButton_squad' as const,
    SquadMembersList_squad: 'SquadMembersList_squad' as const,
    SquadSearchResult_squad: 'SquadSearchResult_squad' as const,
    BenchObjectDrawer_playerGameScoreInterface: 'BenchObjectDrawer_playerGameScoreInterface' as const,
    BenchObjectDrawer_anyPlayerInterface: 'BenchObjectDrawer_anyPlayerInterface' as const,
    BenchObjectDrawer_anyCardInterface: 'BenchObjectDrawer_anyCardInterface' as const,
    BriefSo5AppearanceScore_so5Appearance: 'BriefSo5AppearanceScore_so5Appearance' as const,
    So5AppearenceInlineGames_so5Appearance: 'So5AppearenceInlineGames_so5Appearance' as const,
    So5AppearenceInlineGamesDots_so5Appearance: 'So5AppearenceInlineGamesDots_so5Appearance' as const,
    GamesStanding_TeamInterface: 'GamesStanding_TeamInterface' as const,
    TopPlayersFilters_so5Fixture: 'TopPlayersFilters_so5Fixture' as const,
    FixtureCompetitionTabs_so5LeagueTrack: 'FixtureCompetitionTabs_so5LeagueTrack' as const,
    TrckGroupAside_so5Fixture: 'TrckGroupAside_so5Fixture' as const,
    TrckGroupAside_so5LeaderboardGroupInterface: 'TrckGroupAside_so5LeaderboardGroupInterface' as const,
    TrckGroupAside_so5LeagueTrackGroup: 'TrckGroupAside_so5LeagueTrackGroup' as const,
    TrckGroupAsideGWSelector_so5Fixture: 'TrckGroupAsideGWSelector_so5Fixture' as const,
    VaultPointsRuleBox_So5Leaderboard: 'VaultPointsRuleBox_So5Leaderboard' as const,
    TrckGroupAsideHeader_So5Fixture: 'TrckGroupAsideHeader_So5Fixture' as const,
    TrckGroupAsideHeader_So5LeaderboardGroupInterface: 'TrckGroupAsideHeader_So5LeaderboardGroupInterface' as const,
    TrckGroupAsideHeader_So5LeagueTrack: 'TrckGroupAsideHeader_So5LeagueTrack' as const,
    TrckGroupAsideMatches_so5Fixture: 'TrckGroupAsideMatches_so5Fixture' as const,
    TrckGroupAsideMatches_so5LeagueTrack: 'TrckGroupAsideMatches_so5LeagueTrack' as const,
    HotStreakLadder_so5Fixture: 'HotStreakLadder_so5Fixture' as const,
    HotStreakLadder_thresholdsStreakTask: 'HotStreakLadder_thresholdsStreakTask' as const,
    TrckGroupAsidePrizePool_so5Leaderboard: 'TrckGroupAsidePrizePool_so5Leaderboard' as const,
    TrckGroupAsidePrizePool_so5Fixture: 'TrckGroupAsidePrizePool_so5Fixture' as const,
    MissingCardsMessage_so5Leaderboard: 'MissingCardsMessage_so5Leaderboard' as const,
    getMissingCards_validity: 'getMissingCards_validity' as const,
    MyCardsContext_cardSet: 'MyCardsContext_cardSet' as const,
    useBenchObjectsTotalScore_so5RuleInterface: 'useBenchObjectsTotalScore_so5RuleInterface' as const,
    useBenchObjectsTotalScore_composeTeamBenchObjectInterface: 'useBenchObjectsTotalScore_composeTeamBenchObjectInterface' as const,
    useBenchObjectsTotalScore_so5AppearanceBonusInterface: 'useBenchObjectsTotalScore_so5AppearanceBonusInterface' as const,
    useBulkComposeBuy_anyCard: 'useBulkComposeBuy_anyCard' as const,
    useBulkComposeBuy_composeTeamBenchObjectInterface: 'useBulkComposeBuy_composeTeamBenchObjectInterface' as const,
    useComposeActions_so5Leaderboard: 'useComposeActions_so5Leaderboard' as const,
    useComposeActions_composeTeamBenchObjectInterface: 'useComposeActions_composeTeamBenchObjectInterface' as const,
    useComposeActions_so5Lineup: 'useComposeActions_so5Lineup' as const,
    useComposeActions_managerTeam: 'useComposeActions_managerTeam' as const,
    useComposeBuy_anyCardInterface: 'useComposeBuy_anyCardInterface' as const,
    useGameplayTierStarCap_so5RuleInterface: 'useGameplayTierStarCap_so5RuleInterface' as const,
    useGameplayTierStarCap_composeTeamBenchObjectInterface: 'useGameplayTierStarCap_composeTeamBenchObjectInterface' as const,
    useLineupCap_so5RuleInterface: 'useLineupCap_so5RuleInterface' as const,
    useLineupCap_composeTeamBenchObjectInterface: 'useLineupCap_composeTeamBenchObjectInterface' as const,
    useRefreshBenchObjectsFromCart_composeTeamBenchObjectInterface: 'useRefreshBenchObjectsFromCart_composeTeamBenchObjectInterface' as const,
    useSaveBestPackCardPicture_anyCardInterface: 'useSaveBestPackCardPicture_anyCardInterface' as const,
    BasicFixtureLayout_so5Fixture: 'BasicFixtureLayout_so5Fixture' as const,
    ChampionshipLayout_so5UserGroupLeaderboard: 'ChampionshipLayout_so5UserGroupLeaderboard' as const,
    ChampionshipLayout_so5UserGroup: 'ChampionshipLayout_so5UserGroup' as const,
    GenericLeaderboardPrizePoolLayout_so5Leaderboard: 'GenericLeaderboardPrizePoolLayout_so5Leaderboard' as const,
    GenericLeaderboardPrizePoolLayout_so5LeaderboardContender: 'GenericLeaderboardPrizePoolLayout_so5LeaderboardContender' as const,
    HideTeamDialog_managerTeam: 'HideTeamDialog_managerTeam' as const,
    HideTeamDialog_so5Leaderboard: 'HideTeamDialog_so5Leaderboard' as const,
    LineupFooter_so5LeaderboardContender: 'LineupFooter_so5LeaderboardContender' as const,
    LineupActionsDropdown_so5LeaderboardContender: 'LineupActionsDropdown_so5LeaderboardContender' as const,
    LineupLayoutHeader_so5LeaderboardContender: 'LineupLayoutHeader_so5LeaderboardContender' as const,
    LineupRanking_so5LeaderboardContender: 'LineupRanking_so5LeaderboardContender' as const,
    LineupStatus_so5LeaderboardContender: 'LineupStatus_so5LeaderboardContender' as const,
    LineupFooterStatus_lineupInterface: 'LineupFooterStatus_lineupInterface' as const,
    LineupFooterStatus_so5Lineup: 'LineupFooterStatus_so5Lineup' as const,
    SimpleContenderFooterStatus_so5LeaderboardContender: 'SimpleContenderFooterStatus_so5LeaderboardContender' as const,
    LeftLiveLineupFooter_so5LeaderboardContender: 'LeftLiveLineupFooter_so5LeaderboardContender' as const,
    RightLiveLineupFooter_so5LeaderboardContender: 'RightLiveLineupFooter_so5LeaderboardContender' as const,
    LiveLineupFooter_so5LeaderboardContender: 'LiveLineupFooter_so5LeaderboardContender' as const,
    TeamLineupFooter_so5LeaderboardContender: 'TeamLineupFooter_so5LeaderboardContender' as const,
    TeamLineupLayout_so5LeaderboardContender: 'TeamLineupLayout_so5LeaderboardContender' as const,
    WithChaseHeaderLayout_so5UserGroup: 'WithChaseHeaderLayout_so5UserGroup' as const,
    WithFixtureHeaderLayout_so5Fixture: 'WithFixtureHeaderLayout_so5Fixture' as const,
    GameSection_gameWithCardsPreview: 'GameSection_gameWithCardsPreview' as const,
    bookmarkTarget_bookmark: 'bookmarkTarget_bookmark' as const,
    isCardLockedIn_cardUsageInterface: 'isCardLockedIn_cardUsageInterface' as const,
    getContenderStatus_so5LeaderboardContender: 'getContenderStatus_so5LeaderboardContender' as const,
    getContenderRightFooterState_so5LeaderboardContender: 'getContenderRightFooterState_so5LeaderboardContender' as const,
    getNextEligibleRewardsState_so5LeaderboardContender: 'getNextEligibleRewardsState_so5LeaderboardContender' as const,
    hasContenderStreakReward_so5LeaderboardContender: 'hasContenderStreakReward_so5LeaderboardContender' as const,
    getContenderLeftFooterState_so5LeaderboardContender: 'getContenderLeftFooterState_so5LeaderboardContender' as const,
    getSecondaryContenderFooterState_so5LeaderboardContender: 'getSecondaryContenderFooterState_so5LeaderboardContender' as const,
    getNbDecks_publicUserInfoInterface: 'getNbDecks_publicUserInfoInterface' as const,
    getLineupDisplayName_so5Leaderboard: 'getLineupDisplayName_so5Leaderboard' as const,
    getLineupDisplayName_so5Lineup: 'getLineupDisplayName_so5Lineup' as const,
    getLineupDisplayName_managerTeam: 'getLineupDisplayName_managerTeam' as const,
    playerHasPlayedInLeaderboard_anyPlayer: 'playerHasPlayedInLeaderboard_anyPlayer' as const,
    isFixtureStarted_so5Fixture: 'isFixtureStarted_so5Fixture' as const,
    isFixtureOpened_so5Fixture: 'isFixtureOpened_so5Fixture' as const,
    isFixtureLive_so5Fixture: 'isFixtureLive_so5Fixture' as const,
    isFixtureClosed_so5Fixture: 'isFixtureClosed_so5Fixture' as const,
    hasGamesStarted_so5Lineup: 'hasGamesStarted_so5Lineup' as const,
    getLineupSlotCounts_so5Leaderboard: 'getLineupSlotCounts_so5Leaderboard' as const,
    getFixtureState_so5Fixture: 'getFixtureState_so5Fixture' as const,
    getTeamName_team: 'getTeamName_team' as const,
    getCompetitionPictureUrl_competition: 'getCompetitionPictureUrl_competition' as const,
    isCardUsed_anyCard: 'isCardUsed_anyCard' as const,
    hasLeagueTrackExtraSlot_so5LeagueTrack: 'hasLeagueTrackExtraSlot_so5LeagueTrack' as const,
    hasLeaderboardGroupExtraSlot_so5LeaderboardGroupInterface: 'hasLeaderboardGroupExtraSlot_so5LeaderboardGroupInterface' as const,
    getAddTeamPath_so5LeaderboardGroupInterface: 'getAddTeamPath_so5LeaderboardGroupInterface' as const,
    isAppearanceLocked_so5Appearance: 'isAppearanceLocked_so5Appearance' as const,
    getLeaguesWithContenders_so5LeaderboardGroupInterface: 'getLeaguesWithContenders_so5LeaderboardGroupInterface' as const,
    getComposeTeamSuccessRoute_so5Leaderboard: 'getComposeTeamSuccessRoute_so5Leaderboard' as const,
    hasSomeCardsForLeaderboard_so5Leaderboard: 'hasSomeCardsForLeaderboard_so5Leaderboard' as const,
    getSo5LeaguesByGroup_so5Fixture: 'getSo5LeaguesByGroup_so5Fixture' as const,
    getBestProjection_playerGameScoreInterface: 'getBestProjection_playerGameScoreInterface' as const,
    getTaskCompetitionColor_taskInterface: 'getTaskCompetitionColor_taskInterface' as const,
    UserFixtureResultLink_userFixtureResults: 'UserFixtureResultLink_userFixtureResults' as const,
    UserFixtureResultLink_so5Fixture: 'UserFixtureResultLink_so5Fixture' as const,
    RevealCarousel_card: 'RevealCarousel_card' as const,
    RevealCarousel_searchCards: 'RevealCarousel_searchCards' as const,
    CompetitionGamesPage_so5LeaderboardGroupInterface: 'CompetitionGamesPage_so5LeaderboardGroupInterface' as const,
    CompetitionGamesPages_paginatedSo5LeaderboardGroupInterface: 'CompetitionGamesPages_paginatedSo5LeaderboardGroupInterface' as const,
    ContenderPage_so5LeaderboardContender: 'ContenderPage_so5LeaderboardContender' as const,
    MatchCenterGame_gameWithPlayerGameScoresPreview: 'MatchCenterGame_gameWithPlayerGameScoresPreview' as const,
    MatchCenterPage_so5Fixture: 'MatchCenterPage_so5Fixture' as const,
    DelayedAndRevealed_RevealableCardCampaign: 'DelayedAndRevealed_RevealableCardCampaign' as const,
    Reveal3dTearable_AnyCardInterface: 'Reveal3dTearable_AnyCardInterface' as const,
    RevealChip_RevealableCardCampaign: 'RevealChip_RevealableCardCampaign' as const,
    RevealChip_AnyCardInterface: 'RevealChip_AnyCardInterface' as const,
    RankingsPage_so5Leaderboard: 'RankingsPage_so5Leaderboard' as const,
    RankingsPage_so5LeaderboardContender: 'RankingsPage_so5LeaderboardContender' as const,
    HomeEventType_so5Root: 'HomeEventType_so5Root' as const,
    HomeEventType_tokenRoot: 'HomeEventType_tokenRoot' as const,
    HomeEventType_marketRoot: 'HomeEventType_marketRoot' as const,
    HomeEventType_taskCampaignsHomepage: 'HomeEventType_taskCampaignsHomepage' as const,
    SetInvitePage_cardSet: 'SetInvitePage_cardSet' as const,
    getRewardBoostRatio_anyRewardConfig: 'getRewardBoostRatio_anyRewardConfig' as const,
    PrepareLineupPrompt_taskInterface: 'PrepareLineupPrompt_taskInterface' as const,
    PreparedTaskLineup_taskPreparedLineup: 'PreparedTaskLineup_taskPreparedLineup' as const,
    SquadLineupsStickyFooter_squadStep: 'SquadLineupsStickyFooter_squadStep' as const,
    ConfirmationDialogContent_anyCard: 'ConfirmationDialogContent_anyCard' as const,
    FindItInCardPacks_cardPack: 'FindItInCardPacks_cardPack' as const,
    Actions_card: 'Actions_card' as const,
    BlueprintDisclaimer_AnyCardInterface: 'BlueprintDisclaimer_AnyCardInterface' as const,
    CardAttributes_anyCard: 'CardAttributes_anyCard' as const,
    CardLoyaltyBoost_AnyCardInterface: 'CardLoyaltyBoost_AnyCardInterface' as const,
    CardPackOrigin_anyCard: 'CardPackOrigin_anyCard' as const,
    CardPageBackground_cardSet: 'CardPageBackground_cardSet' as const,
    ClassicCardPage_anyCard: 'ClassicCardPage_anyCard' as const,
    CompetitionLogo_so5Leaderboard: 'CompetitionLogo_so5Leaderboard' as const,
    EligibleCompetition_so5Leaderboard: 'EligibleCompetition_so5Leaderboard' as const,
    CompetitionsEligibility_anyCard: 'CompetitionsEligibility_anyCard' as const,
    useCompetitionsEligibility_anyCard: 'useCompetitionsEligibility_anyCard' as const,
    GlobalCupBonus_anyCard: 'GlobalCupBonus_anyCard' as const,
    CardLevelPreview_card: 'CardLevelPreview_card' as const,
    useCardLevelSprings_card: 'useCardLevelSprings_card' as const,
    Level_anyCardInterface: 'Level_anyCardInterface' as const,
    LiveOffer_tokenOffer: 'LiveOffer_tokenOffer' as const,
    MyOffers_anyCard: 'MyOffers_anyCard' as const,
    PlayerInfo_anyCard: 'PlayerInfo_anyCard' as const,
    RevealDelayedWarning_anyCard: 'RevealDelayedWarning_anyCard' as const,
    SeriesCardSlot_userCardCollectionSlot: 'SeriesCardSlot_userCardCollectionSlot' as const,
    GenericCardPage_anyCard: 'GenericCardPage_anyCard' as const,
    ItemOwner_user: 'ItemOwner_user' as const,
    ItemOwnerSince_anyCard: 'ItemOwnerSince_anyCard' as const,
    ItemSold_anyCard: 'ItemSold_anyCard' as const,
    SkinEditionSwitcher_userCardCollectionSlot: 'SkinEditionSwitcher_userCardCollectionSlot' as const,
    Team_anyCard: 'Team_anyCard' as const,
    Team_anyPlayerInterface: 'Team_anyPlayerInterface' as const,
    OwnerMyClubLink_User: 'OwnerMyClubLink_User' as const,
    TokenOwner_anyCard: 'TokenOwner_anyCard' as const,
    TradeButton_publicUserInfoInterface: 'TradeButton_publicUserInfoInterface' as const,
    FreeTicket_TaskInterface: 'FreeTicket_TaskInterface' as const,
    GetMoreTickets_taskInterface: 'GetMoreTickets_taskInterface' as const,
    WheelHistoryRow_probabilisticBundleSlotConfig: 'WheelHistoryRow_probabilisticBundleSlotConfig' as const,
    WheelHistoryRow_probabilisticBundleSlotItemInterface: 'WheelHistoryRow_probabilisticBundleSlotItemInterface' as const,
    Reward_probabilisticBundleSlotItemInterface: 'Reward_probabilisticBundleSlotItemInterface' as const,
    Reward_probabilisticBundleSlotConfig: 'Reward_probabilisticBundleSlotConfig' as const,
    Shape_probabilisticBundleSlotConfig: 'Shape_probabilisticBundleSlotConfig' as const,
    Slot_probabilisticBundleSlotConfig: 'Slot_probabilisticBundleSlotConfig' as const,
    isWorthyOfCelebration_ProbabilisticBundleSlotConfig: 'isWorthyOfCelebration_ProbabilisticBundleSlotConfig' as const,
    useWheelReward_probabilisticBundleSlotConfig: 'useWheelReward_probabilisticBundleSlotConfig' as const,
    AuctionBidsInfo_auction: 'AuctionBidsInfo_auction' as const,
    AuctionWinner_auction: 'AuctionWinner_auction' as const,
    AuctionDetails_auction: 'AuctionDetails_auction' as const,
    AuctionImg_auction: 'AuctionImg_auction' as const,
    Auction_auction: 'Auction_auction' as const,
    AuctionBidItem_tokenAuction: 'AuctionBidItem_tokenAuction' as const,
    AuctionEligibility_tokenAuction: 'AuctionEligibility_tokenAuction' as const,
    AuctionReminder_auction: 'AuctionReminder_auction' as const,
    AuctionStatus_auction: 'AuctionStatus_auction' as const,
    AuctionsActions_auction: 'AuctionsActions_auction' as const,
    Bid_tokenBid: 'Bid_tokenBid' as const,
    Bid_AnyRewardInterface: 'Bid_AnyRewardInterface' as const,
    Bid_AnyRewardConfigInterface: 'Bid_AnyRewardConfigInterface' as const,
    BidHistory_tokenBidConnection: 'BidHistory_tokenBidConnection' as const,
    BidHistory_tokenAuction: 'BidHistory_tokenAuction' as const,
    BidInfos_auction: 'BidInfos_auction' as const,
    BidToEarn_TokenAuction: 'BidToEarn_TokenAuction' as const,
    BidsCount_auction: 'BidsCount_auction' as const,
    BundledAuctionPreview_anyCard: 'BundledAuctionPreview_anyCard' as const,
    BundledAuctionPreview_auction: 'BundledAuctionPreview_auction' as const,
    MyBidsBanner_auctionConnection: 'MyBidsBanner_auctionConnection' as const,
    OpenAuction_auction: 'OpenAuction_auction' as const,
    BidBundleSummary_auction: 'BidBundleSummary_auction' as const,
    BidResume_tokenAuction: 'BidResume_tokenAuction' as const,
    BidConfirmedDialogContent_tokenAuction: 'BidConfirmedDialogContent_tokenAuction' as const,
    BidPaymentModal_auction: 'BidPaymentModal_auction' as const,
    usePollAuctionBestBid_auction: 'usePollAuctionBestBid_auction' as const,
    EndedAuctionPaymentBox_tokenAuction: 'EndedAuctionPaymentBox_tokenAuction' as const,
    BidField_auction: 'BidField_auction' as const,
    BidTokenSummary_anyCard: 'BidTokenSummary_anyCard' as const,
    BuyField_anyCard: 'BuyField_anyCard' as const,
    BuyTokenConfirmation_anyCard: 'BuyTokenConfirmation_anyCard' as const,
    CancelOffer_anyCard: 'CancelOffer_anyCard' as const,
    InSeasonWarning_anyCard: 'InSeasonWarning_anyCard' as const,
    AuctionMetas_auction: 'AuctionMetas_auction' as const,
    BidContent_auction: 'BidContent_auction' as const,
    EligibilityTooltip_anyCard: 'EligibilityTooltip_anyCard' as const,
    StreaksPromotion_anyCardInterface: 'StreaksPromotion_anyCardInterface' as const,
    CardOverview_anyCard: 'CardOverview_anyCard' as const,
    PaymentProvider_auction: 'PaymentProvider_auction' as const,
    TokenSummary_anyCard: 'TokenSummary_anyCard' as const,
    TokensSummary_anyCard: 'TokensSummary_anyCard' as const,
    BoostButton_anyCard: 'BoostButton_anyCard' as const,
    CardBonus_anyCard: 'CardBonus_anyCard' as const,
    CardFooter_anyCardInterface: 'CardFooter_anyCardInterface' as const,
    CardProperties_anyCard: 'CardProperties_anyCard' as const,
    CardPropertiesWithStats_anyCard: 'CardPropertiesWithStats_anyCard' as const,
    CardRow_anyCardBaseData: 'CardRow_anyCardBaseData' as const,
    CardRow_anyCard: 'CardRow_anyCard' as const,
    DirectOffer_CardRow_anyCard: 'DirectOffer_CardRow_anyCard' as const,
    CardsShow_anyCard: 'CardsShow_anyCard' as const,
    CollectionPrediction_anyCard: 'CollectionPrediction_anyCard' as const,
    CollectionUpsellCard_anyCard: 'CollectionUpsellCard_anyCard' as const,
    IneligibleIndicator_anyPlayer: 'IneligibleIndicator_anyPlayer' as const,
    InlineCard_anyCardInterface: 'InlineCard_anyCardInterface' as const,
    ItemEligibility_card: 'ItemEligibility_card' as const,
    NBAAnyCardFooter_anyCardInterface: 'NBAAnyCardFooter_anyCardInterface' as const,
    NBACardFooter_anyPlayerInterface: 'NBACardFooter_anyPlayerInterface' as const,
    ScrapCardSection_anyCardInterface: 'ScrapCardSection_anyCardInterface' as const,
    useCardXpProgressBarSprings_cardXpGradeThreshold: 'useCardXpProgressBarSprings_cardXpGradeThreshold' as const,
    useCardXpProgressBarSprings_leveledUpCard: 'useCardXpProgressBarSprings_leveledUpCard' as const,
    useSimpleCardXpProgressBar_anyCard: 'useSimpleCardXpProgressBar_anyCard' as const,
    AddToCart_anyCard: 'AddToCart_anyCard' as const,
    AddToCartOnClickWrapper_anyCard: 'AddToCartOnClickWrapper_anyCard' as const,
    useEligibleForCartPromo_anyCard: 'useEligibleForCartPromo_anyCard' as const,
    AddToCartPopin_anyCard: 'AddToCartPopin_anyCard' as const,
    CartItem_anyCard: 'CartItem_anyCard' as const,
    CartItem_cartItem: 'CartItem_cartItem' as const,
    CartItemStateWarning_cartItem: 'CartItemStateWarning_cartItem' as const,
    CartPayment_cart: 'CartPayment_cart' as const,
    EligibleCollectionsDialog_cardCollection: 'EligibleCollectionsDialog_cardCollection' as const,
    EligibleCollectionsDialog_deliverableItemVariantsStocks: 'EligibleCollectionsDialog_deliverableItemVariantsStocks' as const,
    CartPromo_cartPurchaseRewardPromotionalEvent: 'CartPromo_cartPurchaseRewardPromotionalEvent' as const,
    CartPromos_cart: 'CartPromos_cart' as const,
    CollectionUpsellTitle_cardCollection: 'CollectionUpsellTitle_cardCollection' as const,
    CollectionUpsellContent_CardCollectionScoreIncrease: 'CollectionUpsellContent_CardCollectionScoreIncrease' as const,
    LazyCollectionElement_CardCollectionScoreIncrease: 'LazyCollectionElement_CardCollectionScoreIncrease' as const,
    MissingCardsForCollection_cardCollection: 'MissingCardsForCollection_cardCollection' as const,
    MissingCardsForCollection_userCardCollection: 'MissingCardsForCollection_userCardCollection' as const,
    useSortPrimaryBuys_anyCard: 'useSortPrimaryBuys_anyCard' as const,
    CollectionUpsell_CardCollectionScoreIncrease: 'CollectionUpsell_CardCollectionScoreIncrease' as const,
    LazyCartPromos_cart: 'LazyCartPromos_cart' as const,
    MainCartItems_cartItem: 'MainCartItems_cartItem' as const,
    SavedForLaterItem_anyCard: 'SavedForLaterItem_anyCard' as const,
    SavedForLaterItem_cartItem: 'SavedForLaterItem_cartItem' as const,
    SavedForLaterItems_cartItem: 'SavedForLaterItems_cartItem' as const,
    BundleDetailsDialog_bundledPurchasableItem: 'BundleDetailsDialog_bundledPurchasableItem' as const,
    BundleDetailsOverlay_bundledPurchasableItem: 'BundleDetailsOverlay_bundledPurchasableItem' as const,
    BuyPackButton_cardPack: 'BuyPackButton_cardPack' as const,
    BundledPurchasableRewards_purchasableItem: 'BundledPurchasableRewards_purchasableItem' as const,
    BuyCardPackFlow_cardPack: 'BuyCardPackFlow_cardPack' as const,
    BuyCardPackContent_cardPack: 'BuyCardPackContent_cardPack' as const,
    BundledPurchasableItem_bundledPurchasableItem: 'BundledPurchasableItem_bundledPurchasableItem' as const,
    GemsPack_inGameCurrencyPurchasableItem: 'GemsPack_inGameCurrencyPurchasableItem' as const,
    PackBadge_cardPack: 'PackBadge_cardPack' as const,
    PackDescription_cardPack: 'PackDescription_cardPack' as const,
    PackWithBuyButton_cardPack: 'PackWithBuyButton_cardPack' as const,
    SuccessBody_purchasableItem: 'SuccessBody_purchasableItem' as const,
    TokenPreview_purchasableItem: 'TokenPreview_purchasableItem' as const,
    PurchasableItemPaymentDialog_purchasableItem: 'PurchasableItemPaymentDialog_purchasableItem' as const,
    SeriesCardPackGroup_cardPackGroup: 'SeriesCardPackGroup_cardPackGroup' as const,
    SeriesDailyClaimModule_cardSet: 'SeriesDailyClaimModule_cardSet' as const,
    SeriesDailyClaimModule_task: 'SeriesDailyClaimModule_task' as const,
    WelcomePackOrb_availableVoucher: 'WelcomePackOrb_availableVoucher' as const,
    SpecialBundle_bundledPurchasableItem: 'SpecialBundle_bundledPurchasableItem' as const,
    GemsShop_gemsShop: 'GemsShop_gemsShop' as const,
    Content_cardPack: 'Content_cardPack' as const,
    PackContentPanel_cardPack: 'PackContentPanel_cardPack' as const,
    PackContents_cardPack: 'PackContents_cardPack' as const,
    PackOdds_cardPack: 'PackOdds_cardPack' as const,
    PackSlotGameplayTierOdds_gameplayTierOdds: 'PackSlotGameplayTierOdds_gameplayTierOdds' as const,
    PackRecap_anyCardInterface: 'PackRecap_anyCardInterface' as const,
    RevealPackCardsDialog_anyCardInterface: 'RevealPackCardsDialog_anyCardInterface' as const,
    RevealPackCardsDialog_cardSet: 'RevealPackCardsDialog_cardSet' as const,
    RevealPackCardsDialogFromReward_anyRewardInterface: 'RevealPackCardsDialogFromReward_anyRewardInterface' as const,
    SellCommonCard_anyCard: 'SellCommonCard_anyCard' as const,
    BoughtPacksCountTask_task: 'BoughtPacksCountTask_task' as const,
    CardPackGroupSection_cardPackGroup: 'CardPackGroupSection_cardPackGroup' as const,
    FeaturedCardPackSection_featuredCardPack: 'FeaturedCardPackSection_featuredCardPack' as const,
    FeaturedDailyClaim_task: 'FeaturedDailyClaim_task' as const,
    GemsShopSection_gemsShop: 'GemsShopSection_gemsShop' as const,
    MarketLiveOpsGameCard_anyGameInterface: 'MarketLiveOpsGameCard_anyGameInterface' as const,
    MarketLiveOpsSection_marketLiveOps: 'MarketLiveOpsSection_marketLiveOps' as const,
    MarketSetSectionTitle_marketSetSection: 'MarketSetSectionTitle_marketSetSection' as const,
    PacksLeftBadge_cardPack: 'PacksLeftBadge_cardPack' as const,
    SpecialOffersSection_specialOffers: 'SpecialOffersSection_specialOffers' as const,
    WeeklyDealCard_cardPack: 'WeeklyDealCard_cardPack' as const,
    WeeklyDealsSection_weeklyDeals: 'WeeklyDealsSection_weeklyDeals' as const,
    WelcomeOfferSection_marketSetWelcomeOffer: 'WelcomeOfferSection_marketSetWelcomeOffer' as const,
    SetMarketPage_marketRoot: 'SetMarketPage_marketRoot' as const,
    CardBonusWithTransition_skinEdition: 'CardBonusWithTransition_skinEdition' as const,
    CardInfos_anyCardInterface: 'CardInfos_anyCardInterface' as const,
    TinderCardSwipe_anyCardInterface: 'TinderCardSwipe_anyCardInterface' as const,
    AddTokenToDeck_anyCard: 'AddTokenToDeck_anyCard' as const,
    CounterOfferBuilder_tokenOffer: 'CounterOfferBuilder_tokenOffer' as const,
    MakeOffer_anyCard: 'MakeOffer_anyCard' as const,
    MinimumPrice_anyCard: 'MinimumPrice_anyCard' as const,
    AmountInput_AnyCardInterface: 'AmountInput_AnyCardInterface' as const,
    TradePaymentMethods_publicUserInfoInterface: 'TradePaymentMethods_publicUserInfoInterface' as const,
    OfferBuilderBuildingPage_baseCard: 'OfferBuilderBuildingPage_baseCard' as const,
    OfferBuilderBuildingPage_publicUserInfoInterface: 'OfferBuilderBuildingPage_publicUserInfoInterface' as const,
    OfferBuilderBuildingPage_anyCard: 'OfferBuilderBuildingPage_anyCard' as const,
    CardPicker_anyCard: 'CardPicker_anyCard' as const,
    OfferSide_anyCard: 'OfferSide_anyCard' as const,
    OfferUser_publicUserInfoInterface: 'OfferUser_publicUserInfoInterface' as const,
    OfferUser_user: 'OfferUser_user' as const,
    OfferBuilderSummary_anyCard: 'OfferBuilderSummary_anyCard' as const,
    NewOfferBuilder_publicUserInfoInterface: 'NewOfferBuilder_publicUserInfoInterface' as const,
    NewOfferBuilder_anyCard: 'NewOfferBuilder_anyCard' as const,
    useOnSubmit_anyCard: 'useOnSubmit_anyCard' as const,
    NewPrefilledOfferBuilder_tokenOffer: 'NewPrefilledOfferBuilder_tokenOffer' as const,
    NewPrefilledOfferBuilder_publicUserInfoInterface: 'NewPrefilledOfferBuilder_publicUserInfoInterface' as const,
    PromotionalEvent_PromotionalEvent: 'PromotionalEvent_PromotionalEvent' as const,
    PromotionalEvents_PromotionalEvent: 'PromotionalEvents_PromotionalEvent' as const,
    MultipleMatchupItem_anyGame: 'MultipleMatchupItem_anyGame' as const,
    PlayerGameStatsPrediction_playingStatusOdds: 'PlayerGameStatsPrediction_playingStatusOdds' as const,
    ScheduledPlayerGameScoreState_playerGameScore: 'ScheduledPlayerGameScoreState_playerGameScore' as const,
    SingleMatchupItem_anyGame: 'SingleMatchupItem_anyGame' as const,
    RecentPurchase_tokenOwner: 'RecentPurchase_tokenOwner' as const,
    FriendsRecentPurchases_tokenOwner: 'FriendsRecentPurchases_tokenOwner' as const,
    PromoBanner_PromotionalEvent: 'PromoBanner_PromotionalEvent' as const,
    PromoBanner_ProbabilisticBundleConfig: 'PromoBanner_ProbabilisticBundleConfig' as const,
    PromoBanner_ProbableRewardConfig: 'PromoBanner_ProbableRewardConfig' as const,
    PromoBanners_PromotionalEventsInterface: 'PromoBanners_PromotionalEventsInterface' as const,
    PromoBanners_WheelTicketRewardsInterface: 'PromoBanners_WheelTicketRewardsInterface' as const,
    MatchdayPickCard_instantBuyCampaign: 'MatchdayPickCard_instantBuyCampaign' as const,
    PlayerNotifications_subscription: 'PlayerNotifications_subscription' as const,
    HighScarcityStatus_highScarcityStatus: 'HighScarcityStatus_highScarcityStatus' as const,
    AccountEntry_authorizationRequest: 'AccountEntry_authorizationRequest' as const,
    Auction_authorizationRequest: 'Auction_authorizationRequest' as const,
    Bid_authorizationRequest: 'Bid_authorizationRequest' as const,
    Offer_authorizationRequest: 'Offer_authorizationRequest' as const,
    PrimaryOffer_authorizationRequest: 'PrimaryOffer_authorizationRequest' as const,
    Bid_userAccountEntry: 'Bid_userAccountEntry' as const,
    CardWithdrawal_userAccountEntry: 'CardWithdrawal_userAccountEntry' as const,
    Offer_userAccountEntry: 'Offer_userAccountEntry' as const,
    PrimaryOffer_userAccountEntry: 'PrimaryOffer_userAccountEntry' as const,
    DumbSo5Reward_userAccountEntry: 'DumbSo5Reward_userAccountEntry' as const,
    Reward_userAccountEntry: 'Reward_userAccountEntry' as const,
    TransactionsBid_tokenBid: 'TransactionsBid_tokenBid' as const,
    TransactionsOffer_tokenOffer: 'TransactionsOffer_tokenOffer' as const,
    TransactionsPrimaryOfferTitle_tokenPrimaryOffer: 'TransactionsPrimaryOfferTitle_tokenPrimaryOffer' as const,
    TransactionsPrimaryOffer_tokenPrimaryOffer: 'TransactionsPrimaryOffer_tokenPrimaryOffer' as const,
    AnyPlayerDescription_anyPlayer: 'AnyPlayerDescription_anyPlayer' as const,
    CardsChangedOffer_tokenOffer: 'CardsChangedOffer_tokenOffer' as const,
    CardsChanged_tokenOffer: 'CardsChanged_tokenOffer' as const,
    CardsChanged_user: 'CardsChanged_user' as const,
    CounteredOffer_publicUserInfoInterface: 'CounteredOffer_publicUserInfoInterface' as const,
    CounterpartUser_publicUserInfoInterface: 'CounterpartUser_publicUserInfoInterface' as const,
    CounterpartUser_tokenOffer: 'CounterpartUser_tokenOffer' as const,
    MySorareDirectOfferBody_anyCard: 'MySorareDirectOfferBody_anyCard' as const,
    MySorareDirectOfferBody_tokenOffer: 'MySorareDirectOfferBody_tokenOffer' as const,
    MySorareDirectOfferBody_publicUserInfoInterface: 'MySorareDirectOfferBody_publicUserInfoInterface' as const,
    AcceptOfferDialog_tokenOffer: 'AcceptOfferDialog_tokenOffer' as const,
    MySorareDirectOfferStatus_tokenOffer: 'MySorareDirectOfferStatus_tokenOffer' as const,
    useCheckOfferFairness_tokenOffer: 'useCheckOfferFairness_tokenOffer' as const,
    OfferSummary_tokenOffer: 'OfferSummary_tokenOffer' as const,
    RejectionReason_tokenOffer: 'RejectionReason_tokenOffer' as const,
    RejectionReason_publicUserInfoInterface: 'RejectionReason_publicUserInfoInterface' as const,
    MySorareDirectOffer_tokenOffer: 'MySorareDirectOffer_tokenOffer' as const,
    FollowDescription_club: 'FollowDescription_club' as const,
    FollowDescription_country: 'FollowDescription_country' as const,
    FollowDescription_anyPlayer: 'FollowDescription_anyPlayer' as const,
    Follow_subscription: 'Follow_subscription' as const,
    MySorarePrimaryOffer_primaryOffer: 'MySorarePrimaryOffer_primaryOffer' as const,
    Subscriptions_subscription: 'Subscriptions_subscription' as const,
    ShopAllCards_competition: 'ShopAllCards_competition' as const,
    AvailableForTrade_anyCard: 'AvailableForTrade_anyCard' as const,
    CancelSalePopin_anyCard: 'CancelSalePopin_anyCard' as const,
    CurrentOwner_anyCard: 'CurrentOwner_anyCard' as const,
    DelayedSettlementHelpers_anyCard: 'DelayedSettlementHelpers_anyCard' as const,
    OfferDealSummary_anyCard: 'OfferDealSummary_anyCard' as const,
    OfferDialog_anyCard: 'OfferDialog_anyCard' as const,
    OwnerAccount_account: 'OwnerAccount_account' as const,
    SellCard_anyCard: 'SellCard_anyCard' as const,
    SetupMinimumPriceDialog_anyCard: 'SetupMinimumPriceDialog_anyCard' as const,
    SingleSaleOffer_anyCard: 'SingleSaleOffer_anyCard' as const,
    AnyPlayerFifteenStatsIcon_anyPlayer: 'AnyPlayerFifteenStatsIcon_anyPlayer' as const,
    AnyPlayerStatsIcon_anyPlayer: 'AnyPlayerStatsIcon_anyPlayer' as const,
    CalendarTooltip_anyPlayer: 'CalendarTooltip_anyPlayer' as const,
    TooltipGame_anyGame: 'TooltipGame_anyGame' as const,
    AnyPlayerUpcomingGames_anyPlayer: 'AnyPlayerUpcomingGames_anyPlayer' as const,
    AveragePlayerScores_anyPlayer: 'AveragePlayerScores_anyPlayer' as const,
    CompletedTransactionRow_tokenPrice: 'CompletedTransactionRow_tokenPrice' as const,
    CompletedTransactions_tokenPrice: 'CompletedTransactions_tokenPrice' as const,
    Grade_playerGameScoreProjection: 'Grade_playerGameScoreProjection' as const,
    InjuryCornerBadge_anyPlayerInterface: 'InjuryCornerBadge_anyPlayerInterface' as const,
    InjuryTag_anyPlayer: 'InjuryTag_anyPlayer' as const,
    LastOwnedCards_anyPlayer: 'LastOwnedCards_anyPlayer' as const,
    LastOwnedCardsBySo5Competition_cards: 'LastOwnedCardsBySo5Competition_cards' as const,
    LastOwnedCardsBySo5Competition_so5Competition: 'LastOwnedCardsBySo5Competition_so5Competition' as const,
    OwnedCardRow_anyCard: 'OwnedCardRow_anyCard' as const,
    ScoresBreakdown_averageLastScore: 'ScoresBreakdown_averageLastScore' as const,
    ScoresCard_averageLastScore: 'ScoresCard_averageLastScore' as const,
    Stats_averageLastScore: 'Stats_averageLastScore' as const,
    PerformanceBlocks_anyPlayer: 'PerformanceBlocks_anyPlayer' as const,
    PlayerMarketDrawerAuctions_anyCard: 'PlayerMarketDrawerAuctions_anyCard' as const,
    useSortSecondaryOfferSlugs_anyCard: 'useSortSecondaryOfferSlugs_anyCard' as const,
    PlayerMarketDrawerManagerSales_anyCard: 'PlayerMarketDrawerManagerSales_anyCard' as const,
    useManagerSalesTag_anyCard: 'useManagerSalesTag_anyCard' as const,
    LazyAllLastOwnedCardsQuery_anyCard: 'LazyAllLastOwnedCardsQuery_anyCard' as const,
    AnyCardPriceHistory_anyCard: 'AnyCardPriceHistory_anyCard' as const,
    PriceGraph_tokenPrice: 'PriceGraph_tokenPrice' as const,
    PriceHistoryTooltip_anyCard: 'PriceHistoryTooltip_anyCard' as const,
    TransactionLabel_tokenDeal: 'TransactionLabel_tokenDeal' as const,
    AvailablePrimaryBuyForAPlayer_anyCard: 'AvailablePrimaryBuyForAPlayer_anyCard' as const,
    BuyPrimaryBuyConfirmation_anyCard: 'BuyPrimaryBuyConfirmation_anyCard' as const,
    BuyPrimaryBuyConfirmation_anyReward: 'BuyPrimaryBuyConfirmation_anyReward' as const,
    OpenPrimaryBuy_anyCard: 'OpenPrimaryBuy_anyCard' as const,
    PriceLockedRibbon_primaryOffer: 'PriceLockedRibbon_primaryOffer' as const,
    PrimaryOfferPrice_primaryOffer: 'PrimaryOfferPrice_primaryOffer' as const,
    MobileAppPrimaryOfferBuyFieldWrapper_anyCard: 'MobileAppPrimaryOfferBuyFieldWrapper_anyCard' as const,
    WebPrimaryOfferBuyFieldWrapper_anyCard: 'WebPrimaryOfferBuyFieldWrapper_anyCard' as const,
    PrimaryOfferBuyFieldWrapper_anyCard: 'PrimaryOfferBuyFieldWrapper_anyCard' as const,
    PrimaryBuyBuyField_anyCard: 'PrimaryBuyBuyField_anyCard' as const,
    PrimaryBuyDetails_anyCard: 'PrimaryBuyDetails_anyCard' as const,
    PrimaryOfferStockCounter_primaryOffer: 'PrimaryOfferStockCounter_primaryOffer' as const,
    PrimaryOfferTokensPreview_anyCard: 'PrimaryOfferTokensPreview_anyCard' as const,
    EndedSaleDetails_anyCard: 'EndedSaleDetails_anyCard' as const,
    EndedSaleDetails_offer: 'EndedSaleDetails_offer' as const,
    LiveSaleDetails_anyCard: 'LiveSaleDetails_anyCard' as const,
    LiveSaleDetails_offer: 'LiveSaleDetails_offer' as const,
    SalePriceFeesTooltip_offer: 'SalePriceFeesTooltip_offer' as const,
    SalePrice_offer: 'SalePrice_offer' as const,
    SaleWinner_offer: 'SaleWinner_offer' as const,
    SaleDetails_anyCard: 'SaleDetails_anyCard' as const,
    SaleDetails_offer: 'SaleDetails_offer' as const,
    Sale_offer: 'Sale_offer' as const,
    RarityVaultBanner_boostLevel: 'RarityVaultBanner_boostLevel' as const,
    RarityVaultBanner_sealingConfig: 'RarityVaultBanner_sealingConfig' as const,
    RarityVaultBanner_rewardBoost: 'RarityVaultBanner_rewardBoost' as const,
    RarityVaultHowItWorks_sealingConfig: 'RarityVaultHowItWorks_sealingConfig' as const,
    RarityVaultHowItWorksDialog_sealingConfig: 'RarityVaultHowItWorksDialog_sealingConfig' as const,
    SealCardsDialog_anyCard: 'SealCardsDialog_anyCard' as const,
    SealCardsDialog_sealingConfig: 'SealCardsDialog_sealingConfig' as const,
    SealCardsDialog_rewardBoost: 'SealCardsDialog_rewardBoost' as const,
    SealingRecap_anyCard: 'SealingRecap_anyCard' as const,
    UnsealCardDialog_anyCard: 'UnsealCardDialog_anyCard' as const,
    UnsealingAnimation_anyCard: 'UnsealingAnimation_anyCard' as const,
    BackendPaginatedSearchPlayerTable_AnyPlayerInterface: 'BackendPaginatedSearchPlayerTable_AnyPlayerInterface' as const,
    PriceCell_commonPlayer: 'PriceCell_commonPlayer' as const,
    PriceCell_anyPlayer: 'PriceCell_anyPlayer' as const,
    AnyStatsIconCell_anyPlayer: 'AnyStatsIconCell_anyPlayer' as const,
    CommonPlayerMetas_anyPlayer: 'CommonPlayerMetas_anyPlayer' as const,
    GradeCell_playerGameScoreProjection: 'GradeCell_playerGameScoreProjection' as const,
    SearchPlayerCellActions_anyPlayer: 'SearchPlayerCellActions_anyPlayer' as const,
    SearchPlayerCell_anyPlayer: 'SearchPlayerCell_anyPlayer' as const,
    SearchPlayerRow_anyPlayer: 'SearchPlayerRow_anyPlayer' as const,
    AverageBenchObjectScoreCell_composeTeamBenchObjectInterface: 'AverageBenchObjectScoreCell_composeTeamBenchObjectInterface' as const,
    AveragePlayerScoreCell_anyPlayer: 'AveragePlayerScoreCell_anyPlayer' as const,
    BreakdownPlayerScoreCell_anyPlayer: 'BreakdownPlayerScoreCell_anyPlayer' as const,
    ProjectionCell_anyPlayer: 'ProjectionCell_anyPlayer' as const,
    ProjectionGradeCell_anyPlayer: 'ProjectionGradeCell_anyPlayer' as const,
    StatCell_anyPlayer: 'StatCell_anyPlayer' as const,
    WithPlayerAppearancesCell_anyPlayer: 'WithPlayerAppearancesCell_anyPlayer' as const,
    SearchPlayerStatsCells_anyPlayer: 'SearchPlayerStatsCells_anyPlayer' as const,
    BackendSearchPlayerTable_AnyPlayerInterface: 'BackendSearchPlayerTable_AnyPlayerInterface' as const,
    StartingPriceCell_anyPlayer: 'StartingPriceCell_anyPlayer' as const,
    CardPreview_anyCard: 'CardPreview_anyCard' as const,
    CardDescription_anyCard: 'CardDescription_anyCard' as const,
    FlexCard_anyCard: 'FlexCard_anyCard' as const,
    Ownership_tokenOwner: 'Ownership_tokenOwner' as const,
    OwnershipHistory_anyCard: 'OwnershipHistory_anyCard' as const,
    PlayerDrawerTokenActions_anyCard: 'PlayerDrawerTokenActions_anyCard' as const,
    PlayerDrawerTokenDetails_anyCard: 'PlayerDrawerTokenDetails_anyCard' as const,
    MarketCreditCornerBadge_anyCard: 'MarketCreditCornerBadge_anyCard' as const,
    PlayerDrawerToken_anyCard: 'PlayerDrawerToken_anyCard' as const,
    StackedToken_anyCard: 'StackedToken_anyCard' as const,
    TokenBoostDetails_anyCard: 'TokenBoostDetails_anyCard' as const,
    TokenContent_anyCard: 'TokenContent_anyCard' as const,
    TokenOfferDetails_anyCard: 'TokenOfferDetails_anyCard' as const,
    TokenDetails_anyCard: 'TokenDetails_anyCard' as const,
    TokenImg_anyCard: 'TokenImg_anyCard' as const,
    TokenLoyaltyBoost_anyCard: 'TokenLoyaltyBoost_anyCard' as const,
    TokenProperties_anyCard: 'TokenProperties_anyCard' as const,
    TokenRoot_anyCard: 'TokenRoot_anyCard' as const,
    TokenSealingFooter_anyCard: 'TokenSealingFooter_anyCard' as const,
    Token_anyCard: 'Token_anyCard' as const,
    TokenName_anyCard: 'TokenName_anyCard' as const,
    TokenNameCancelSalePopin_anyCard: 'TokenNameCancelSalePopin_anyCard' as const,
    TokenOwnerPrice_tokenOwner: 'TokenOwnerPrice_tokenOwner' as const,
    TokenOwnerTransfer_owner: 'TokenOwnerTransfer_owner' as const,
    BlockchainInfo_anyCard: 'BlockchainInfo_anyCard' as const,
    TokenId_anyCard: 'TokenId_anyCard' as const,
    TokenStatsIcon_anyCard: 'TokenStatsIcon_anyCard' as const,
    getSo5LineupUrl_so5Lineup: 'getSo5LineupUrl_so5Lineup' as const,
    UsedInLineupValidator_anyCard: 'UsedInLineupValidator_anyCard' as const,
    TokenTransferValidator_anyCard: 'TokenTransferValidator_anyCard' as const,
    TokenUnsealButton_anyCard: 'TokenUnsealButton_anyCard' as const,
    CompletedTransactionRow_deal: 'CompletedTransactionRow_deal' as const,
    CompletedTransactions_deal: 'CompletedTransactions_deal' as const,
    SmallUser_user: 'SmallUser_user' as const,
    SmallUser_anonymousUser: 'SmallUser_anonymousUser' as const,
    EthereumCard_anyCard: 'EthereumCard_anyCard' as const,
    AddToWatchlist_anyPlayer: 'AddToWatchlist_anyPlayer' as const,
    AddToWatchlistButton_anyPlayer: 'AddToWatchlistButton_anyPlayer' as const,
    DestroyWatchlistButton_watchlist: 'DestroyWatchlistButton_watchlist' as const,
    DestroyWatchlistDialog_watchlist: 'DestroyWatchlistDialog_watchlist' as const,
    EditWatchlistButton_watchlist: 'EditWatchlistButton_watchlist' as const,
    AddWatchlistToCartConfirmDialog_anyCard: 'AddWatchlistToCartConfirmDialog_anyCard' as const,
    ManagePlayerInWatchlist_anyPlayer: 'ManagePlayerInWatchlist_anyPlayer' as const,
    PublicWatchlists_watchlist: 'PublicWatchlists_watchlist' as const,
    RemoveFromWatchlistButton_anyPlayer: 'RemoveFromWatchlistButton_anyPlayer' as const,
    ShareWatchlistButton_watchlist: 'ShareWatchlistButton_watchlist' as const,
    SorareWatchlistBanner_watchlist: 'SorareWatchlistBanner_watchlist' as const,
    UpsertWatchlistDialog_watchlist: 'UpsertWatchlistDialog_watchlist' as const,
    WatchlistHeader_watchlist: 'WatchlistHeader_watchlist' as const,
    ManageWatchlist_watchlist: 'ManageWatchlist_watchlist' as const,
    WatchlistItem_watchlist: 'WatchlistItem_watchlist' as const,
    WatchlistMetas_watchlist: 'WatchlistMetas_watchlist' as const,
    WatchlistPage_watchlist: 'WatchlistPage_watchlist' as const,
    CurrentMarketplaceUser_currentUser: 'CurrentMarketplaceUser_currentUser' as const,
    SingleSaleOfferContext_anyCard: 'SingleSaleOfferContext_anyCard' as const,
    UseBestBidBelongsToUser_bestBid: 'UseBestBidBelongsToUser_bestBid' as const,
    useBidWithWallet_auction: 'useBidWithWallet_auction' as const,
    UsePollAuction_auction: 'UsePollAuction_auction' as const,
    useStopAutoBid_bid: 'useStopAutoBid_bid' as const,
    useCartEvents_anyCard: 'useCartEvents_anyCard' as const,
    useClickBidEvent_tokenAuction: 'useClickBidEvent_tokenAuction' as const,
    useClickBundleEvent_anyCard: 'useClickBundleEvent_anyCard' as const,
    useClickBuyEvent_anyCard: 'useClickBuyEvent_anyCard' as const,
    useClickCardEvent_anyCard: 'useClickCardEvent_anyCard' as const,
    useAcceptOffer_anyCard: 'useAcceptOffer_anyCard' as const,
    useApproveMigrator_anyCard: 'useApproveMigrator_anyCard' as const,
    useCannotBuy_anyCard: 'useCannotBuy_anyCard' as const,
    useCannotSell_anyCard: 'useCannotSell_anyCard' as const,
    useCannotSettleInCrypto_anyCard: 'useCannotSettleInCrypto_anyCard' as const,
    useCannotSettleInFiat_anyCard: 'useCannotSettleInFiat_anyCard' as const,
    useCreateDirectOffer_anyCard: 'useCreateDirectOffer_anyCard' as const,
    useCreateSingleSaleOffer_anyCard: 'useCreateSingleSaleOffer_anyCard' as const,
    useGetAuctionDetails_auction: 'useGetAuctionDetails_auction' as const,
    useGetTokenSingleSaleDetails_anyCard: 'useGetTokenSingleSaleDetails_anyCard' as const,
    useMigrateCards_anyCard: 'useMigrateCards_anyCard' as const,
    useStateOffer_anyCard: 'useStateOffer_anyCard' as const,
    useSeriesDailyClaim_task: 'useSeriesDailyClaim_task' as const,
    SteppedPrimaryOffer_primaryOffer: 'SteppedPrimaryOffer_primaryOffer' as const,
    useAddCollectionToCart_userCardCollection: 'useAddCollectionToCart_userCardCollection' as const,
    useAddCollectionToCart_cardCollection: 'useAddCollectionToCart_cardCollection' as const,
    useAddMultipleCardsToCart_anyCard: 'useAddMultipleCardsToCart_anyCard' as const,
    useFilterLivePrimaryBuys_anyCard: 'useFilterLivePrimaryBuys_anyCard' as const,
    useIsPrimaryBuyLive_anyCard: 'useIsPrimaryBuyLive_anyCard' as const,
    useCardsSearchClient_searchCardFacetValues: 'useCardsSearchClient_searchCardFacetValues' as const,
    useCardsSearchClient_searchCards: 'useCardsSearchClient_searchCards' as const,
    useDefaultPrintablePlayersSearchClient_searchPrintablePlayers: 'useDefaultPrintablePlayersSearchClient_searchPrintablePlayers' as const,
    usePrintablePlayersSearchClient_searchPrintablePlayers: 'usePrintablePlayersSearchClient_searchPrintablePlayers' as const,
    usePrintablePlayersSearchClient_searchFacetValue: 'usePrintablePlayersSearchClient_searchFacetValue' as const,
    useOwnerAccount_account: 'useOwnerAccount_account' as const,
    useCart_anyCard: 'useCart_anyCard' as const,
    useCart_cartItem: 'useCart_cartItem' as const,
    useCart_cart: 'useCart_cart' as const,
    useGetPriceHistory_anyCard: 'useGetPriceHistory_anyCard' as const,
    useHasFollowedPlayers_currentUser: 'useHasFollowedPlayers_currentUser' as const,
    useIsBoostAffordable_anyCard: 'useIsBoostAffordable_anyCard' as const,
    useIsCardDroppable_anyCard: 'useIsCardDroppable_anyCard' as const,
    useLevelUpCards_appearanceInterface: 'useLevelUpCards_appearanceInterface' as const,
    useMarketFeesHelperStatus_anyCard: 'useMarketFeesHelperStatus_anyCard' as const,
    useAuctionCurrentPrice_auction: 'useAuctionCurrentPrice_auction' as const,
    auctionMinNextBid_auction: 'auctionMinNextBid_auction' as const,
    getLeagueAvatar_competition: 'getLeagueAvatar_competition' as const,
    getLeagueAvatar_so5Competition: 'getLeagueAvatar_so5Competition' as const,
    getLeagueBackgroundUrl_competition: 'getLeagueBackgroundUrl_competition' as const,
    getLeagueBackgroundUrl_so5Competition: 'getLeagueBackgroundUrl_so5Competition' as const,
    isAnnouncedStarter_playerGameScore: 'isAnnouncedStarter_playerGameScore' as const,
    isAnnouncedSubstitute_playerGameScore: 'isAnnouncedSubstitute_playerGameScore' as const,
    isSubstitutedIn_playerGameScore: 'isSubstitutedIn_playerGameScore' as const,
    isSubstitutedOut_playerGameScore: 'isSubstitutedOut_playerGameScore' as const,
    SmallUserForSubscription_user: 'SmallUserForSubscription_user' as const,
    BidderFragment: 'BidderFragment' as const,
    CardFragment: 'CardFragment' as const,
    TokenAuctionUpdateFragment: 'TokenAuctionUpdateFragment' as const,
    OfferSideFragment: 'OfferSideFragment' as const,
    TokenOfferUpdateFragment: 'TokenOfferUpdateFragment' as const,
    PrimaryOfferUpdateFragment: 'PrimaryOfferUpdateFragment' as const,
    getTransactionType_tokenDeal: 'getTransactionType_tokenDeal' as const,
    findRewardThresholdColor_probabilisticBundleSlotConfig: 'findRewardThresholdColor_probabilisticBundleSlotConfig' as const,
    BackendCardResultsFromGraphQL_card: 'BackendCardResultsFromGraphQL_card' as const,
    CardPreviewGrid_card: 'CardPreviewGrid_card' as const,
    DeckEditorDialog_deck: 'DeckEditorDialog_deck' as const,
    DeckEditorDialog_anyCard: 'DeckEditorDialog_anyCard' as const,
    BackendPlayerSearchLayout_AnyPlayerInterface: 'BackendPlayerSearchLayout_AnyPlayerInterface' as const,
    DomesticLeagueRanking_anyGameInterface: 'DomesticLeagueRanking_anyGameInterface' as const,
    DomesticLeagueRanking_teamInterface: 'DomesticLeagueRanking_teamInterface' as const,
    GameStatusLabel_anyGameInterface: 'GameStatusLabel_anyGameInterface' as const,
    HandInfoChip_BaseballPlayer: 'HandInfoChip_BaseballPlayer' as const,
    BuyingFloorPricePlayerDetails_anyPlayer: 'BuyingFloorPricePlayerDetails_anyPlayer' as const,
    BuyingPlayerDetailsButton_anyPlayer: 'BuyingPlayerDetailsButton_anyPlayer' as const,
    PlayerInjuryReport_anyPlayer: 'PlayerInjuryReport_anyPlayer' as const,
    PlayerNewsUpdates_anyPlayer: 'PlayerNewsUpdates_anyPlayer' as const,
    PlayerProperties_anyPlayer: 'PlayerProperties_anyPlayer' as const,
    PlayerProperties_anyCard: 'PlayerProperties_anyCard' as const,
    PlayerRotowireStatsProjection_PlayerGameScoreInterface: 'PlayerRotowireStatsProjection_PlayerGameScoreInterface' as const,
    PlayerRotowireStatsProjection_AnyPlayerInterface: 'PlayerRotowireStatsProjection_AnyPlayerInterface' as const,
    PlayerStats_anyPlayerInterface: 'PlayerStats_anyPlayerInterface' as const,
    PlayerStats_anyCardInterface: 'PlayerStats_anyCardInterface' as const,
    PlayerStats_playerGameScoreInterface: 'PlayerStats_playerGameScoreInterface' as const,
    PlayerUnavailabilityPanel_anyPlayer: 'PlayerUnavailabilityPanel_anyPlayer' as const,
    PlayerUpcomingGames_game: 'PlayerUpcomingGames_game' as const,
    PlayerUpcomingGames_teamInterface: 'PlayerUpcomingGames_teamInterface' as const,
    PlayerDetails_playerGameScoreInterface: 'PlayerDetails_playerGameScoreInterface' as const,
    PlayerUnavailabilityBadge_suspension: 'PlayerUnavailabilityBadge_suspension' as const,
    PlayerUnavailabilityBadge_injury: 'PlayerUnavailabilityBadge_injury' as const,
    useGetSuspensionsAndInjuries_playerGameScoreInterface: 'useGetSuspensionsAndInjuries_playerGameScoreInterface' as const,
    useGetSuspensionsAndInjuries_anyPlayer: 'useGetSuspensionsAndInjuries_anyPlayer' as const,
    BriefGame_teamInterface: 'BriefGame_teamInterface' as const,
    BriefGame_anyGameInterface: 'BriefGame_anyGameInterface' as const,
    BriefPlayerScore_anyCardInterface: 'BriefPlayerScore_anyCardInterface' as const,
    BriefPlayerScore_anyPlayerInterface: 'BriefPlayerScore_anyPlayerInterface' as const,
    BriefPlayerScore_playerGameScoreInterface: 'BriefPlayerScore_playerGameScoreInterface' as const,
    InlineGame_game: 'InlineGame_game' as const,
    FixtureBarProjections_playerGameScoreInterface: 'FixtureBarProjections_playerGameScoreInterface' as const,
    FixtureBarProjections_anyPlayer: 'FixtureBarProjections_anyPlayer' as const,
    FixtureChart_playerGameScoreInterface: 'FixtureChart_playerGameScoreInterface' as const,
    FixtureChart_anyPlayer: 'FixtureChart_anyPlayer' as const,
    FixtureChart_anyCard: 'FixtureChart_anyCard' as const,
    useGetFiltersOptions_playerGameScoreInterface: 'useGetFiltersOptions_playerGameScoreInterface' as const,
    useGetFiltersOptions_anyPlayer: 'useGetFiltersOptions_anyPlayer' as const,
    useGetFiltersOptions_anyCard: 'useGetFiltersOptions_anyCard' as const,
    LazyFixtureChart_anyCard: 'LazyFixtureChart_anyCard' as const,
    CategoryHeader_playerGameScoreInterface: 'CategoryHeader_playerGameScoreInterface' as const,
    CategoryStat_statScore: 'CategoryStat_statScore' as const,
    CategoryStat_playerGameScoreInterface: 'CategoryStat_playerGameScoreInterface' as const,
    Category_playerGameScoreInterface: 'Category_playerGameScoreInterface' as const,
    Category_statScore: 'Category_statScore' as const,
    DecisiveScore_playerGameScoreInterface: 'DecisiveScore_playerGameScoreInterface' as const,
    PlayerGameScoreStats_playerGameScoreInterface: 'PlayerGameScoreStats_playerGameScoreInterface' as const,
    PlayerGameScoreStatusIcon_playerGameScoreInterface: 'PlayerGameScoreStatusIcon_playerGameScoreInterface' as const,
    usePerformanceFilters_anyPlayer: 'usePerformanceFilters_anyPlayer' as const,
    usePerformanceFilters_anyCard: 'usePerformanceFilters_anyCard' as const,
    getDecisiveActions_playerGameScoreInterface: 'getDecisiveActions_playerGameScoreInterface' as const,
    playoffsGames: 'playoffsGames' as const,
    NBABasicBenchCard_composeTeamBenchObjectInterface: 'NBABasicBenchCard_composeTeamBenchObjectInterface' as const,
    NBABasicBenchCard_appearanceRule: 'NBABasicBenchCard_appearanceRule' as const,
    NBABasicFilters_so5Leaderboard: 'NBABasicFilters_so5Leaderboard' as const,
    NBABasicMarketCard_anyCardInterface: 'NBABasicMarketCard_anyCardInterface' as const,
    NBABasicMarketCard_appearanceRule: 'NBABasicMarketCard_appearanceRule' as const,
    NBABenchObjectFooter_composeTeamBenchObjectInterface: 'NBABenchObjectFooter_composeTeamBenchObjectInterface' as const,
    NBACompose_sharedBenchObjectFragment_composeTeamBenchObjectInterface: 'NBACompose_sharedBenchObjectFragment_composeTeamBenchObjectInterface' as const,
    NBACompose_composeTeamBenchObjectInterface: 'NBACompose_composeTeamBenchObjectInterface' as const,
    NBACompose_anyPlayerInterface: 'NBACompose_anyPlayerInterface' as const,
    NBACompose_so5Leaderboard: 'NBACompose_so5Leaderboard' as const,
    NBACompose_so5Lineup: 'NBACompose_so5Lineup' as const,
    NBACompose_managerTeam: 'NBACompose_managerTeam' as const,
    NBAFieldCard_composeTeamBenchObjectInterface: 'NBAFieldCard_composeTeamBenchObjectInterface' as const,
    NBAFieldCard_appearanceRule: 'NBAFieldCard_appearanceRule' as const,
    GameBoxScoreRow_playerGameScoreInterface: 'GameBoxScoreRow_playerGameScoreInterface' as const,
    GameBoxScoreGame_playerGameScoreInterface: 'GameBoxScoreGame_playerGameScoreInterface' as const,
    GameBoxScoreGame_anyGameInterface: 'GameBoxScoreGame_anyGameInterface' as const,
    GameBoxScore_anyGameInterface: 'GameBoxScore_anyGameInterface' as const,
    GameHeader_anyGame: 'GameHeader_anyGame' as const,
    GameTime_anyGame: 'GameTime_anyGame' as const,
    LiveCardsInLineup_so5Fixture: 'LiveCardsInLineup_so5Fixture' as const,
    LiveCardsInLineup_basketballPlayerGameScore: 'LiveCardsInLineup_basketballPlayerGameScore' as const,
    LiveCardsInLineup_anyCard: 'LiveCardsInLineup_anyCard' as const,
    LiveCardsInLineup_so5Appearance: 'LiveCardsInLineup_so5Appearance' as const,
    TeamPlayersStats_basketballPlayerGameScore: 'TeamPlayersStats_basketballPlayerGameScore' as const,
    TeamPlayersStats_team: 'TeamPlayersStats_team' as const,
    TeamPlayersStats_anyCard: 'TeamPlayersStats_anyCard' as const,
    TeamPlayersStats_so5Appearance: 'TeamPlayersStats_so5Appearance' as const,
    TopFieldPlayers_basketballPlayerGameScore: 'TopFieldPlayers_basketballPlayerGameScore' as const,
    TopFieldPlayers_anyCard: 'TopFieldPlayers_anyCard' as const,
    TopFieldPlayers_so5Appearance: 'TopFieldPlayers_so5Appearance' as const,
    LiveGameView_basketballPlayerGameScore: 'LiveGameView_basketballPlayerGameScore' as const,
    LiveGameView_anyGame: 'LiveGameView_anyGame' as const,
    LiveGameView_so5Fixture: 'LiveGameView_so5Fixture' as const,
    LiveGameView_anyCard: 'LiveGameView_anyCard' as const,
    FeaturedPlayersOutperformers_basketballPlayerGameScore: 'FeaturedPlayersOutperformers_basketballPlayerGameScore' as const,
    FeaturedPlayersOutperformers_team: 'FeaturedPlayersOutperformers_team' as const,
    PastGameView_basketballPlayerGameScore: 'PastGameView_basketballPlayerGameScore' as const,
    PastGameView_anyGame: 'PastGameView_anyGame' as const,
    PastGameView_so5Fixture: 'PastGameView_so5Fixture' as const,
    PastGameView_anyCard: 'PastGameView_anyCard' as const,
    PlayerInFixtureLinkBox_anyCard: 'PlayerInFixtureLinkBox_anyCard' as const,
    PlayerInLineupLinkBox_so5Fixture: 'PlayerInLineupLinkBox_so5Fixture' as const,
    PlayerInLineupLinkBox_so5Appearance: 'PlayerInLineupLinkBox_so5Appearance' as const,
    TeamPlayers_anyPlayer: 'TeamPlayers_anyPlayer' as const,
    TeamPlayers_team: 'TeamPlayers_team' as const,
    TeamPlayers_so5Fixture: 'TeamPlayers_so5Fixture' as const,
    TeamPlayers_so5Appearance: 'TeamPlayers_so5Appearance' as const,
    TeamPlayers_anyCard: 'TeamPlayers_anyCard' as const,
    UpcomingGameView_anyGame: 'UpcomingGameView_anyGame' as const,
    UpcomingGameView_anyPlayer: 'UpcomingGameView_anyPlayer' as const,
    UpcomingGameView_so5Fixture: 'UpcomingGameView_so5Fixture' as const,
    UpcomingGameView_anyCard: 'UpcomingGameView_anyCard' as const,
    GameView_basketballPlayerGameScore: 'GameView_basketballPlayerGameScore' as const,
    GameView_anyGame: 'GameView_anyGame' as const,
    GameView_anyPlayer: 'GameView_anyPlayer' as const,
    GameView_so5Fixture: 'GameView_so5Fixture' as const,
    GameView_anyCard: 'GameView_anyCard' as const,
    PlayerCardScore_so5Fixture: 'PlayerCardScore_so5Fixture' as const,
    PlayerCardScore_so5Appearance: 'PlayerCardScore_so5Appearance' as const,
    LivePlayerCardScore_anyPlayer: 'LivePlayerCardScore_anyPlayer' as const,
    LivePlayerCardScore_anyGame: 'LivePlayerCardScore_anyGame' as const,
    UpcomingPlayerCardScore_anyPlayer: 'UpcomingPlayerCardScore_anyPlayer' as const,
    UpcomingPlayerCardScore_anyGame: 'UpcomingPlayerCardScore_anyGame' as const,
    NBATeamSearch_team: 'NBATeamSearch_team' as const,
    ScoutingCenterGameIdStatsPage_teamGameStatsInterface: 'ScoutingCenterGameIdStatsPage_teamGameStatsInterface' as const,
    ScoutingCenterGameIdStatsPage_anyGameInterface: 'ScoutingCenterGameIdStatsPage_anyGameInterface' as const,
    FootballClubs_club: 'FootballClubs_club' as const,
    PartnersList_club: 'PartnersList_club' as const,
    contentCreatorsPage_anyPlayerInterface: 'contentCreatorsPage_anyPlayerInterface' as const
  }
}